// src/AppRoutes.tsx
import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';

// Pages
// Juin 2026 — Fiche article (vue 360°)
// Mai 2026 — Demandes de sortie d'articles (multi-motifs)
// Mai 2026 — Parc compteurs (registre EEC)
// Mai 2026 — Parc scellés (registre EEC)
// Juillet 2026 — Parcs transformateurs & poteaux (registre EEC)
// Juillet 2026 — Parc disjoncteurs (registre EEC)
// Mai 2026 — Chantier GG : module Devis CRM

// Composants pour les décaissements
import {
  Plug, ClipboardList, Users as UsersIcon, FolderOpen, MapPin as MapPinIcon,
  FilePlus, Layers, AlertTriangle as AlertTriIcon,
  Briefcase, Calendar as CalendarIcon, CreditCard as CreditCardIcon, FileCheck,
  GraduationCap, BookOpen, MessageSquare, Wallet as WalletIcon,
  Scale, // chantier V — portail cabinet juridique
} from 'lucide-react';
import { BRAND_NAME } from './config/env';
// Mai 2026 — Chantier JJ-1 : tableau de bord RH (TDB 2017)
// Mai 2026 — Chantier KK-2 : paiement salaires espèces caisse
// Mai 2026 — Chantier MM-2 : réconciliation bancaire admin
import VirementsBanque from './components/RH/Paie/VirementsBanque';
import OffresEmploi from './components/RH/Recrutement/OffresEmploi';
// Module Dossier Médical
// Lot 3 — Module Évaluation / Performance (RH / collaborateur / manager)
// GPEC — Fiches de postes, Matrice compétences, Profils de carrière, Succession, Feedback 360°, Mobilité
// Self Service — Mes collaborateurs
// Self Service — Mes enquêtes
// Module Sécurité — Politique de sécurité (mot de passe, connexion, 2FA)
// Lot 3 — Module Évaluation / Performance (RH / collaborateur / manager)
// GPEC — Fiches de postes, Matrice compétences, Profils de carrière, Succession, Feedback 360°, Mobilité
// Self Service — Mes collaborateurs
// Module Sécurité — Politique de sécurité (mot de passe, connexion, 2FA)
// MM-112 — Vue 360 utility (séparée de FicheClient360 CRM)
// MM-118 — Page publique de confirmation du droit d'entrée par le client
// Juillet 2026 — Formulaire public AGEE + base de connaissances publique (sans auth)
// MM-119 — Page publique de paiement du droit d'entrée (lien email)
// QR documents — vérification publique + paiement facture impayée
// MM-117b — Page admin paramétrage barèmes frais d'entrée (BT/MT/Eau)
// CRM — listes globales branchements & abonnements
// Mai 2026 — MM-16 : Mes tâches workflow
// Mai 2026 — Vitrine publique dédiée aux cabinets juridiques (style Légis-style)
// Mai 2026 — Espace client interne cabinet (sidebar navy + or)
// Mai 2026 — Wrappers fullscreen pour login/inscription cabinet (sans header parasite)
// Mai 2026 — Login premium dédié cabinets juridiques (style Légis-style)
// Mai 2026 — MM-11 : portail premium pour opérateurs de service
// (ELECTRICITE, EAU, INTERNET, TELEPHONIE) — style agence en ligne EEC
import EtatsCaisse from './pages/EtatsCaisse';
import Billetage from './pages/Billetage';

// Module Vie Scolaire
// Module Consolidation Groupe — états financiers consolidés multi-entités
// Module Édition (report-builder) — constructeur d'éditions dynamiques
// Admin des niveaux d'organisation (échelons DG→DC→DR→Agence) — consolidation hiérarchique
// Module Électricité — Consignation réseau (attestations + diffusion)
// MM-33 : page admin Templates de formulaires d'étape
// MM-28 : page admin Demandes client (catalogue par entité)
// MM-29 : catalogue public des démarches (portail abonné)
// MM-52 — Page de saisie portail abonné qui démarre le workflow réel
// Réclamation publique (anonyme) depuis la vitrine publique d'une entité
// Mode Couture — page client publique (self-service estimation + paiement à l'usage)
// Module Demandes de Remboursement (électricité EDG)
// MM-124 — Saisie CR Étude Terrain (étape cr_activite du workflow EEC)
// EEC 5.17 — Saisie CR d'Intervention (étape cr_intervention du workflow EEC)
// EEC MT — Saisie CR Consignation / Déconsignation (étapes cr_consignation / cr_deconsignation)
// Juillet 2026 — Vue d'ensemble AGEE (tableau de bord spécialisé évaluations environnementales)
// Vitrine patronat — pages profondes publiques + back-office de contenu
import { IS_CGEGUI, IS_PATRONAT } from './data/tenantFlag';
import { loginPathForBuild } from './utils/postLogout';
// Vitrine patronat — pages profondes publiques + back-office de contenu
// Sprint EEC Congo — FAC-3 : paramétrage des tarifs électriques
import {
  PortailFondsSituation, PortailFondsVersements, PortailFondsDocuments,
} from './pages/PortailPublic/PortailFondsEpargnePages';
// Relance EDG — référentiels data-driven (usages, catégories, documents, alertes, rôles)
// Sprint EEC — Facturation électrique BT (hub + cycles + pilotage)
// Calendrier de facturation — planning prévisionnel annuel (autonome, découplé des campagnes)
// Sprint EEC — Recouvrement / Relance (chaînes BM / M / TRAVAUX)
// CRM — Accords commerciaux / Plans de paiement (simulateur + suivi)
// Sprint EEC Congo — Phase 3+4 : app mobile agent terrain (shell + flux relevés)

// Module Société / Associés / Dividendes
// Module Plantation — gestion agro-industrielle (palmier à huile, hévéa, cacao)
import PlantationPage from './pages/Plantation';

// ── Chargement differe des pages ────────────────────────────────────────────
// Les 393 pages ci-dessous etaient importees en dur : elles se retrouvaient
// toutes dans le bundle principal, telecharge integralement au premier ecran,
// alors qu'une session n'en ouvre qu'une poignee. Chacune forme desormais son
// propre fragment, recupere au moment ou l'on navigue vers sa route.
//
// Layout et ProtectedRoute restent en import direct : presents sur toutes les
// routes, les differer ajouterait un aller-retour reseau sans rien economiser.
const differer = (charger: () => Promise<any>) => React.lazy(charger);

const AbonnementsListPage = differer(() => import('./components/CRM/Abonnements/AbonnementsListPage'));
const HciPortail = differer(() => import('./pages/PortailHCI/HciPortail'));
const AbonnementsParentsPage = differer(() => import('./components/VieScolaire/AbonnementsParentsPage'));
const AccordsCommerciaux = differer(() => import('./components/Recouvrement/AccordsCommerciaux'));
const AccueilAdherent = differer(() => import('./pages/EspaceAdherent/AccueilAdherent'));
const AchatPrepayePage = differer(() => import('./pages/FacturationElectrique/Prepaye/AchatPrepayePage'));
const Achats = differer(() => import('./components/Achats/Achats'));
const ActivitesCategoriePage = differer(() => import('./pages/PortailPublic/ActivitesCategoriePage'));
const ActivitesPage = differer(() => import('./pages/ActivitesPage'));
const ActualiteDetailPage = differer(() => import('./pages/PortailPublic/ActualiteDetailPage'));
const ActualitesCategoriePage = differer(() => import('./pages/PortailPublic/ActualitesCategoriePage'));
const AdherentsMigresPage = differer(() => import('./pages/adhesions/AdherentsMigresPage'));
const AdherentsPage = differer(() => import('./components/Adherent/AdherentsPage'));
const AgeeBaseConnaissances = differer(() => import('./pages/agee/AgeeBaseConnaissances'));
const AgeeBaseConnaissancesPublique = differer(() => import('./pages/PortailPublic/AgeeBaseConnaissancesPublique'));
const AgeeCarteProjet = differer(() => import('./pages/agee/AgeeCarteProjet'));
const AgeeDemandePublique = differer(() => import('./pages/PortailPublic/AgeeDemandePublique'));
const AgeeVueEnsemble = differer(() => import('./pages/agee/AgeeVueEnsemble'));
const AgregateurDashboardPage = differer(() => import('./pages/Agregateur/AgregateurDashboardPage'));
const Alertes = differer(() => import('./components/Alertes'));
const AlertesConfigPage = differer(() => import('./pages/AlertesConfigPage'));
const AlertesRH = differer(() => import('./components/RH/AlertesRH'));
const AllActualitesPage = differer(() => import('./pages/PortailPublic/AllActualitesPage'));
const AllTemoignagesPage = differer(() => import('./pages/PortailPublic/AllTemoignagesPage'));
const AnneeScolaireDetailPage = differer(() => import('./components/VieScolaire/AnneeScolaireDetailPage'));
const AnnoncesRHPage = differer(() => import('./pages/RH/AnnoncesRHPage'));
const AnnuairePage = differer(() => import('./pages/PortailPublic/AnnuairePage'));
const InstancesPage = differer(() => import('./pages/Instances/InstancesPage'));
const MesConvocationsAdherent = differer(() => import('./pages/EspaceAdherent/MesConvocations'));
const EthiquePage = differer(() => import('./pages/Ethique/EthiquePage'));
const MesSanctionsAdherent = differer(() => import('./pages/EspaceAdherent/MesSanctions'));
const VerificationsPage = differer(() => import('./pages/Verifications/VerificationsPage'));
const SignalementPage = differer(() => import('./pages/PortailPublic/SignalementPage'));
const MesProgrammesAdherent = differer(() => import('./pages/EspaceAdherent/MesProgrammes'));
const ProgrammesPage = differer(() => import('./pages/Programmes/ProgrammesPage'));
const CatalogueProgrammesPage = differer(() => import('./pages/PortailPublic/CatalogueProgrammesPage'));
const MesChiffresAdherent = differer(() => import('./pages/EspaceAdherent/MesChiffres'));
const ChiffresPage = differer(() => import('./pages/Chiffres/ChiffresPage'));
const SyntheseReseauPage = differer(() => import('./pages/PortailPublic/SyntheseReseauPage'));
const MesOpportunitesAdherent = differer(() => import('./pages/EspaceAdherent/MesOpportunites'));
const OpportunitesPage = differer(() => import('./pages/Opportunites/OpportunitesPage'));
const OpportunitesPubliquesPage = differer(() => import('./pages/PortailPublic/OpportunitesPubliquesPage'));
const MesEntrepreneursAdherent = differer(() => import('./pages/EspaceAdherent/MesEntrepreneurs'));
const RegistreEntrepreneursPage = differer(() => import('./pages/Registre/RegistreEntrepreneursPage'));
const AnnuaireRHPage = differer(() => import('./pages/RH/AnnuairePage'));
const ArretsMaladie = differer(() => import('./pages/RH/Medical/ArretsMaladie'));
const ArticleLocationPublic = differer(() => import('./pages/ArticleLocationPublic'));
const AssociesPage = differer(() => import('./pages/Societe/AssociesPage'));
const Assurance = differer(() => import('./components/Assurance/Assurance'));
const AxesAnalytiquesPage = differer(() => import('./pages/Administration/AxesAnalytiquesPage'));
const BancaireReconciliation = differer(() => import('./pages/BancaireReconciliation'));
const BanquesPage = differer(() => import('./pages/Parametrage/BanquesPage'));
const BaremeFraisEtalonnagePage = differer(() => import('./pages/CRM/Reclamations/BaremeFraisEtalonnagePage'));
const BaremesFraisEntreePage = differer(() => import('./pages/admin/BaremesFraisEntreePage'));
const BaremesMission = differer(() => import('./pages/Parametrage/BaremesMission'));
const ConflitsInteret = differer(() => import('./pages/ConflitsInteret/ConflitsInteretPage'));
const Avancements = differer(() => import('./pages/Avancements/AvancementsPage'));
const Distinctions = differer(() => import('./pages/Distinctions/DistinctionsPage'));
const MesAvancementsDistinctions = differer(() => import('./pages/MonEspace/MesAvancementsDistinctions'));
const MonDossier = differer(() => import('./pages/MonEspace/MonDossier'));
const ConformiteDossiers = differer(() => import('./pages/RH/ConformiteDossiers'));
const ParcAutoPage = differer(() => import('./pages/ParcAuto/ParcAutoPage'));
// Verticale Auto-école (module `auto_ecole`) — candidats, moniteurs, barème,
// paiements, planning des séances et examens.
const AutoEcoleTableauDeBord = differer(() => import('./pages/AutoEcole/TableauDeBordPage'));
const AutoEcoleEleves = differer(() => import('./pages/AutoEcole/ElevesPage'));
const AutoEcoleMoniteurs = differer(() => import('./pages/AutoEcole/MoniteursPage'));
const AutoEcoleBareme = differer(() => import('./pages/AutoEcole/BaremePage'));
const AutoEcolePaiements = differer(() => import('./pages/AutoEcole/PaiementsPage'));
const AutoEcolePlanning = differer(() => import('./pages/AutoEcole/PlanningPage'));
const AutoEcoleExamens = differer(() => import('./pages/AutoEcole/ExamensPage'));
/** Un de ces droits suffit à accéder au module Auto-école. */
const DROITS_AUTO_ECOLE = ['access_auto_ecole', 'gerer_eleves_ae', 'gerer_bareme_frais_ae', 'encaisser_frais_ae', 'gerer_planning_ae', 'gerer_examens_ae', 'gerer_moniteurs_ae', 'gerer_formation_ae'];
const PatrimoineReseauPage = differer(() => import('./pages/Gmao/PatrimoinePage'));
const IncidentsReseauPage = differer(() => import('./pages/Gmao/IncidentsPage'));
const OrdresTravailReseauPage = differer(() => import('./pages/Gmao/OrdresTravailPage'));
const PreventifReseauPage = differer(() => import('./pages/Gmao/PreventifPage'));
const EquipesReseauPage = differer(() => import('./pages/Gmao/EquipesPage'));
const IndicateursReseauPage = differer(() => import('./pages/Gmao/IndicateursPage'));
const TerrainReseauPage = differer(() => import('./pages/Gmao/TerrainPage'));
const CarteExploitationPage = differer(() => import('./pages/Gmao/CarteExploitationPage'));
const TableauDeBordConformitePage = differer(() => import('./pages/Conformite/TableauDeBordConformitePage'));
const ProcessusQualitePage = differer(() => import('./pages/Conformite/ProcessusPage'));
const DocumentsQualitePage = differer(() => import('./pages/Conformite/DocumentsPage'));
const NonConformitesPage = differer(() => import('./pages/Conformite/NonConformitesPage'));
const ActionsQualitePage = differer(() => import('./pages/Conformite/ActionsPage'));
const SuggestionsQualitePage = differer(() => import('./pages/Conformite/SuggestionsPage'));
const AuditsQualitePage = differer(() => import('./pages/Conformite/AuditsPage'));
const IndicateursQualitePage = differer(() => import('./pages/Conformite/IndicateursPage'));
const RisquesQualitePage = differer(() => import('./pages/Conformite/RisquesPage'));
const HseQualitePage = differer(() => import('./pages/Conformite/HsePage'));
/** Droits du module Conformité et efficacité : l'un d'eux suffit pour consulter les registres. */
const DROITS_CONFORMITE = ['access_qualite', 'parametrer_qualite', 'rediger_documents_qualite', 'verifier_documents_qualite', 'approuver_documents_qualite', 'traiter_non_conformites', 'gerer_actions_qualite', 'gerer_audits_qualite', 'realiser_audits_qualite', 'gerer_indicateurs_qualite', 'saisir_mesures_qualite', 'gerer_risques_qualite', 'gerer_hse'];
const TableauDeBordFederationPage = differer(() => import('./pages/Federation/TableauDeBordFederationPage'));
const ClubsFederationPage = differer(() => import('./pages/Federation/ClubsFederationPage'));
const LicencesFederationPage = differer(() => import('./pages/Federation/LicencesFederationPage'));
const PaiementsFederationPage = differer(() => import('./pages/Federation/PaiementsFederationPage'));
const ParametrageFederationPage = differer(() => import('./pages/Federation/ParametrageFederationPage'));
const VerificationLicencePage = differer(() => import('./pages/Federation/VerificationLicencePage'));
const VerificationQuitusPage = differer(() => import('./pages/PortailPublic/VerificationQuitusPage'));
const AgrementsFederationPage = differer(() => import('./pages/Federation/AgrementsFederationPage'));
const CommissionsFederationPage = differer(() => import('./pages/Federation/CommissionsFederationPage'));
const SuiviAffiliationsFederationPage = differer(() => import('./pages/Federation/SuiviAffiliationsFederationPage'));
const ReussiteAutoEcolePage = differer(() => import('./pages/Federation/ReussiteAutoEcolePage'));
const AffiliationFederationPage = differer(() => import('./pages/PortailPublic/AffiliationFederationPage'));
const SuiviAffiliationFederationPage = differer(() => import('./pages/PortailPublic/SuiviAffiliationFederationPage'));
const EspaceFederationPage = differer(() => import('./pages/PortailPublic/EspaceFederationPage'));
const ActivationEspaceFederationPage = differer(() => import('./pages/PortailPublic/ActivationEspaceFederationPage'));
const EvenementsFederationPublicPage = differer(() => import('./pages/PortailPublic/EvenementsFederationPublicPage'));
const SuiviInscriptionEvenementPage = differer(() => import('./pages/PortailPublic/EvenementsFederationPublicPage').then((m) => ({ default: m.SuiviInscriptionEvenementPage })));
const EvenementsFederationPage = differer(() => import('./pages/Federation/EvenementsFederationPage'));
const BadgesPresencesPage = differer(() => import('./pages/VieScolaire/Badges/BadgesPresencesPage'));
const BadgeusePage = differer(() => import('./pages/VieScolaire/Badges/BadgeusePage'));
const SanteSecurite = differer(() => import('./pages/RH/SST/SanteSecuritePage'));
const BienPublic = differer(() => import('./pages/BienPublic'));
const BilanEnquetesSatisfactionPage = differer(() => import('./pages/CRM/BilanEnquetesSatisfactionPage'));
const BilanPeriodique = differer(() => import('./components/BilanPeriodique/BilanPeriodique'));
const BilletageHistorique = differer(() => import('./pages/BilletageHistorique'));
const BordereauInterventionDetailPage = differer(() => import('./pages/demandes/BordereauInterventionDetailPage'));
const BordereauPaiement = differer(() => import('./components/RH/Paie/BordereauPaiement'));
const BordereauxJournaliers = differer(() => import('./components/RH/BordereauxJournaliers/BordereauxJournaliers'));
const BordereauxStages = differer(() => import('./components/RH/Stages/BordereauxStages'));
const BranchementsListPage = differer(() => import('./components/CRM/Branchements/BranchementsListPage'));
const BridgeAdmin = differer(() => import('./components/Admin/BridgeAdmin/BridgeAdmin'));
const BulletinPaieDetail = differer(() => import('./components/RH/Paie/BulletinPaie'));
const Caisse = differer(() => import('./components/Caisse'));
const CaisseWorkspace = differer(() => import('./pages/CaisseWorkspace'));
const CalendrierConges = differer(() => import('./components/RH/Conges/CalendrierConges'));
const CalendrierFacturationPage = differer(() => import('./pages/FacturationElectrique/CalendrierFacturationPage'));
const CampagnesPrimes = differer(() => import('./components/RH/CampagnesPrimes/CampagnesPrimes'));
const Candidatures = differer(() => import('./components/RH/Recrutement/Candidatures'));
const CapitalSocialPage = differer(() => import('./pages/Societe/CapitalSocialPage'));
const CarteBranchementsPage = differer(() => import('./pages/SIG/CarteBranchementsPage'));
// Module « Carte de visite digitale » — back-office + espace collaborateur + page publique
const CartesVisitePage = differer(() => import('./pages/CartesVisite/CartesVisitePage'));
const MaCartePage = differer(() => import('./pages/EspaceAdherent/MaCarte'));
const CartePubliquePage = differer(() => import('./pages/PortailPublic/CartePubliquePage'));
const CartographieGPSPage = differer(() => import('./components/Immobilisations/CartographieGPSPage'));
const CashPoolingPage = differer(() => import('./pages/Finances/CashPoolingPage'));
const CatalogueDemandesPage = differer(() => import('./pages/PortailPublic/CatalogueDemandesPage'));
const CatalogueFormations = differer(() => import('./components/RH/Formations/CatalogueFormations'));
const CataloguePublicAssurance = differer(() => import('./pages/CataloguePublicAssurance'));
const CataloguePublicImmobilier = differer(() => import('./pages/CataloguePublicImmobilier'));
const CataloguePublicLocation = differer(() => import('./pages/CataloguePublicLocation'));
const CentrePilotagePage = differer(() => import('./pages/Pilotage/CentrePilotagePage'));
const ChangePasswordFirstLogin = differer(() => import('./pages/ChangePasswordFirstLogin'));
const ChantiersPage = differer(() => import('./components/Chantier/ChantiersPage'));
// Septembre 2026 — BTP Lot 1 : marchés, situations de travaux, paramétrage BTP
const MarchesBtpListePage = differer(() => import('./pages/BtpMarche/MarchesListePage'));
const MarcheBtpFichePage = differer(() => import('./pages/BtpMarche/MarcheFichePage'));
const SituationBtpPage = differer(() => import('./pages/BtpMarche/SituationPage'));
const ParametrageBtpPage = differer(() => import('./pages/BtpMarche/ParametrageBtpPage'));
const ClasseDetailPage = differer(() => import('./components/VieScolaire/ClasseDetailPage'));
const ClientVue360UtilityPage = differer(() => import('./pages/clients/ClientVue360UtilityPage'));
const Clients = differer(() => import('./components/Clients'));
const ClotureExercicePage = differer(() => import('./components/Immobilisations/ClotureExercicePage'));
const CommandesEnLignePage = differer(() => import('./pages/Boutique/CommandesEnLignePage'));
const CoursiersPage = differer(() => import('./pages/Boutique/CoursiersPage'));
const StatistiquesLivraisonPage = differer(() => import('./pages/Boutique/StatistiquesLivraisonPage'));
const SuiviLivraisonsPage = differer(() => import('./pages/Boutique/SuiviLivraisonsPage'));
const ZonesLivraisonPage = differer(() => import('./pages/Boutique/ZonesLivraisonPage'));
// Espace MOBILE du coursier (sous /portail/:slug/coursier) — auth portail, pas staff.
const CoursierLayout = differer(() => import('./pages/PortailPublic/Coursier/CoursierLayout'));
const CoursierLoginPage = differer(() => import('./pages/PortailPublic/Coursier/CoursierLoginPage'));
const CoursierChangerMdpPage = differer(() => import('./pages/PortailPublic/Coursier/CoursierChangerMdpPage'));
const CoursierTourneePage = differer(() => import('./pages/PortailPublic/Coursier/CoursierTourneePage'));
const CoursierBilanPage = differer(() => import('./pages/PortailPublic/Coursier/CoursierBilanPage'));
const CommissionsPage = differer(() => import('./pages/adherent/CommissionsPage'));
const CommunicationAdherent = differer(() => import('./pages/EspaceAdherent/Communication'));
const CompositionCommissionsPage = differer(() => import('./pages/adherent/CompositionCommissionsPage'));
const ComptabiliteOHADA = differer(() => import('./components/Comptabilite/ComptabiliteOHADA'));
const CompteursParcPage = differer(() => import('./components/Stock/Compteurs/CompteursParcPage'));
const ConfirmationDroitEntreePage = differer(() => import('./pages/PublicConfirmation/ConfirmationDroitEntreePage'));
const ConsignationListPage = differer(() => import('./pages/Consignation/ConsignationListPage'));
const ConsolidationElectriciteHome = differer(() => import('./pages/Consolidation/ConsolidationElectriciteHome'));
// Septembre 2026 — Vue d'ensemble du module Électricité (page d'accueil du module).
const VueEnsembleElectricitePage = differer(() => import('./pages/Electricite/VueEnsembleElectricitePage'));
const ConsolidationHome = differer(() => import('./pages/Consolidation/ConsolidationHome'));
const ContratValidationEmploye = differer(() => import('./pages/ContratValidationEmploye'));
const ContrePropositionReponse = differer(() => import('./pages/ContrePropositionReponse'));
const ControleIntegriteGlobal = differer(() => import('./components/Immobilisations/ControleIntegriteGlobal'));
const ConventionsSubventionPage = differer(() => import('./pages/admin/ConventionsSubventionPage'));
const CotationDetailPage = differer(() => import('./components/Achats/CotationDetailPage'));
const CotationPubliquePage = differer(() => import('./pages/CotationPubliquePage'));
const CoursDevises = differer(() => import('./pages/Parametrage/CoursDevises'));
const CourrierListPage = differer(() => import('./pages/courrier/CourrierListPage'));
const CoutureClientPage = differer(() => import('./pages/PortailPublic/CoutureClientPage'));
const CouvertureChangePage = differer(() => import('./pages/Finances/CouvertureChangePage'));
const CrListPage = differer(() => import('./components/Terrain/CR/CrListPage'));
const CreditBailPage = differer(() => import('./components/Immobilisations/CreditBailPage'));
const CursusDetailPage = differer(() => import('./components/VieScolaire/CursusDetailPage'));
const CursusProgrammePage = differer(() => import('./components/VieScolaire/CursusProgrammePage'));
const CyclePilotagePage = differer(() => import('./pages/FacturationElectrique/BT/CyclePilotagePage'));
const CyclesBtPage = differer(() => import('./pages/FacturationElectrique/BT/CyclesBtPage'));
const CyclesMtPage = differer(() => import('./pages/FacturationElectrique/MT/CyclesMtPage'));
const Dashboard = differer(() => import('./pages/Dashboard'));
const DashboardAssurance = differer(() => import('./components/Assurance/DashboardAssurance'));
const DashboardCRM = differer(() => import('./components/CRM/DashboardCRM'));
const DashboardCabinetPremium = differer(() => import('./pages/PortailPublic/DashboardCabinetPremium'));
const DashboardImmoConsolide = differer(() => import('./pages/DashboardImmoConsolide'));
const DashboardPaie = differer(() => import('./components/RH/Paie/DashboardPaie'));
const DashboardRH = differer(() => import('./components/RH/DashboardRH'));
const DashboardRevenueSharingPage = differer(() => import('./components/Admin/DashboardRevenueSharingPage'));
const DatabaseSyncPage = differer(() => import('./pages/DatabaseSyncPage'));
const DecaissementsDirectsList = differer(() => import('./components/DecaissementsDirectsList'));
const Delegations = differer(() => import('./pages/RH/Delegations'));
const DemandeAcompte = differer(() => import('./components/MonEspace/DemandeAcompte'));
const DemandeDetailPage = differer(() => import('./pages/demandes/DemandeDetailPage'));
const DemandeDisponibilite = differer(() => import('./components/RH/Disponibilite/DemandeDisponibilite'));
const DemandePaiementFournisseurPrestataire = differer(() => import('./components/DemandePaiementFournisseurPrestataire'));
const DemandePret = differer(() => import('./components/MonEspace/DemandePret'));
const DemandeSortieDetail = differer(() => import('./components/Stock/DemandesSortie/DemandeSortieDetail'));
const DemandeSortieForm = differer(() => import('./components/Stock/DemandesSortie/DemandeSortieForm'));
const DemandesAbsences = differer(() => import('./components/RH/Absences/DemandesAbsences'));
const DemandesAdhesionPage = differer(() => import('./pages/admin/DemandesAdhesionPage'));
const DemandesClientPage = differer(() => import('./pages/admin/DemandesClientPage'));
const DemandesConges = differer(() => import('./components/RH/Conges/DemandesConges'));
const DemandesDecaissementList = differer(() => import('./components/DemandesDecaissementList'));
const DemandesDocuments = differer(() => import('./components/RH/Documents/DemandesDocuments'));
const DemandesRH = differer(() => import('./components/RH/DemandesRH'));
const DemandesRemboursement = differer(() => import('./pages/DemandesRemboursement'));
const DemandesSortieList = differer(() => import('./components/Stock/DemandesSortie/DemandesSortieList'));
const DemoVieScolairePage = differer(() => import('./components/Demo/DemoVieScolairePage'));
const DetailCandidature = differer(() => import('./components/RH/Recrutement/DetailCandidature'));
const DetailContrat = differer(() => import('./components/RH/Contrats/DetailContrat'));
const DetailEvaluation = differer(() => import('./components/RH/Evaluations/DetailEvaluation'));
const DetailFormation = differer(() => import('./components/RH/Formations/DetailFormation'));
const DetectionFraudePage = differer(() => import('./pages/PertesNonTechniques/DetectionFraudePage'));
const DevModules = differer(() => import('./pages/admin/DevModules'));
const DevTypesOperation = differer(() => import('./pages/admin/DevTypesOperation'));
const DevisPage = differer(() => import('./components/Devis/DevisPage'));
const DevisReponsePublique = differer(() => import('./pages/DevisReponsePublique'));
const DiplomesPage = differer(() => import('./components/VieScolaire/DiplomesPage'));
const DisjoncteursParcPage = differer(() => import('./components/Stock/Disjoncteurs/DisjoncteursParcPage'));
const DistributionsDividendesPage = differer(() => import('./pages/Societe/DistributionsDividendesPage'));
const DocumentTemplatesPage = differer(() => import('./pages/admin/DocumentTemplatesPage'));
const DocumentsEntreprisePage = differer(() => import('./pages/RH/DocumentsEntreprisePage'));
const DossierElectronique = differer(() => import('./pages/DossierElectronique'));
const DossierVenteDetail = differer(() => import('./components/CRM/DossiersVente/DossierVenteDetail'));
const DossiersVenteList = differer(() => import('./components/CRM/DossiersVente/DossiersVenteList'));
const EcartCaisseValidation = differer(() => import('./pages/EcartCaisseValidation'));
const EcheancierScolaritePage = differer(() => import('./pages/VieScolaire/EcheancierScolaritePage'));
const EcoleAnneesPage = differer(() => import('./components/VieScolaire/EcoleAnneesPage'));
const EcoleDetailPage = differer(() => import('./components/VieScolaire/EcoleDetailPage'));
const EcrituresComptablesPaie = differer(() => import('./components/RH/Paie/EcrituresComptablesPaie'));
const EditBulletinPaie = differer(() => import('./components/RH/Paie/EditBulletinPaie'));
const EditionHome = differer(() => import('./pages/Edition/EditionHome'));
// Module E-learning (LMS interne) — formateur / apprenant / suivi (+ IA).
const ElearningFormateurCours = differer(() => import('./pages/Elearning/FormateurCoursPage'));
const ElearningFormateurCoursDetail = differer(() => import('./pages/Elearning/FormateurCoursDetailPage'));
const ElearningMesFormations = differer(() => import('./pages/Elearning/MesFormationsPage'));
const ElearningCoursApprenant = differer(() => import('./pages/Elearning/ApprenantCoursDetailPage'));
const ElearningSuivi = differer(() => import('./pages/Elearning/SuiviPage'));
// Porte d'entrée du module : le menu « Vue d'ensemble » pointait sur /elearning,
// route qui n'existait pas — le lien ne menait nulle part.
const ElearningTableauBord = differer(() => import('./pages/Elearning/TableauBordPage'));
// Lot 3 — Portail PUBLIC apprenant e-learning (sans compte, résolu par slug).
const ElearningCataloguePublic = differer(() => import('./pages/PortailPublic/ElearningCataloguePublicPage'));
const ElearningCoursPublic = differer(() => import('./pages/PortailPublic/ElearningCoursPublicPage'));
const EmissionsCategoriePage = differer(() => import('./pages/PortailPublic/EmissionsCategoriePage'));
const EnquetesRHPage = differer(() => import('./pages/RH/EnquetesRHPage'));
const EnquetesSatisfactionPage = differer(() => import('./pages/CRM/EnquetesSatisfactionPage'));
const Entretiens = differer(() => import('./components/RH/Recrutement/Entretiens'));
const EspaceClientAdmin = differer(() => import('./components/EspaceClientAdmin/EspaceClientAdmin'));
const EspacePublicConfigPage = differer(() => import('./pages/admin/EspacePublicConfigPage'));
const EtatActiviteCommerciale = differer(() => import('./components/CRM/EtatActiviteCommerciale'));
const EtatsCrmPage = differer(() => import('./components/CRM/EtatsCrmPage'));
const EtatsImmobilisations = differer(() => import('./components/Immobilisations/EtatsImmobilisations'));
const EtatsPatronatPage = differer(() => import('./pages/adherent/EtatsPatronatPage'));
const EtatsRHHub = differer(() => import('./components/RH/EtatsRHHub'));
const EvaluationPerformancePage = differer(() => import('./pages/Evaluation/EvaluationPerformancePage'));
const EvenementsCategoriePage = differer(() => import('./pages/PortailPublic/EvenementsCategoriePage'));
const EvenementsRHPage = differer(() => import('./pages/RH/EvenementsRHPage'));
const FacturationHubPage = differer(() => import('./pages/FacturationElectrique/FacturationHubPage'));
const FacturationSmartPage = differer(() => import('./pages/FacturationElectrique/FacturationSmartPage'));
const FactureFraudePage = differer(() => import('./pages/PertesNonTechniques/FactureFraudePage'));
// Septembre 2026 — Factures fournisseur (contrôle, rapprochement 3 voies, règlement)
const FactureFournisseurDetail = differer(() => import('./pages/FacturesFournisseur/FactureFournisseurDetail'));
const FactureFournisseurForm = differer(() => import('./pages/FacturesFournisseur/FactureFournisseurForm'));
const FacturesARapprocher = differer(() => import('./pages/FacturesFournisseur/FacturesARapprocher'));
const FacturesFournisseurList = differer(() => import('./pages/FacturesFournisseur/FacturesFournisseurList'));
const FicheArticle = differer(() => import('./components/Stock/FicheArticle'));
const FicheClient360 = differer(() => import('./components/CRM/FicheClient/FicheClient360'));
const FicheEmploye = differer(() => import('./components/RH/Employes/FicheEmploye'));
const FichePersonnePage = differer(() => import('./pages/PortailPublic/FichePersonnePage'));
const FichePoste = differer(() => import('./components/RH/Organisation/FichePoste'));
const Finances = differer(() => import('./pages/Finances'));
const FneTransmissionsPage = differer(() => import('./components/Admin/FneTransmissionsPage'));
const FneConfigPage = differer(() => import('./pages/Parametrage/FneConfigPage'));
const FondsEpargnePage = differer(() => import('./pages/FondsEpargne/FondsEpargnePage'));
const FormTemplatesPage = differer(() => import('./pages/admin/FormTemplatesPage'));
const GaleriePage = differer(() => import('./pages/PortailPublic/GaleriePage'));
const GarantiesPage = differer(() => import('./components/Immobilisations/GarantiesPage'));
const GenerationPaie = differer(() => import('./components/RH/Paie/GenerationPaie'));
const GestionDemissions = differer(() => import('./components/RH/Demissions/GestionDemissions'));
const GouvernancePage = differer(() => import('./pages/Gouvernance/GouvernancePage'));
const GpecEtatsPage = differer(() => import('./pages/RH/GPEC/GpecEtatsPage'));
const GpecFeedback360Page = differer(() => import('./pages/RH/GPEC/GpecFeedback360Page'));
const GpecFichesPostesPage = differer(() => import('./pages/RH/GPEC/GpecFichesPostesPage'));
const GpecMatriceCompetencesPage = differer(() => import('./pages/RH/GPEC/GpecMatriceCompetencesPage'));
const GpecMobiliteCarrierePage = differer(() => import('./pages/RH/GPEC/GpecMobiliteCarrierePage'));
const GpecMobiliteInternePage = differer(() => import('./pages/RH/GPEC/GpecMobiliteInternePage'));
const GpecProfilsCarrierePage = differer(() => import('./pages/RH/GPEC/GpecProfilsCarrierePage'));
const GpecRisquesRhPage = differer(() => import('./pages/RH/GPEC/GpecRisquesRhPage'));
const GpecSuccessionPage = differer(() => import('./pages/RH/GPEC/GpecSuccessionPage'));
const GpecTalentsPage = differer(() => import('./pages/RH/GPEC/GpecTalentsPage'));
const HistoriqueCinetPay = differer(() => import('./pages/admin/HistoriqueCinetPay'));
const HistoriquePaie = differer(() => import('./components/RH/Paie/HistoriquePaie'));
const Immobilier = differer(() => import('./components/Immobilier/Immobilier'));
const Immobilisations = differer(() => import('./components/Immobilisations/Immobilisations'));
const ImportContratPdfPage = differer(() => import('./pages/RH/ImportContratPdfPage'));
const InscriptionsFormation = differer(() => import('./components/RH/Formations/InscriptionsFormation'));
const InterventionDetailPage = differer(() => import('./components/Terrain/Interventions/InterventionDetailPage'));
const InterventionsListPage = differer(() => import('./components/Terrain/Interventions/InterventionsListPage'));
const Inventaire = differer(() => import('./components/Inventaire'));
const InventaireDetailPage = differer(() => import('./components/Immobilisations/InventaireDetailPage'));
const InventaireImmobilisations = differer(() => import('./components/Immobilisations/InventaireImmobilisations'));
const LandingPage = differer(() => import('./pages/LandingPage'));
const LandingPageCGEGUI = differer(() => import('./pages/LandingPageCGEGUI'));
const LandingPageEEC = differer(() => import('./pages/LandingPageEEC'));
const LayoutCabinetClientPremium = differer(() => import('./pages/PortailPublic/LayoutCabinetClientPremium'));
const LayoutEspaceAdherent = differer(() => import('./pages/EspaceAdherent/LayoutEspaceAdherent'));
const LayoutUtilityClientPremium = differer(() => import('./pages/PortailPublic/LayoutUtilityClientPremium'));
const ListeContrats = differer(() => import('./components/RH/Contrats/ListeContrats'));
const ListeEmployes = differer(() => import('./components/RH/Employes/ListeEmployes'));
const ListeEvaluations = differer(() => import('./components/RH/Recrutement/ListeEvaluations'));
const ListeRapports = differer(() => import('./components/CRM/RapportActivite/ListeRapports'));
const Location = differer(() => import('./components/Location/Location'));
const LocationSignaturePublic = differer(() => import('./pages/LocationSignaturePublic'));
const Login = differer(() => import('./pages/Login'));
const LoginCabinetPremium = differer(() => import('./pages/PortailPublic/LoginCabinetPremium'));
const LoginPatronatAdherentsPage = differer(() => import('./pages/PortailPublic/LoginPatronatAdherentsPage'));
const LoginPatronatAgentsPage = differer(() => import('./pages/PortailPublic/LoginPatronatAgentsPage'));
const LotDetailPage = differer(() => import('./components/Terrain/Releves/LotDetailPage'));
const LotsListPage = differer(() => import('./components/Terrain/Releves/LotsListPage'));
const MaCarriere = differer(() => import('./components/MonEspace/MaCarriere'));
const MaDemission = differer(() => import('./components/MonEspace/MaDemission'));
const MaFicheDePoste = differer(() => import('./components/MonEspace/MaFicheDePoste'));
const MaintenancePage = differer(() => import('./components/Immobilisations/MaintenancePage'));
const MesAchats = differer(() => import('./components/MonEspace/MesAchats'));
const MesAcomptes = differer(() => import('./components/MonEspace/MesAcomptes'));
const MesActionsCommerciales = differer(() => import('./components/CRM/DossiersVente/MesActionsCommerciales'));
const MesActivitesAdherent = differer(() => import('./pages/EspaceAdherent/MesActivites'));
const MesBulletins = differer(() => import('./components/MonEspace/MesBulletins'));
const MesCollaborateursPage = differer(() => import('./pages/MonEspace/MesCollaborateursPage'));
const MesColleguesRHPage = differer(() => import('./pages/RH/MesColleguesRHPage'));
const MesCommissionsAdherent = differer(() => import('./pages/EspaceAdherent/MesCommissions'));
const MesCourriersAdherent = differer(() => import('./pages/EspaceAdherent/MesCourriers'));
const MesDelegations = differer(() => import('./pages/RH/MesDelegations'));
const MesDemandes = differer(() => import('./components/MonEspace/MesDemandes'));
const MesEnquetesPage = differer(() => import('./pages/MonEspace/MesEnquetesPage'));
const MesEvaluations = differer(() => import('./components/MonEspace/MesEvaluations'));
const MesFinancesAdherent = differer(() => import('./pages/EspaceAdherent/MesFinances'));
const MesVotesAdherent = differer(() => import('./pages/EspaceAdherent/MesVotes'));
const ScrutinsPage = differer(() => import('./pages/Scrutins/ScrutinsPage'));
// Octobre 2026 — solliciter son organisation depuis l'espace membre.
const SolliciterAdherent = differer(() => import('./pages/EspaceAdherent/Solliciter'));
const MesSollicitationsAdherent = differer(() => import('./pages/EspaceAdherent/MesSollicitations'));
const MesObjectifs = differer(() => import('./components/MonEspace/MesObjectifs'));
const MesPrets = differer(() => import('./components/MonEspace/MesPrets'));
const MesTachesPage = differer(() => import('./pages/MesTachesPage'));
const MesuresPage = differer(() => import('./pages/RH/MesuresPage'));
const MigrationAdherentsPage = differer(() => import('./pages/adhesions/MigrationAdherentsPage'));
const ModeCouturePage = differer(() => import('./pages/ModeCouture/ModeCouturePage'));
const ModifierEmploye = differer(() => import('./components/RH/Employes/ModifierEmploye'));
const ModuleHubPage = differer(() => import('./pages/modules/ModuleHubPage'));
const MonAdhesion = differer(() => import('./pages/EspaceAdherent/MonAdhesion'));
const MonCv = differer(() => import('./components/MonEspace/MonCv'));
const MonDossierAdherent = differer(() => import('./pages/EspaceAdherent/MonDossier'));
const MonDossierMedical = differer(() => import('./pages/RH/Medical/MonDossierMedical'));
const MonEquipePage = differer(() => import('./pages/RH/MonEquipePage'));
const MonEspaceHub = differer(() => import('./components/MonEspace/MonEspaceHub'));
const MonProfil = differer(() => import('./pages/MonProfil'));
const MotDePasseOubliePage = differer(() => import('./components/Auth/MotDePasseOubliePage'));
const MotifsSortieAdmin = differer(() => import('./components/Stock/DemandesSortie/MotifsSortieAdmin'));
const NiveauxOrganisationAdmin = differer(() => import('./pages/Consolidation/NiveauxOrganisationAdmin'));
const NotesGridPage = differer(() => import('./components/VieScolaire/NotesGridPage'));
const NouveauContrat = differer(() => import('./components/RH/Contrats/NouveauContrat'));
const NouveauRapport = differer(() => import('./components/CRM/RapportActivite/NouveauRapport'));
const NouvelEmploye = differer(() => import('./components/RH/Employes/NouvelEmploye'));
const NouvelleAdhesionBackoffice = differer(() => import('./pages/adhesions/NouvelleAdhesionBackoffice'));
const NouvelleDemandeAbsence = differer(() => import('./components/RH/Absences/NouvelleDemandeAbsence'));
const NouvelleDemandeConge = differer(() => import('./components/RH/Conges/NouvelleDemandeConge'));
const NouvelleDemandeDecaissement = differer(() => import('./components/NouvelleDemandeDecaissement'));
const NouvelleDemandeFormation = differer(() => import('./components/RH/Formations/NouvelleDemandeFormation'));
const NouvelleDemandeGenerique = differer(() => import('./pages/demandes/NouvelleDemandeGenerique'));
const NouvelleDemandePortailPage = differer(() => import('./pages/PortailPublic/NouvelleDemandePortailPage'));
const NouvelleEvaluation = differer(() => import('./components/RH/Evaluations/NouvelleEvaluation'));
const ObjectifsAgents = differer(() => import('./components/CRM/Objectifs/ObjectifsAgents'));
const OperateursMobileMoneyPage = differer(() => import('./pages/Parametrage/OperateursMobileMoneyPage'));
// ─────────────────────────────────────────────────────────────────────────
// ORGANISATION RH — l'écran de référence reste `OrganisationRH`
//
// Le module RH doit fonctionner DANS LES DEUX SENS :
//   • seul, sans le module Administration — il gère alors sa propre
//     structure (directions, départements, services), ses catégories,
//     fonctions, postes, grilles salariales et matrice des compétences ;
//   • avec le module Administration — un bouton « Synchroniser » va alors
//     chercher les entités pour composer l'organigramme.
//
// Les deux doivent rester possibles. C'est pourquoi RIEN n'est retiré de cet
// écran : ses neuf onglets, ses 2 479 lignes et son organigramme restent en
// place, et la synchronisation n'est qu'un ajout.
//
// `OrganisationEntites` avait été branché ici à titre d'essai : il n'affiche
// que l'arbre des entités, donc il masquait les huit autres onglets ET les
// boutons de synchronisation, qui vivent dans `OrganisationRH`. Route
// rétablie. Le composant d'essai est conservé, sans route : son code de
// lecture de l'arbre des entités sert de base au bouton à venir.
// ─────────────────────────────────────────────────────────────────────────
const OrganisationRH = differer(() => import('./components/RH/Organisation/OrganisationRH'));
const OrganismesSociaux = differer(() => import('./components/RH/OrganismesSociaux/OrganismesSociaux'));
const PageAdhesion = differer(() => import('./pages/PortailPublic/PageAdhesion'));
const PageAnnuaire = differer(() => import('./pages/PortailPublic/PageAnnuaire'));
const PageBiographiePresident = differer(() => import('./pages/PortailPublic/PageBiographiePresident'));
// Un seul module porte les deux pages de gouvernance : elles partagent leurs
// vignettes et leur organigramme, les séparer aurait dupliqué ce code.
const PageConseilAdministration = differer(() =>
  import('./pages/PortailPublic/PageGouvernance').then((m) => ({ default: m.PageConseilAdministration })));
const PageSecretariatGeneral = differer(() =>
  import('./pages/PortailPublic/PageGouvernance').then((m) => ({ default: m.PageSecretariatGeneral })));
const PageDetailContenu = differer(() => import('./pages/PortailPublic/PageDetailContenu'));
const PageDetailPersonne = differer(() => import('./pages/PortailPublic/PageDetailPersonne'));
const PageDocuments = differer(() => import('./pages/PortailPublic/PageDocuments'));
const PageFederations = differer(() => import('./pages/PortailPublic/PageFederations'));
const PageListeContenus = differer(() => import('./pages/PortailPublic/PageListeContenus'));
const PageMembresPartenaires = differer(() => import('./pages/PortailPublic/PageMembresPartenaires'));
const PagePersonnes = differer(() => import('./pages/PortailPublic/PagePersonnes'));
const PagePhototheque = differer(() => import('./pages/PortailPublic/PagePhototheque'));
const PageSuiviDemande = differer(() => import('./pages/PortailPublic/PageSuiviDemande'));
const PaiementDroitEntreePage = differer(() => import('./pages/PublicConfirmation/PaiementDroitEntreePage'));
const PaiementPublicPage = differer(() => import('./pages/PortailPublic/PaiementPublicPage'));
const PaiementRetour = differer(() => import('./pages/PaiementRetour'));
const PaiementRetourPage = differer(() => import('./components/Paiement/PaiementRetourPage'));
const PaiementSalairesCaisse = differer(() => import('./pages/PaiementSalairesCaisse'));
const PaiementsAdminPage = differer(() => import('./components/Admin/PaiementsAdminPage'));
const ParametresRH = differer(() => import('./components/RH/ParametresRH/ParametresRH'));
const PertesNonTechniquesPage = differer(() => import('./pages/PertesNonTechniques/PertesNonTechniquesPage'));
const PlanningActivite = differer(() => import('./components/CRM/PlanningActivite/PlanningActivite'));
const PointagePage = differer(() => import('./components/RH/Pointage/PointagePage'));
const PolitiqueSecuritePage = differer(() => import('./pages/Securite/PolitiqueSecuritePage'));
const PortailApi = differer(() => import('./pages/PortailApi'));
const PortailApplications = differer(() => import('./components/MonEspace/PortailApplications'));
const PortailAssuranceClient = differer(() => import('./pages/PortailAssuranceClient'));
const PortailBranchementsPage = differer(() => import('./pages/PortailPublic/PortailBranchementsPage'));
const PortailCandidature = differer(() => import('./components/RH/Recrutement/PortailCandidature'));
const PortailDashboardPage = differer(() => import('./pages/VieScolaire/PortailDashboardPage'));
const PortailECDashboard = differer(() => import('./pages/PortailPublic/PortailDashboardPage'));
// Oct. 2026 — tableau de bord du portail aiguillé sur le métier résolu par le
// référentiel (`ecom_portail_metiers`). Sans métier spécifique : tableau de
// bord historique, à l'identique.
const PortailECDashboardParMetier = differer(() => import('./pages/PortailPublic/DashboardPortailParMetier'));
// Oct. 2026 — « Mon dossier » de l'espace candidat (profil + pièces)
const PortailDossierCandidat = differer(() => import('./pages/PortailPublic/Candidat/DossierCandidatPage'));
const PortailPlanningCandidat = differer(() => import('./pages/PortailPublic/Candidat/PlanningCandidatPage'));
const PortailECDemandes = differer(() => import('./pages/PortailPublic/PortailDemandesPage'));
const PortailECFactures = differer(() => import('./pages/PortailPublic/PortailFacturesPage'));
const PortailECHistorique = differer(() => import('./pages/PortailPublic/PortailHistoriquePage'));
const PortailECInscription = differer(() => import('./pages/PortailPublic/PortailInscriptionPage'));
const PortailECInscriptionFullPage = differer(() => import('./pages/PortailPublic/PortailInscriptionFullPage'));
const PortailECLayout = differer(() => import('./pages/PortailPublic/PortailLayout'));
const PortailECLogin = differer(() => import('./pages/PortailPublic/PortailLoginPage'));
const PortailECLoginFullPage = differer(() => import('./pages/PortailPublic/PortailLoginFullPage'));
const PortailECPayer = differer(() => import('./pages/PortailPublic/PortailPayerPage'));
const PortailECPlaceholder = differer(() => import('./pages/PortailPublic/PortailPlaceholderPage'));
const PortailECProfil = differer(() => import('./pages/PortailPublic/PortailProfilPage'));
const PortailECResult = differer(() => import('./pages/PortailPublic/PortailPaiementResultPage'));
const PortailECVitrine = differer(() => import('./pages/PortailPublic/PortailVitrinePage'));
const PortailEcheancierImmoPage = differer(() => import('./pages/PortailPublic/PortailEcheancierImmoPage'));
const PortailMesDemandes = differer(() => import('./pages/PortailPublic/PortailMesDemandesPage'));
const PortailPatronatPage = differer(() => import('./pages/PortailPublic/PortailPatronatPage'));
const PortailVitrineAdminPage = differer(() => import('./pages/PortailPublic/PortailVitrineAdminPage'));
const PoteauxParcPage = differer(() => import('./components/Stock/Poteaux/PoteauxParcPage'));
const PrestationsPage = differer(() => import('./pages/PrestationsPage'));
const ProcedureDisciplinaire = differer(() => import('./components/RH/Disciplinaire/ProcedureDisciplinaire'));
const ProjetsPage = differer(() => import('./components/Projet/ProjetsPage'));
const MesProjetsPage = differer(() => import('./components/Projet/MesProjetsPage'));
const PetitMaterielPage = differer(() => import('./pages/RH/PetitMaterielPage'));
const PromotionDetailPage = differer(() => import('./components/VieScolaire/PromotionDetailPage'));
const Promotions = differer(() => import('./components/Promotions'));
const PromotionsMarketingPage = differer(() => import('./components/Promotions/PromotionsPage'));
const ProspectsList = differer(() => import('./components/CRM/ProspectsCrm/ProspectsList'));
// Sept. 2026 — Board pipeline commercial (Kanban) + KPIs de conversion
const PipelineCommercialPage = differer(() => import('./pages/CRM/PipelineCommercialPage'));
const RetentionSantePage = differer(() => import('./pages/CRM/RetentionSantePage'));
const FideliteParrainagePage = differer(() => import('./pages/CRM/FideliteParrainagePage'));
const EngagementRelancesPage = differer(() => import('./pages/CRM/EngagementRelancesPage'));
// Sept. 2026 — Écran Acquisition & coûts (coût par lead + taux de réponse ventilé)
const AcquisitionCoutsPage = differer(() => import('./pages/CRM/AcquisitionCoutsPage'));
const PublicActivitePage = differer(() => import('./pages/PublicActivitePage'));
const PublicAgeeFraisDossier = differer(() => import('./pages/PublicAgee/PublicAgeeFraisDossier'));
const PublicEcolePage = differer(() => import('./pages/VieScolaire/PublicEcolePage'));
const PublicPortailLoginPage = differer(() => import('./pages/VieScolaire/PublicPortailLoginPage'));
const RapportsAValider = differer(() => import('./components/CRM/RapportsAValider'));
const RebalanceEcritures = differer(() => import('./components/Comptabilite/RebalanceEcritures'));
const ReclamationPubliquePage = differer(() => import('./pages/PortailPublic/ReclamationPubliquePage'));
const ReclamationsPage = differer(() => import('./pages/CRM/Reclamations/ReclamationsPage'));
const RecouvrementPage = differer(() => import('./pages/Recouvrement/RecouvrementPage'));
const RecrutementModule = differer(() => import('./components/RH/Recrutement/RecrutementModule'));
const ReeditionComptePage = differer(() => import('./components/Admin/ReeditionComptePage'));
const ReferentielCoupures = differer(() => import('./pages/admin/ReferentielCoupures'));
const ReferentielDevises = differer(() => import('./pages/admin/ReferentielDevises'));
const ReferentielsAdmin = differer(() => import('./pages/admin/ReferentielsAdmin'));
const ReferentielsFiscauxPage = differer(() => import('./pages/Administration/ReferentielsFiscauxPage'));
const RegroupementsPage = differer(() => import('./pages/Regroupements/RegroupementsPage'));
const PersonnaliserMenusPage = differer(() => import('./pages/Parametrage/PersonnaliserMenusPage'));
const ReinitialiserMotDePassePage = differer(() => import('./components/Auth/ReinitialiserMotDePassePage'));
const RelanceReferentielsPage = differer(() => import('./pages/Parametrage/RelanceReferentielsPage'));
const RelationsSocialesPage = differer(() => import('./pages/RH/RelationsSocialesPage'));
const RemiseBanque = differer(() => import('./pages/RemiseBanque'));
const RemisesEnBanque = differer(() => import('./components/Caisse/Remises/RemisesEnBanque'));
const RemisesPage = differer(() => import('./components/VieScolaire/RemisesPage'));
const RemunerationMandatairesPage = differer(() => import('./pages/RH/RemunerationMandatairesPage'));
const RepertoireBesoinsSpeciaux = differer(() => import('./components/VieScolaire/RepertoireBesoinsSpeciaux'));
const RhDashboardPage = differer(() => import('./components/RhDashboard/RhDashboardPage'));
const RhDossierMedical = differer(() => import('./pages/RH/Medical/RhDossierMedical'));
const RhMedicalList = differer(() => import('./pages/RH/Medical/RhMedicalList'));
const SaisieCREtudeTerrainPage = differer(() => import('./pages/demandes/SaisieCREtudeTerrainPage'));
const SaisieChargePage = differer(() => import('./components/Terrain/Releves/SaisieChargePage'));
const SaisieCrConsignationPage = differer(() => import('./pages/demandes/SaisieCrConsignationPage'));
const SaisieCrControlePage = differer(() => import('./pages/demandes/SaisieCrControlePage'));
const SaisieCrDeconsignationPage = differer(() => import('./pages/demandes/SaisieCrDeconsignationPage'));
const SaisieCrDeplacementPage = differer(() => import('./pages/demandes/SaisieCrDeplacementPage'));
const SaisieCrDeposePage = differer(() => import('./pages/demandes/SaisieCrDeposePage'));
const SaisieCrInterventionPage = differer(() => import('./pages/demandes/SaisieCrInterventionPage'));
const SaisieRelevePage = differer(() => import('./components/Terrain/Releves/SaisieRelevePage'));
const ScellesParcPage = differer(() => import('./components/Stock/Scelles/ScellesParcPage'));
const Souscription = differer(() => import('./pages/Souscription'));
const SouscriptionParentPage = differer(() => import('./components/Demo/SouscriptionParentPage'));
const SsoCallback = differer(() => import('./pages/SsoCallback'));
const Statistics = differer(() => import('./components/Statistics/Statistics'));
const StatsPatronalesPage = differer(() => import('./pages/StatsPatronalesPage'));
const Stock = differer(() => import('./components/Stock'));
const SubventionsPage = differer(() => import('./components/Immobilisations/SubventionsPage'));
const SuiviActionsEnquetesPage = differer(() => import('./pages/CRM/SuiviActionsEnquetesPage'));
const SuiviCotisationsPage = differer(() => import('./pages/adherent/SuiviCotisationsPage'));
const SuiviDemandePage = differer(() => import('./pages/PortailPublic/SuiviDemandePage'));
const Supervision = differer(() => import('./components/Supervision'));
const TableauTaches = differer(() => import('./components/TableauTaches'));
const TarifsElectriquesPage = differer(() => import('./pages/Parametrage/TarifsElectriquesPage'));
const TarifsEauPage = differer(() => import('./pages/Eau/TarifsEauPage'));
const ZonesGeographiquesPage = differer(() => import('./pages/ZonesGeographiques/ZonesGeographiquesPage'));
const FacturationEauPage = differer(() => import('./pages/Eau/FacturationEauPage'));
const VueEnsembleEauPage = differer(() => import('./pages/Eau/VueEnsembleEauPage'));
const RecouvrementEauPage = differer(() => import('./pages/Eau/RecouvrementEauPage'));
const TeamBuilding = differer(() => import('./components/RH/TeamBuilding/TeamBuilding'));
const TerrainHomePage = differer(() => import('./components/Terrain/TerrainHomePage'));
const TerrainLoginPage = differer(() => import('./components/Terrain/TerrainLoginPage'));
const ToutesCategoriesPage = differer(() => import('./pages/PortailPublic/ToutesCategoriesPage'));
const TransformateursParcPage = differer(() => import('./components/Stock/Transformateurs/TransformateursParcPage'));
const Unauthorized = differer(() => import('./pages/Unauthorized'));
const ValidationAnnulations = differer(() => import('./pages/ValidationAnnulations'));
const ValidationConges = differer(() => import('./components/RH/Conges/ValidationConges'));
const ValidationCrControlePage = differer(() => import('./pages/demandes/ValidationCrControlePage'));
const ValidationDemandeDecaissement = differer(() => import('./components/ValidationDemandeDecaissement'));
const VenteSaisieDirecte = differer(() => import('./components/VenteSaisieDirecte'));
const VerifDocumentPage = differer(() => import('./pages/PublicConfirmation/VerifDocumentPage'));
const VieScolaireHome = differer(() => import('./components/VieScolaire/VieScolaireHome'));
const VitrineCabinetPremium = differer(() => import('./pages/PortailPublic/VitrineCabinetPremium'));
const VitrinePatronatAdminPage = differer(() => import('./pages/PortailPublic/VitrinePatronatAdminPage'));
const VitrinePatronatPage = differer(() => import('./pages/PortailPublic/VitrinePatronatPage'));
const VitrineUtilityPremium = differer(() => import('./pages/PortailPublic/VitrineUtilityPremium'));
const Vue360AdherentPage = differer(() => import('./pages/adherent/Vue360AdherentPage'));

// Agrégateur de paiement — dashboard marchand (back-office) + page publique /pay/:reference

// Administration pese a lui seul plus de dix mille lignes et n'est ouvert que
// par les administrateurs : on le sort du bundle principal, que tous les
// utilisateurs telechargent au premier ecran. Il est alors recupere au moment
// ou l'on ouvre la page, pas avant.
const Administration = React.lazy(() => import('./components/Administration'));

// ── Helpers renderItem partagés pour le portail EEC ─────────────────────────
// Utilisés dans /portail/:slug et /espace-public/electricite/:slug
const STATUT_COULEUR_ABO: Record<string, string> = {
  ACTIF: 'bg-emerald-50 text-emerald-700', actif: 'bg-emerald-50 text-emerald-700',
  SUSPENDU: 'bg-amber-50 text-amber-700', suspendu: 'bg-amber-50 text-amber-700',
  RESILIE: 'bg-red-50 text-red-700', resilie: 'bg-red-50 text-red-700',
};
const STATUT_COULEUR_FACT: Record<string, string> = {
  IMPAYEE: 'bg-red-100 text-red-700', impayee: 'bg-red-100 text-red-700',
  PAYEE: 'bg-emerald-100 text-emerald-700', payee: 'bg-emerald-100 text-emerald-700',
  EN_COURS: 'bg-amber-100 text-amber-700', en_cours: 'bg-amber-100 text-amber-700',
  IMPRIMEE: 'bg-blue-100 text-blue-700', imprimee: 'bg-blue-100 text-blue-700',
};
const fmtDateFR = (d: string | null | undefined): string | null =>
  d ? new Date(d).toLocaleDateString('fr-FR') : null;
const fmtPeriode = (debut: string | null | undefined, fin: string | null | undefined): string | null => {
  const d = fmtDateFR(debut ?? null);
  const f = fmtDateFR(fin ?? null);
  if (d && f) return `${d} – ${f}`;
  return d ?? f ?? null;
};

const renderAbonnementItem = (a: any) => {
  const isPostpaye = (a.modeComptage ?? '').toUpperCase().includes('POST');
  const isPrepaye = (a.modeComptage ?? '').toUpperCase().includes('PRE');
  const badgeSt = STATUT_COULEUR_ABO[a.statut] ?? 'bg-blue-50 text-blue-700';

  const details: { label: string; value: string | null }[] = [
    { label: 'Compteur',       value: a.numeroCompteur ?? null },
    { label: 'PDS',            value: a.numeroPds ?? null },
    { label: 'Puissance',      value: a.puissanceSouscriteKva ? `${a.puissanceSouscriteKva} kVA` : null },
    { label: 'Calibre',        value: a.calibreAmp ? `${a.calibreAmp} A` : null },
    { label: 'Tarif',          value: a.tarifCode ?? null },
    { label: 'Comptage',       value: a.modeComptage ?? null },
    { label: 'Périodicité',    value: a.periodicite ?? null },
    { label: 'Facturation',    value: a.modeFacturation ?? null },
    { label: 'Secteur',        value: a.secteur ?? null },
    { label: 'Tournée',        value: a.tournee ?? null },
    { label: 'Abonnement',     value: fmtDateFR(a.dateAbonnement) },
    { label: 'Mise en service',value: fmtDateFR(a.dateMiseEnService) },
    { label: 'Résiliation',    value: fmtDateFR(a.dateResiliation) },
  ].filter(d => d.value !== null && d.value !== '');

  const hasBillingData = isPostpaye
    ? !!(a.dernierMontantTTC || a.dernierePeriodeFin || a.prochainePeriodeFin)
    : !!(a.dernierAchatDate);

  return (
    <div className="space-y-3">
      {/* En-tête : N° contrat + réseau + mode + statut */}
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-semibold text-gray-900">{a.numero ?? '—'}</span>
          {a.reseau && (
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-700 font-bold uppercase">{a.reseau}</span>
          )}
          {a.modeComptage && (
            <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${isPrepaye ? 'bg-violet-50 text-violet-700' : 'bg-sky-50 text-sky-700'}`}>
              {isPrepaye ? 'Prépayé' : 'Postpayé'}
            </span>
          )}
        </div>
        {a.statut && (
          <span className={`text-[11px] px-2 py-0.5 rounded font-medium ${badgeSt}`}>{a.statut}</span>
        )}
      </div>

      {/* Grille infos contrat */}
      {details.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-1.5">
          {details.map((d, i) => (
            <div key={i} className="flex flex-col">
              <span className="text-[10px] text-gray-400 uppercase tracking-wide leading-tight">{d.label}</span>
              <span className="text-xs font-medium text-gray-700">{d.value}</span>
            </div>
          ))}
        </div>
      )}

      {/* ── Section facturation / rechargement ── */}
      {hasBillingData && (
        <div className="border-t border-gray-100 pt-2 space-y-2">
          {isPostpaye ? (
            <>
              {/* Dernière période + montant */}
              {(a.dernierePeriodeFin || a.dernierMontantTTC) && (
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div>
                    <p className="text-[10px] text-gray-400 uppercase tracking-wide">Dernière période facturée</p>
                    <p className="text-xs font-medium text-gray-700">
                      {fmtPeriode(a.dernierePeriodeDebut, a.dernierePeriodeFin) ?? '—'}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] text-gray-400 uppercase tracking-wide">Dernier montant facturé</p>
                    <div className="flex items-center gap-1 justify-end">
                      <span className="text-xs font-bold text-gray-800">
                        {a.dernierMontantTTC
                          ? `${Number(a.dernierMontantTTC).toLocaleString('fr-FR')} FCFA`
                          : '—'}
                      </span>
                      {a.dernierStatutFacture && (
                        <span className={`text-[10px] px-1.5 py-0.5 rounded ${STATUT_COULEUR_FACT[a.dernierStatutFacture] ?? 'bg-gray-100 text-gray-600'}`}>
                          {a.dernierStatutFacture}
                        </span>
                      )}
                    </div>
                    {a.derniereConsommationKwh && (
                      <p className="text-[10px] text-gray-400 mt-0.5">
                        {Number(a.derniereConsommationKwh).toLocaleString('fr-FR')} kWh
                      </p>
                    )}
                  </div>
                </div>
              )}
              {/* Prochaine période estimée */}
              {a.prochainePeriodeFin && (
                <div className="flex items-center gap-2 bg-blue-50 rounded px-2 py-1.5">
                  <span className="text-[10px] text-blue-500 font-medium uppercase tracking-wide flex-shrink-0">
                    Prochaine période
                  </span>
                  <span className="text-xs font-semibold text-blue-700 ml-auto">
                    {fmtPeriode(a.prochainePeriodeDebut, a.prochainePeriodeFin)}
                  </span>
                </div>
              )}
              {/* Prévision de facturation */}
              {a.dernierMontantTTC && (
                <div className="flex items-center gap-2 bg-amber-50 rounded px-2 py-1.5">
                  <span className="text-[10px] text-amber-600 font-medium uppercase tracking-wide flex-shrink-0">
                    Prévision facturation
                  </span>
                  <span className="text-xs font-semibold text-amber-800 ml-auto">
                    ≈ {Number(a.dernierMontantTTC).toLocaleString('fr-FR')} FCFA
                  </span>
                </div>
              )}
            </>
          ) : isPrepaye ? (
            <>
              {a.dernierAchatDate && (
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div>
                    <p className="text-[10px] text-gray-400 uppercase tracking-wide">Dernier rechargement</p>
                    <p className="text-xs font-medium text-gray-700">{fmtDateFR(a.dernierAchatDate)}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] text-gray-400 uppercase tracking-wide">Montant rechargé</p>
                    <p className="text-xs font-bold text-violet-700">
                      {a.dernierAchatMontant
                        ? `${Number(a.dernierAchatMontant).toLocaleString('fr-FR')} FCFA`
                        : '—'}
                    </p>
                    {a.dernierKwhAchetes && (
                      <p className="text-[10px] text-gray-400 mt-0.5">
                        {Number(a.dernierKwhAchetes).toLocaleString('fr-FR')} kWh
                      </p>
                    )}
                  </div>
                </div>
              )}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated, loading, permissionsLoaded, hasPermission, user } = useAuth();

  // Route par defaut apres connexion : les agents sans access_dashboard
  // sont rediriges vers leur espace personnel.
  // Un adhérent (role `client`, créé à la validation de son adhesion) n'est
  // pas un agent : son point d'entrée est son espace membre, jamais le
  // back-office ni l'espace self-service des employes.
  const estAdherent = user?.role === 'client';
  const defaultHome = estAdherent
    ? '/espace-adherent/accueil'
    : (hasPermission('access_dashboard') ? '/dashboard' : '/mon-espace');
  const defaultPublicRoute = process.env.REACT_APP_DEFAULT_PUBLIC_ROUTE || '/landing';
  // Build tenant « vitrine à la racine » : slug du portail patronat à afficher
  // directement sur `/` (ex. CGE-GUI → vitrine servie sur /cgegui, sans redirect
  // vers /p/adherents/cgegui). Null = comportement générique.
  const HOME_VITRINE_SLUG = process.env.REACT_APP_HOME_VITRINE_SLUG || null;
  const location = useLocation();

  // Routes entièrement publiques — bypass du garde d'authentification
  // Note: basename='/gestioncaisse' est défini dans BrowserRouter (App.tsx)
  // → location.pathname est déjà relatif à /gestioncaisse, donc PAS de préfixe ici
  const PUBLIC_PATHS = [
    '/postuler/', '/landing', '/souscrire', '/devis-validation/', '/bien-public/',
    // Écran de badgeuse Vie Scolaire : authentifié par son jeton d'appairage, pas par une session.
    '/badgeuse',
    // Portail public HCI International, rattache a l'entite HCI du socle
    '/portail/hci',
    // `/espace-public/` couvre aussi le catalogue immobilier `/espace-public/immobilier/:slug`
    '/api-zone', '/contre-proposition/', '/contrat-validation/', '/espace-public/',
    // Module Location — catalogue public + fiche article publique
    '/location-public/', '/article-location/',
    // ── Accès publics (pas de JWT requis) ────────────────────────────────
    '/login',
    // Retour SSO SAML — le backend redirige ici avec les tokens en query params
    '/sso/callback',
    '/mot-de-passe-oublie',
    '/reinitialiser-mot-de-passe',
    '/demo-vie-scolaire',
    '/espace-parent/souscription',
    '/paiement/retour',
    '/cinetpay/retour',
    '/cotation/',
    '/espace-parent/echeancier/',
    // Portail Espace Client (vitrine publique + login/inscription)
    // Couvre aussi la page CLIENT PUBLIQUE Mode Couture : /portail/:slug/mode-couture
    // (et /espace-public/<domaine>/:slug/mode-couture via le préfixe /espace-public/).
    // Couvre également le portail PUBLIC e-learning (Lot 3) :
    //   /portail/:slug/elearning  et  /portail/:slug/elearning/cours/:coursId
    '/portail/',
    // Portail Patronat / Association (accès agents + adhérents via slug)
    '/p/agents/',
    '/p/adherents/',
    // Routes RACINE de la vitrine (build CGE-GUI dédié uniquement). Publiques.
    // Gatées IS_CGEGUI → n'existent pas dans les autres builds.
    ...(IS_CGEGUI ? [
      '/acces-collaborateurs',
      '/connexion', '/suivi', '/membre/', '/galerie', '/annuaire', '/temoignages',
      '/actualites', '/evenements/', '/nos-activites/', '/emissions/', '/categories/',
    ] : []),
    // Routes RACINE de la vitrine (build CGE-GUI dédié uniquement). Publiques.
    // Gatées IS_CGEGUI → n'existent pas dans les autres builds.
    ...(IS_CGEGUI ? [
      '/acces-collaborateurs',
      '/connexion', '/suivi', '/membre/', '/galerie', '/annuaire', '/temoignages',
      '/actualites', '/evenements/', '/nos-activites/', '/emissions/', '/categories/',
    ] : []),
    // Socle « Vitrine Patronat » — pages publiques servies à la racine.
    // Gardées par HOME_VITRINE_SLUG et NON par le tenant : tout patronat en
    // hérite, sans quoi un second patronat n'aurait pas ces pages.
    ...(HOME_VITRINE_SLUG !== null ? [
      // Tout le socle « Vitrine Patronat » vit sous /public/ : un seul
      // préfixe couvre ses pages, présentes et à venir. C'est aussi ce qui
      // évite qu'une route publique masque une page du back-office — le cas
      // s'est produit avec /activites.
      '/public/',
    ] : []),
    // MM-118 — Confirmation publique du droit d'entrée (token JWT 30j dans URL)
    '/public/droit-entree/',
    // AGEE — Accord public frais de dossier (token JWT dans URL, envoyé par email)
    '/public/agee/',
    // MM-119 — Paiement public du droit d'entrée (lien email)
    '/public/paiement/',
    // QR documents — vérification publique + paiement facture impayée
    '/verif/',
    // Carte de visite digitale — page publique consultée après scan du QR (sans JWT)
    '/public/carte/',
    // Login mobile agents terrain (pas de JWT requis)
    '/terrain/login',
    // Portail public activités (sans JWT — page de présentation d'un événement)
    '/p/activites/',
    // Agrégateur de paiement — page de paiement publique (sans JWT)
    '/pay/',
    // Fédération sportive — vérification publique d'une licence et affiliation
    // en ligne d'une structure. Déclarées ICI et non sous le préfixe '/public/'
    // du socle Vitrine : celui-ci n'est ajouté que pour un tenant vitrine, et
    // ces pages doivent s'ouvrir sur toute instance (app.sag.ci comprise).
    '/public/federation/',
  ];
  const normalizedPathname = location.pathname.replace(/^\/\//, '/');
  const isPublicRoute =
    (HOME_VITRINE_SLUG !== null && location.pathname === '/') ||
    PUBLIC_PATHS.some(p => normalizedPathname.startsWith(p));

  if (!isPublicRoute && (loading || !permissionsLoaded)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement de l'application...</p>
        </div>
      </div>
    );
  }

  // Filet de securite pour les rares routes rendues hors du cadre applicatif
  // (pages publiques, portails). Les pages encadrees par Layout sont, elles,
  // suspendues au niveau du conteneur central : voir Layout.tsx.
  return (
    <React.Suspense fallback={<div className="min-h-screen bg-gray-50" />}>
    <Routes>
      {/* Routes publiques — accessibles sans authentification */}
      <Route path="/landing" element={BRAND_NAME.includes('E²C') || BRAND_NAME.includes('EEC') ? <LandingPageEEC /> : <LandingPage />} />
      <Route path="/souscrire" element={<Souscription />} />
      <Route path="/postuler/:token" element={<PortailCandidature />} />
      <Route path="/devis-validation/:devisId" element={<DevisReponsePublique />} />
      <Route path="/verif/:type/:numero" element={<VerifDocumentPage />} />
      {/* Agrégateur de paiement — page de paiement PUBLIQUE (sans auth) */}
      <Route path="/pay/:reference" element={<PaiementPublicPage />} />
      <Route path="/bien-public/:token" element={<BienPublic />} />
      <Route path="/contre-proposition/:token" element={<ContrePropositionReponse />} />
      <Route path="/contrat-validation/:token" element={<ContratValidationEmploye />} />
      <Route path="/espace-public/ecoles/:slug" element={<PublicEcolePage />} />
      <Route path="/espace-public/ecoles/:slug/portail/:portailRole" element={<PublicPortailLoginPage />} />
      <Route path="/espace-public/ecoles/:slug/portail/:portailRole/dashboard" element={<PortailDashboardPage />} />
      {/* Catalogue immobilier public d'une entité (vitrine programmes + biens) */}
      <Route path="/espace-public/immobilier/:slug" element={<CataloguePublicImmobilier />} />
      {/* Catalogue assurance public d'une entité (vitrine produits + demande de devis).
          Le préfixe /espace-public/ est déjà couvert par PUBLIC_PATHS. La route
          `produit/:token` (lien direct d'un produit) est servie par la même vitrine. */}
      <Route path="/espace-public/assurance/produit/:slug" element={<CataloguePublicAssurance />} />
      <Route path="/espace-public/assurance/:slug" element={<CataloguePublicAssurance />} />
      {/* Catalogue location public d'une entité (alias propre, cohérent avec immobilier).
          L'ancienne route /location-public/:entiteSlug reste active pour compat. */}
      <Route path="/espace-public/location/:entiteSlug" element={<CataloguePublicLocation />} />
      {/* Mai 2026 — Vitrine publique dédiée pour les cabinets juridiques.
          URL "type" stable : /espace-public/cabinets-avocats/<slug-cabinet>.
          Le composant détecte automatiquement le param `slug` (ici) ou
          `slugEntite` (route générique /portail/:slugEntite). */}
      <Route path="/espace-public/cabinets-avocats/:slug" element={<VitrineCabinetPremium />} />
      <Route path="/espace-public/cabinets-huissiers/:slug" element={<VitrineCabinetPremium />} />
      <Route path="/espace-public/cabinets-notaires/:slug" element={<VitrineCabinetPremium />} />

      {/* Mai 2026 — Sous-routes portail accessibles aussi via /espace-public/cabinets-*.
          STRUCTURE EN 2 LAYOUTS :
          (1) Login + inscription gardent PortailECLayout (header horizontal classique)
              — pas besoin d'utilisateur authentifié.
          (2) Pages internes (dashboard, dossiers, …) utilisent LayoutCabinetClientPremium
              (sidebar latérale navy + or, style Légis & Partners) — réservées aux
              utilisateurs authentifiés (Navigate vers /login sinon). */}
      {(['cabinets-avocats', 'cabinets-huissiers', 'cabinets-notaires'] as const).map(type => (
        <React.Fragment key={type}>
          {/* (1) Routes pré-login — SANS PortailECLayout. Le login utilise un
              composant dédié style Légis premium (background image cabinet,
              palette navy + or, Playfair Display). L'inscription garde le
              wrapper fullscreen classique (TODO : version premium si besoin). */}
          <Route path={`/espace-public/${type}/:slug/login`} element={<LoginCabinetPremium />} />
          <Route path={`/espace-public/${type}/:slug/inscription`} element={<PortailECInscriptionFullPage />} />

          {/* (2) Routes internes post-login — LAYOUT PREMIUM SIDEBAR */}
          <Route path={`/espace-public/${type}/:slug`} element={<LayoutCabinetClientPremium />}>
            <Route path="dashboard" element={<DashboardCabinetPremium />} />
            <Route path="profil" element={<PortailECProfil />} />
            <Route path="historique" element={<PortailECHistorique />} />
            <Route path="payer" element={<PortailECPayer />} />
            <Route path="paiement-result/:paiementId" element={<PortailECResult />} />
            <Route path="factures" element={<PortailECFactures />} />
            <Route path="echeancier" element={<PortailEcheancierImmoPage />} />
            <Route path="demandes" element={<PortailECDemandes />} />
            <Route path="dossiers" element={
              <PortailECPlaceholder
                titre="Mes dossiers"
                description="Affaires en cours suivies par votre cabinet"
                endpoint="/portail/dossiers-juridiques"
                icon={Scale}
                comingSoonMessage="Vos dossiers apparaîtront ici dès leur ouverture par votre cabinet."
                renderItem={(d: any) => (
                  <div className="flex items-center justify-between gap-3 flex-wrap">
                    <div className="flex-1 min-w-0">
                      <p className="font-medium text-gray-900">
                        Dossier {d.numeroInterne ?? d.code ?? d.id?.slice?.(0, 8) ?? '—'}
                      </p>
                      <p className="text-sm text-gray-500">
                        {d.intitule ?? d.libelle ?? ''}
                        {d.juridiction ? ` · ${d.juridiction}` : ''}
                        {d.stadeProcedure ? ` · ${d.stadeProcedure}` : ''}
                      </p>
                      {d.avocatResponsableNom && (
                        <p className="text-xs text-gray-400 mt-0.5">
                          Avocat : {d.avocatResponsableNom}
                        </p>
                      )}
                    </div>
                    <span className={`text-xs px-2 py-0.5 rounded ${
                      d.statut === 'CLOTURE' ? 'bg-gray-100 text-gray-600'
                      : d.statut === 'EN_DELIBERE' ? 'bg-violet-50 text-violet-700'
                      : 'bg-emerald-50 text-emerald-700'
                    }`}>
                      {d.statut ?? 'En cours'}
                    </span>
                  </div>
                )}
              />
            } />
            <Route path="paiements" element={
              <PortailECPlaceholder
                titre="Mes paiements"
                description="Historique de vos honoraires et frais réglés"
                endpoint="/portail/paiements-immo"
                icon={CreditCardIcon}
                comingSoonMessage="L'historique de vos paiements sera disponible ici."
              />
            } />
            <Route path="documents" element={
              <PortailECPlaceholder
                titre="Mes pièces & jugements"
                description="Conclusions, PV d'audience, jugements et pièces du dossier"
                endpoint="/portail/documents-immo"
                icon={FileCheck}
                comingSoonMessage="Vos documents officiels apparaîtront ici dès leur versement au dossier."
              />
            } />
          </Route>
        </React.Fragment>
      ))}

      {/* ===== MM-11 : OPÉRATEURS DE SERVICE — VITRINE + ESPACE ABONNÉ =====
          URLs "type" SEO-friendly pour les fournisseurs avec abonnement :
            /espace-public/electricite/<slug>   (EEC, EDG, …)
            /espace-public/eau/<slug>           (SODECI, SEEG, …)
            /espace-public/internet/<slug>      (FAI)
            /espace-public/telephonie/<slug>    (opérateurs telecom)
          Le composant détecte automatiquement le param `slug` ou `slugEntite`.
          STRUCTURE EN 2 LAYOUTS (calquée sur les cabinets) :
          (1) Vitrine publique = VitrineUtilityPremium (hero plein écran + slidebar)
          (2) Pages internes (dashboard, factures, payer, …) = LayoutUtilityClientPremium
              (sidebar latérale couleur entité + zone content) */}
      {(['electricite', 'eau', 'internet', 'telephonie'] as const).map(type => (
        <React.Fragment key={`utility-${type}`}>
          {/* Vitrine publique sans wrapper */}
          <Route path={`/espace-public/${type}/:slug`} element={<VitrineUtilityPremium />} />

          {/* Login / inscription en plein écran (sans layout) */}
          <Route path={`/espace-public/${type}/:slug/login`} element={<PortailECLoginFullPage />} />
          <Route path={`/espace-public/${type}/:slug/inscription`} element={<PortailECInscriptionFullPage />} />

          {/* Pages internes — sidebar premium opérateur */}
          <Route path={`/espace-public/${type}/:slug`} element={<LayoutUtilityClientPremium />}>
            <Route path="dashboard"    element={<PortailECDashboard />} />
            <Route path="factures"     element={<PortailECFactures />} />
            <Route path="payer"        element={<PortailECPayer />} />
            <Route path="paiement-result/:paiementId" element={<PortailECResult />} />
            <Route path="echeancier"   element={<PortailEcheancierImmoPage />} />
            <Route path="historique"   element={<PortailECHistorique />} />
            <Route path="demandes"     element={<PortailECDemandes />} />
            <Route path="mes-demandes" element={<PortailMesDemandes />} />
            {/* Nouvelles demandes — catalogue des types de demandes */}
            <Route path="catalogue"    element={<CatalogueDemandesPage />} />
            <Route path="profil"       element={<PortailECProfil />} />
            {/* Mon contrat — branchements + abonnements EEC */}
            <Route path="branchements" element={<PortailBranchementsPage />} />
            <Route path="abonnements" element={
              <PortailECPlaceholder
                titre="Mes abonnements"
                description="Contrats actifs et historiques"
                endpoint="/portail/abonnements"
                icon={ClipboardList}
                renderItem={renderAbonnementItem}
              />
            } />
          </Route>
        </React.Fragment>
      ))}

      {/* ===== MODULE LOCATION — PORTAIL PUBLIC (sans auth) ===== */}
      {/* Signature à distance d'un contrat — DOIT précéder /location-public/:entiteSlug
          (sinon "signature" serait capté comme un slug d'entité). */}
      <Route path="/location-public/signature/:token" element={<LocationSignaturePublic />} />
      <Route path="/location-public/:entiteSlug" element={<CataloguePublicLocation />} />
      <Route path="/article-location/:token" element={<ArticleLocationPublic />} />

      {/* NB : la route vitrine (index) est déclarée dans le layout /portail/:slugEntite ci-dessous */}

      {/* MM-29 — Catalogue public des démarches (par entité, sans auth) */}
      {/* Portail HCI — declare avant les routes /portail/:slugEntite, qui
          capteraient sinon le slug « hci » au profit du portail generique. */}
      <Route path="/portail/hci/*" element={<HciPortail />} />

      <Route path="/portail/:slugEntite/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/electricite/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/eau/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/internet/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/telephonie/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/cabinets-avocats/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/cabinets-huissiers/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/cabinets-notaires/:slug/catalogue" element={<CatalogueDemandesPage />} />
      <Route path="/espace-public/ecoles/:slug/catalogue" element={<CatalogueDemandesPage />} />

      {/* Juillet 2026 — AGEE : formulaire public de pré-demande + base de connaissances (sans auth) */}
      <Route path="/portail/:slugEntite/demande-publique" element={<AgeeDemandePublique />} />
      <Route path="/portail/:slugEntite/base-connaissances" element={<AgeeBaseConnaissancesPublique />} />
      <Route path="/portail/:slugEntite/base-connaissances/carte" element={<AgeeBaseConnaissancesPublique mode="carte" />} />

      {/* MM-52 — Saisie d'une nouvelle demande (abonné connecté, redirige vers login si non auth)
           Page autonome (pas sous PortailECLayout) — gère elle-même la garde token portail.
           Démarre le workflow réel via POST /portail/demandes-en-ligne. */}
      <Route path="/portail/:slugEntite/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/electricite/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/eau/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/internet/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/telephonie/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/cabinets-avocats/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/cabinets-huissiers/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/cabinets-notaires/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      <Route path="/espace-public/ecoles/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />

      {/* Réclamation publique (anonyme, sans auth) — RECL_REDRESSEMENT / ETALONNAGE BT-MT.
           Slug résolu via usePortailBasePath (param d'URL). PUBLIC_PATHS couvre déjà
           `/portail/` et `/espace-public/`. */}
      <Route path="/portail/:slugEntite/reclamation" element={<ReclamationPubliquePage />} />

      {/* Mode Couture — page CLIENT PUBLIQUE (self-service + paiement à l'usage).
           Slug résolu via usePortailBasePath (param d'URL). PUBLIC_PATHS couvre
           déjà `/portail/`. */}
      <Route path="/portail/:slug/mode-couture" element={<CoutureClientPage />} />
      <Route path="/espace-public/electricite/:slug/mode-couture" element={<CoutureClientPage />} />
      <Route path="/espace-public/eau/:slug/mode-couture" element={<CoutureClientPage />} />
      <Route path="/espace-public/internet/:slug/mode-couture" element={<CoutureClientPage />} />
      <Route path="/espace-public/telephonie/:slug/mode-couture" element={<CoutureClientPage />} />
      <Route path="/espace-public/electricite/:slug/reclamation" element={<ReclamationPubliquePage />} />
      <Route path="/espace-public/eau/:slug/reclamation" element={<ReclamationPubliquePage />} />
      <Route path="/espace-public/internet/:slug/reclamation" element={<ReclamationPubliquePage />} />
      <Route path="/espace-public/telephonie/:slug/reclamation" element={<ReclamationPubliquePage />} />

      {/* E-learning — PORTAIL PUBLIC apprenant (Lot 3). Apprenant EXTERNE sans
           compte : catalogue des cours exposés, inscription (→ apprenantId jeton
           en localStorage), lecteur de sessions + QCM + attestation. Slug résolu
           via usePortailBasePath. PUBLIC_PATHS couvre déjà `/portail/`. Déclaré
           AVANT le layout /portail/:slugEntite pour matcher en priorité. */}
      <Route path="/portail/:slug/elearning" element={<ElearningCataloguePublic />} />
      <Route path="/portail/:slug/elearning/cours/:coursId" element={<ElearningCoursPublic />} />

      {/* Espace MOBILE du coursier (back-office livraison en main). Auth PORTAIL
           (portail_token), pas la session staff — PUBLIC_PATHS couvre déjà
           `/portail/`. Déclaré AVANT le layout /portail/:slugEntite pour matcher
           en priorité. Index = login, puis changement de mot de passe forcé,
           tournée et bilan. */}
      <Route path="/portail/:slugEntite/coursier" element={<CoursierLayout />}>
        <Route index element={<CoursierLoginPage />} />
        <Route path="changer-mot-de-passe" element={<CoursierChangerMdpPage />} />
        <Route path="tournee" element={<CoursierTourneePage />} />
        <Route path="bilan" element={<CoursierBilanPage />} />
      </Route>

      {/* ===== ESPACE CLIENT — PORTAIL DE PAIEMENT (public, sans Layout SAGeCOM) ===== */}
      <Route path="/portail/:slugEntite" element={<PortailECLayout />}>
        <Route index element={<PortailECVitrine />} />
        <Route path="login" element={<PortailECLogin />} />
        <Route path="inscription" element={<PortailECInscription />} />
        <Route path="dashboard" element={<PortailECDashboardParMetier />} />
        {/* Oct. 2026 — espace candidat (auto-école) : dossier et pièces */}
        <Route path="mon-dossier" element={<PortailDossierCandidat />} />
        {/* Oct. 2026 — « Mon planning » : seances de code et de conduite,
            examens. Resolu depuis le jeton du candidat, jamais depuis un
            identifiant passe dans l'URL. */}
        <Route path="mon-planning" element={<PortailPlanningCandidat />} />
        <Route path="factures" element={<PortailECFactures />} />
        <Route path="payer" element={<PortailECPayer />} />
        <Route path="paiement-result/:paiementId" element={<PortailECResult />} />
        <Route path="historique" element={<PortailECHistorique />} />
        <Route path="profil" element={<PortailECProfil />} />
        {/* Fonds d'épargne — volet II du CDCF. Montées sous le MÊME layout
            portail : connexion, menu et déconnexion sont ceux du socle. */}
        <Route path="situation" element={<PortailFondsSituation />} />
        <Route path="versements" element={<PortailFondsVersements />} />
        <Route path="documents" element={<PortailFondsDocuments />} />
        {/* Onglets enrichis (vue alignée avec back-office) */}
        <Route path="demandes" element={<PortailECDemandes />} />
        <Route path="mes-demandes" element={<PortailMesDemandes />} />
        <Route path="branchements" element={<PortailBranchementsPage />} />
        <Route path="abonnements" element={
          <PortailECPlaceholder
            titre="Mes abonnements"
            description="Contrats actifs et historiques"
            endpoint="/portail/abonnements"
            icon={ClipboardList}
            renderItem={renderAbonnementItem}
          />
        } />
        <Route path="personnes-liees" element={
          <PortailECPlaceholder
            titre="Personnes physiques liées"
            description="Co-titulaires et bénéficiaires de votre compte"
            endpoint="/portail/personnes-liees"
            icon={UsersIcon}
            writeConfig={{
              basePath: '/portail/personnes-liees',
              addLabel: 'Ajouter une personne',
              fields: [
                { key: 'nom', label: 'Nom', required: true },
                { key: 'prenom', label: 'Prénom' },
                { key: 'role', label: 'Rôle (co-titulaire, bénéficiaire…)' },
                { key: 'qualite', label: 'Qualité' },
                { key: 'telephone', label: 'Téléphone', type: 'tel' },
                { key: 'email', label: 'Email', type: 'email' },
              ],
            }}
            renderItem={(p: any) => (
              <div>
                <p className="font-medium text-gray-900">{p.prenom} {p.nom}</p>
                <p className="text-sm text-gray-500">{p.relation ?? p.role ?? ''} — {p.telephone ?? p.email ?? ''}</p>
              </div>
            )}
          />
        } />
        <Route path="pieces" element={
          <PortailECPlaceholder
            titre="Mes pièces"
            description="Documents partagés avec votre fournisseur"
            endpoint="/portail/pieces"
            icon={FolderOpen}
            renderItem={(p: any) => (
              <a href={p.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-sm">
                {p.nom ?? p.libelle ?? 'Document'}
              </a>
            )}
          />
        } />
        <Route path="adresses" element={
          <PortailECPlaceholder
            titre="Mes adresses"
            description="Adresses de facturation et de livraison"
            endpoint="/portail/adresses"
            icon={MapPinIcon}
            writeConfig={{
              basePath: '/portail/adresses',
              addLabel: 'Ajouter une adresse',
              fields: [
                { key: 'libelle', label: 'Libellé (Domicile, Bureau…)', required: true },
                { key: 'adresse', label: 'Adresse', type: 'textarea' },
                { key: 'quartier', label: 'Quartier' },
                { key: 'commune', label: 'Commune' },
                { key: 'ville', label: 'Ville' },
                { key: 'telephone', label: 'Téléphone', type: 'tel' },
                { key: 'principale', label: 'Adresse principale', type: 'checkbox' },
              ],
            }}
            renderItem={(a: any) => (
              <div>
                <p className="font-medium text-gray-900">
                  {a.libelle ?? a.type ?? 'Adresse'}
                  {a.principale && <span className="ml-2 text-[11px] px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded">Principale</span>}
                </p>
                <p className="text-sm text-gray-500">
                  {[a.adresse, a.quartier, a.commune, a.ville].filter(Boolean).join(', ') || a.ligne1 || '—'}
                  {a.telephone ? ` · ${a.telephone}` : ''}
                </p>
              </div>
            )}
          />
        } />
        <Route path="avoirs" element={
          <PortailECPlaceholder
            titre="Mes avoirs"
            description="Avoirs en votre faveur sur votre compte"
            endpoint="/portail/avoirs"
            icon={FilePlus}
            renderItem={(a: any) => (
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="font-medium text-gray-900">{a.numero ?? '—'}</p>
                  <p className="text-sm text-gray-500">{a.motif ?? a.libelle ?? ''}</p>
                </div>
                <span className="font-mono text-emerald-700">{a.montant ?? 0} {a.devise ?? ''}</span>
              </div>
            )}
          />
        } />
        <Route path="extensions" element={
          <PortailECPlaceholder
            titre="Mes extensions"
            description="Services et options additionnels"
            endpoint="/portail/extensions"
            icon={Layers}
            renderItem={(e: any) => (
              <div>
                <p className="font-medium text-gray-900">{e.libelle ?? e.nom ?? '—'}</p>
                <p className="text-sm text-gray-500">{e.description ?? ''}</p>
              </div>
            )}
          />
        } />
        <Route path="relances" element={
          <PortailECPlaceholder
            titre="Mes relances"
            description="Avis et rappels de paiement"
            endpoint="/portail/relances"
            icon={AlertTriIcon}
            renderItem={(r: any) => (
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="font-medium text-gray-900">{r.objet ?? r.titre ?? '—'}</p>
                  <p className="text-sm text-gray-500">{r.date ?? ''}</p>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded ${r.niveau === 'mise_en_demeure' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                  {r.niveau ?? r.statut ?? ''}
                </span>
              </div>
            )}
          />
        } />
        <Route path="avis" element={
          <PortailECPlaceholder
            titre="Avis & annonces"
            description="Avis, annonces de votre fournisseur et de votre agence, coupures programmées (consignation, entretien réseau)"
            endpoint="/portail/communications"
            icon={MessageSquare}
            comingSoonMessage="Les avis et annonces de votre fournisseur s'afficheront ici."
            renderItem={(a: any) => {
              const t = String(a.type ?? '').toUpperCase();
              const coupure = ['COUPURE', 'CONSIGNATION', 'ENTRETIEN'].includes(t);
              const urgent = String(a.niveau ?? '').toUpperCase() === 'URGENT';
              return (
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className={`text-[11px] px-1.5 py-0.5 rounded font-medium ${
                      coupure ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'
                    }`}>
                      {a.type ?? 'ANNONCE'}
                    </span>
                    {urgent && (
                      <span className="text-[11px] px-1.5 py-0.5 rounded bg-red-600 text-white font-medium">URGENT</span>
                    )}
                    <span className="font-medium text-gray-900">{a.titre ?? '—'}</span>
                  </div>
                  {a.contenu && <p className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">{a.contenu}</p>}
                  <div className="mt-1 flex items-center gap-3 flex-wrap text-xs text-gray-400">
                    {a.dateDebut && (
                      <span>
                        Du {new Date(a.dateDebut).toLocaleString('fr-FR')}
                        {a.dateFin ? ` au ${new Date(a.dateFin).toLocaleString('fr-FR')}` : ''}
                      </span>
                    )}
                    {a.zones && <span>Zones : {a.zones}</span>}
                  </div>
                </div>
              );
            }}
          />
        } />

        {/* ── Onglets Template IMMOBILIER (FIMOLUX, promoteurs, agences) ──
            Les pages utilisent le placeholder avec des endpoints dédiés à
            implémenter côté backend (espace acquéreur). En attendant, le
            placeholder affiche "bientôt disponible" si le backend renvoie 404. */}
        <Route path="contrats" element={
          <PortailECPlaceholder
            titre="Mes contrats de vente"
            description="Actes de vente immobiliers signés et en cours"
            endpoint="/portail/contrats-acquereur"
            icon={Briefcase}
            comingSoonMessage="Vos contrats de vente apparaîtront ici dès leur signature par le promoteur."
            renderItem={(c: any) => (
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900">Acte n° {c.numeroActe ?? '—'}</p>
                  <p className="text-sm text-gray-500">
                    {c.bienTitre ?? ''}{c.bienReference ? ` (${c.bienReference})` : ''}
                    {c.dateActe ? ` — Signé le ${new Date(c.dateActe).toLocaleDateString('fr-FR')}` : ''}
                  </p>
                  {c.prixVente > 0 && (
                    <p className="text-xs text-gray-400 mt-0.5">
                      Prix : {Number(c.prixVente).toLocaleString('fr-FR')} FCFA
                      {c.nombreEcheances ? ` · ${c.nombreEcheances} échéances` : ''}
                    </p>
                  )}
                </div>
                <span className={`text-xs px-2 py-0.5 rounded ${
                  c.statut === 'livre' ? 'bg-emerald-100 text-emerald-700' : 'bg-blue-100 text-blue-700'
                }`}>
                  {c.statut === 'livre' ? '✓ Livré' : 'En cours'}
                </span>
              </div>
            )}
          />
        } />
        <Route path="biens" element={
          <PortailECPlaceholder
            titre="Mes biens immobiliers"
            description="Biens dont vous êtes acquéreur ou propriétaire"
            endpoint="/portail/biens-acquereur"
            icon={Layers}
            comingSoonMessage="Vos biens seront listés ici avec photos, plans et état d'avancement."
            renderItem={(b: any) => (
              <div className="flex items-center gap-3 flex-wrap">
                {b.bien?.images?.[0] && (
                  <img src={b.bien.images[0]} alt={b.bien.titre}
                    className="w-20 h-20 object-cover rounded-lg flex-shrink-0" />
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900">{b.bien?.titre ?? '—'}</p>
                  <p className="text-sm text-gray-500">
                    {b.bien?.reference ?? ''}
                    {b.bien?.adresse ? ` · ${b.bien.adresse}` : (b.bien?.ville ? ` · ${b.bien.ville}` : '')}
                    {b.bien?.surface ? ` · ${b.bien.surface} m²` : ''}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">
                    Acte {b.numeroActe} · Prix : {Number(b.prixVente || 0).toLocaleString('fr-FR')} FCFA
                  </p>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded flex-shrink-0 ${
                  b.livraisonEffectuee ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'
                }`}>
                  {b.livraisonEffectuee
                    ? `Livré ${b.dateLivraison ? new Date(b.dateLivraison).toLocaleDateString('fr-FR') : ''}`
                    : 'En attente livraison'}
                </span>
              </div>
            )}
          />
        } />
        {/* Échéancier acquéreur immobilier — page dédiée avec paiement en ligne */}
        <Route path="echeancier" element={<PortailEcheancierImmoPage />} />

        {/* ── Mai 2026 — Chantier V : portail CABINET (avocat/huissier/notaire) ──
            Le justiciable consulte ses dossiers (récupérés via le bridge SIGP).
            Endpoint backend `/portail/dossiers-juridiques` à créer (proxy
            SAGeCom → SIGP-BACK GET /professionnel/dossiers/par-client/:id). */}
        <Route path="dossiers" element={
          <PortailECPlaceholder
            titre="Mes dossiers"
            description="Affaires en cours suivies par votre cabinet"
            endpoint="/portail/dossiers-juridiques"
            icon={Scale}
            comingSoonMessage="Vos dossiers apparaîtront ici dès leur ouverture par votre cabinet."
            renderItem={(d: any) => (
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900">
                    Dossier {d.numeroInterne ?? d.code ?? d.id?.slice?.(0, 8) ?? '—'}
                  </p>
                  <p className="text-sm text-gray-500">
                    {d.intitule ?? d.libelle ?? ''}
                    {d.juridiction ? ` · ${d.juridiction}` : ''}
                    {d.stadeProcedure ? ` · ${d.stadeProcedure}` : ''}
                  </p>
                  {d.avocatResponsableNom && (
                    <p className="text-xs text-gray-400 mt-0.5">
                      Avocat : {d.avocatResponsableNom}
                    </p>
                  )}
                </div>
                <span className={`text-xs px-2 py-0.5 rounded ${
                  d.statut === 'CLOTURE' ? 'bg-gray-100 text-gray-600'
                  : d.statut === 'EN_DELIBERE' ? 'bg-violet-50 text-violet-700'
                  : 'bg-emerald-50 text-emerald-700'
                }`}>
                  {d.statut ?? 'En cours'}
                </span>
              </div>
            )}
          />
        } />
        <Route path="paiements" element={
          <PortailECPlaceholder
            titre="Mes paiements"
            description="Historique de vos versements et reçus"
            endpoint="/portail/paiements-immo"
            icon={CreditCardIcon}
            comingSoonMessage="L'historique de vos paiements sera disponible ici."
            renderItem={(p: any) => (
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900">
                    Versement {p.numeroEcheance ? `— Échéance n° ${p.numeroEcheance}` : ''}
                  </p>
                  <p className="text-sm text-gray-500">
                    {p.datePaiement ? new Date(p.datePaiement).toLocaleDateString('fr-FR') : ''}
                    {p.modePaiement ? ` · ${p.modePaiement}` : ''}
                    {p.reference ? ` · Réf : ${p.reference}` : ''}
                  </p>
                </div>
                <p className="font-mono font-bold text-emerald-700">
                  {Number(p.montant || 0).toLocaleString('fr-FR')} FCFA
                </p>
              </div>
            )}
          />
        } />
        <Route path="documents" element={
          <PortailECPlaceholder
            titre="Mes documents"
            description="Acte de vente, bon de commande, PV de livraison et pièces annexes"
            endpoint="/portail/documents-immo"
            icon={FileCheck}
            comingSoonMessage="Vos documents officiels apparaîtront ici dès leur émission."
            renderItem={(d: any) => {
              const couleurType: Record<string, string> = {
                'Acte de vente':    'bg-blue-100 text-blue-700',
                'Bon de commande':  'bg-purple-100 text-purple-700',
                'PV livraison':     'bg-emerald-100 text-emerald-700',
                'Pièce annexe':     'bg-gray-100 text-gray-700',
              };
              const badgeClass = couleurType[d.type] || 'bg-gray-100 text-gray-700';
              const isPdf = (d.url || '').includes('application/pdf') || (d.nomFichier || '').toLowerCase().endsWith('.pdf');
              const isImage = (d.url || '').includes('image/') ||
                /\.(jpe?g|png|webp|gif)$/i.test(d.nomFichier || '');
              return (
                <a
                  href={d.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={d.nomFichier}
                  className="flex items-center gap-3 hover:bg-gray-50 -m-1 p-2 rounded transition"
                >
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 text-lg">
                    {isPdf ? '📄' : isImage ? '🖼️' : '📎'}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="font-medium text-gray-900 truncate">{d.libelle || d.nom || 'Document'}</p>
                      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded ${badgeClass}`}>
                        {d.type || 'Document'}
                      </span>
                    </div>
                    <p className="text-xs text-gray-500 mt-0.5">
                      {d.date ? new Date(d.date).toLocaleDateString('fr-FR') : '—'}
                      {d.contexte && ` · ${d.contexte}`}
                      {d.nomFichier && ` · ${d.nomFichier}`}
                    </p>
                  </div>
                  <span className="text-blue-600 text-xs font-medium flex-shrink-0">Ouvrir →</span>
                </a>
              );
            }}
          />
        } />

        {/* ── Onglets Template ECOLE (vie scolaire) ─────────────────────── */}
        <Route path="enfants" element={
          <PortailECPlaceholder
            titre="Mes enfants"
            description="Élèves rattachés à votre compte parent"
            endpoint="/portail/enfants"
            icon={GraduationCap}
            comingSoonMessage="Vos enfants scolarisés dans cet établissement apparaîtront ici."
          />
        } />
        <Route path="frais" element={
          <PortailECPlaceholder
            titre="Frais scolaires"
            description="Frais à régler par enfant et par trimestre"
            endpoint="/portail/frais-scolaires"
            icon={WalletIcon}
            comingSoonMessage="Les frais scolaires de vos enfants apparaîtront ici."
          />
        } />
        <Route path="bulletins" element={
          <PortailECPlaceholder
            titre="Bulletins scolaires"
            description="Bulletins trimestriels et annuels"
            endpoint="/portail/bulletins"
            icon={BookOpen}
            comingSoonMessage="Les bulletins seront disponibles dès leur publication par l'école."
          />
        } />
        <Route path="communications" element={
          <PortailECPlaceholder
            titre="Messages de l'école"
            description="Communications, convocations et notes d'information"
            endpoint="/portail/communications-ecole"
            icon={MessageSquare}
            comingSoonMessage="Les messages de l'école s'afficheront ici."
          />
        } />
      </Route>

      <Route path="/api-zone" element={<PortailApi />} />
      <Route
        path="/"
        element={
          isAuthenticated
            ? <Navigate to={defaultHome} replace />
            : HOME_VITRINE_SLUG
              // Socle « Vitrine Patronat » : remplace l'ancienne vitrine pour
              // les entités de catégorie `patronat`. La page vérifie elle-même
              // les données ; l'ancien portail reste servi aux autres tenants.
              ? <VitrinePatronatPage slug={HOME_VITRINE_SLUG} />
              : <Navigate to={defaultPublicRoute} replace />
        }
      />

      {/* Fédération sportive — vérification publique d'une licence (QR de la carte),
          et même page sans code : formulaire « numéro de licence + identifiant ».
          Couvert par PUBLIC_PATHS '/public/federation/'. */}
      <Route path="/public/federation/licence/:code" element={<VerificationLicencePage />} />
      <Route path="/public/federation/licence" element={<VerificationLicencePage />} />

      {/* Patronat/réseau — vérification publique d'un QUITUS de cotisation
          (QR du quitus : numéro + clé en query, ou saisie manuelle).
          Couvert par PUBLIC_PATHS '/public/'. */}
      <Route path="/public/verifier-quitus" element={<VerificationQuitusPage />} />

      {/* Affiliation en ligne d'une structure depuis le portail public d'une
          fédération (sans compte). Couvert par PUBLIC_PATHS '/portail/'. */}
      <Route path="/portail/:slug/federation/affiliation" element={<AffiliationFederationPage />} />
      <Route path="/portail/:slug/federation/affiliation/suivi" element={<SuiviAffiliationFederationPage />} />
      {/* Espace structure / licencié (comptes du portail abonnés) et activation par lien. Couvert par '/portail/'. */}
      <Route path="/portail/:slug/federation/espace" element={<EspaceFederationPage />} />
      <Route path="/portail/:slug/federation/activer" element={<ActivationEspaceFederationPage />} />
      {/* Évènements publiés et inscription en ligne d'une personne ; suivi par référence. Couvert par '/portail/'. */}
      <Route path="/portail/:slug/federation/evenements" element={<EvenementsFederationPublicPage />} />
      <Route path="/portail/:slug/federation/evenements/suivi" element={<SuiviInscriptionEvenementPage />} />

      {/* Vie Scolaire — écran de badgeuse (appareil appairé, sans compte). Dans PUBLIC_PATHS. */}
      <Route path="/badgeuse" element={<BadgeusePage />} />

      {/* /login : build CGE-GUI → jamais l'écran générique ; redirige vers l'espace
          approprié (adhérent → /connexion, sinon /acces-collaborateurs). */}
      {/* Pages du socle « Vitrine Patronat ». Montées dès qu'un build sert une
          vitrine à la racine — la catégorie `patronat` est vérifiée ensuite
          par le gabarit, avec la réponse de l'API. Aucun nom de tenant ici. */}
      {HOME_VITRINE_SLUG !== null && (
        <Route path="/public/services/adhesion" element={<PageAdhesion slug={HOME_VITRINE_SLUG} />} />
      )}
      {HOME_VITRINE_SLUG !== null && (
        <Route path="/public/services/suivi-demande" element={<PageSuiviDemande slug={HOME_VITRINE_SLUG} />} />
      )}
      {HOME_VITRINE_SLUG !== null && (
        <Route path="/public/phototheque" element={<PagePhototheque slug={HOME_VITRINE_SLUG} />} />
      )}

      {/* Rubriques de contenus — elles REMPLACENT les pages de l'ancien socle,
          vers lesquelles le menu menait encore. Gardées par le tenant OU la
          catégorie, pour qu'un second patronat en hérite. */}
      {(IS_CGEGUI || IS_PATRONAT) && HOME_VITRINE_SLUG !== null && (
        <>
        <Route
          path="/public/actualites"
          element={
            <PageListeContenus
              slug={HOME_VITRINE_SLUG}
              type="actualite"
              titre="Actualités"
              chapeau="Toute l'actualité de l'organisation."
              entreeId="actualites-liste"
            />
          }
        />
        <Route
          path="/public/actualites/:id"
          element={
            <PageDetailContenu
              slug={HOME_VITRINE_SLUG}
              type="actualite"
              libelleRubrique="Actualités"
              routeRubrique="/public/actualites"
              entreeId="actualites-liste"
            />
          }
        />
        <Route
          path="/public/activites"
          element={
            <PageListeContenus
              slug={HOME_VITRINE_SLUG}
              type="activite"
              titre="Activités"
              chapeau="Les activités menées par l'organisation."
              entreeId="activites"
            />
          }
        />
        <Route
          path="/public/activites/:id"
          element={
            <PageDetailContenu
              slug={HOME_VITRINE_SLUG}
              type="activite"
              libelleRubrique="Activités"
              routeRubrique="/public/activites"
              entreeId="activites"
            />
          }
        />
        <Route
          path="/public/evenements"
          element={
            <PageListeContenus
              slug={HOME_VITRINE_SLUG}
              type="evenement"
              titre="Événements"
              chapeau="Les rendez-vous à venir et passés."
              entreeId="evenements"
            />
          }
        />
        <Route
          path="/public/evenements/:id"
          element={
            <PageDetailContenu
              slug={HOME_VITRINE_SLUG}
              type="evenement"
              libelleRubrique="Événements"
              routeRubrique="/public/evenements"
              entreeId="evenements"
            />
          }
        />
        <Route
          path="/public/emissions"
          element={
            <PageListeContenus
              slug={HOME_VITRINE_SLUG}
              type="emission"
              titre="Émissions télés"
              chapeau="Les passages télévisés de l'organisation."
              entreeId="emissions"
            />
          }
        />
        <Route
          path="/public/emissions/:id"
          element={
            <PageDetailContenu
              slug={HOME_VITRINE_SLUG}
              type="emission"
              libelleRubrique="Émissions télés"
              routeRubrique="/public/emissions"
              entreeId="emissions"
            />
          }
        />
        </>
      )}

      {/* Documents, rubriques éditoriales et fédérations. Même garde : le
          tenant OU la catégorie. */}
      {(IS_CGEGUI || IS_PATRONAT) && HOME_VITRINE_SLUG !== null && (
        <>
          <Route
            path="/public/annuaire"
            element={<PageAnnuaire slug={HOME_VITRINE_SLUG} />}
          />
          <Route
            path="/public/documents"
            element={<PageDocuments slug={HOME_VITRINE_SLUG} />}
          />
          <Route
            path="/public/membres-partenaires"
            element={<PageMembresPartenaires slug={HOME_VITRINE_SLUG} />}
          />
          <Route
            path="/public/federations"
            element={<PageFederations slug={HOME_VITRINE_SLUG} />}
          />
          <Route
            path="/public/biographie-president"
            element={<PageBiographiePresident slug={HOME_VITRINE_SLUG} />}
          />
          {/* Gouvernance reprise du rapport d'activités : listes figées dans le
              code, en attendant leur passage au back-office. */}
          <Route
            path="/public/conseil-administration"
            element={<PageConseilAdministration slug={HOME_VITRINE_SLUG} />}
          />
          <Route
            path="/public/secretariat-general"
            element={<PageSecretariatGeneral slug={HOME_VITRINE_SLUG} />}
          />
          {/* Bureau et conseillers ont chacun leur liste au back-office —
              plus de filtre sur la photothèque. Chaque fiche a sa page. */}
          <Route
            path="/public/bureau-conseil-administration"
            element={
              <PagePersonnes
                slug={HOME_VITRINE_SLUG}
                titre="Bureau du Conseil d'Administration"
                chapeau="Les membres du bureau exécutif de la confédération."
                entreeId="bureau-ca"
                source="bureauCA"
                routeDetail="/public/bureau-conseil-administration"
                messageVide="La composition du bureau sera publiée prochainement."
              />
            }
          />
          <Route
            path="/public/bureau-conseil-administration/:id"
            element={
              <PageDetailPersonne
                slug={HOME_VITRINE_SLUG}
                source="bureauCA"
                libelleRubrique="Bureau du Conseil d'Administration"
                routeRubrique="/public/bureau-conseil-administration"
                entreeId="bureau-ca"
              />
            }
          />
          <Route
            path="/public/cadres-conseillers"
            element={
              <PagePersonnes
                slug={HOME_VITRINE_SLUG}
                titre="Cadres et conseillers"
                chapeau="Les femmes et les hommes qui accompagnent la confédération."
                entreeId="gouvernance"
                source="cadresConseillers"
                routeDetail="/public/cadres-conseillers"
                messageVide="Cette rubrique est en cours de constitution."
              />
            }
          />
          <Route
            path="/public/cadres-conseillers/:id"
            element={
              <PageDetailPersonne
                slug={HOME_VITRINE_SLUG}
                source="cadresConseillers"
                libelleRubrique="Cadres et conseillers"
                routeRubrique="/public/cadres-conseillers"
                entreeId="gouvernance"
              />
            }
          />
        </>
      )}

      {/* /login : build CGE-GUI → jamais l'écran générique ; redirige vers l'espace
          approprié (adhérent → /connexion, sinon /acces-collaborateurs). */}
      <Route
        path="/login"
        element={
          isAuthenticated
            ? <Navigate to={defaultHome} replace />
            : (IS_CGEGUI ? <Navigate to={loginPathForBuild()} replace /> : <Login />)
        }
      />

      {/* /login/:slug — même écran de connexion, habillé par l'identité visuelle
          de l'ENTITÉ désignée par son slug (nom, logo, couleurs lus sur
          l'endpoint public GET /portail/:slug/vitrine).

          Usage : un domaine sert une fédération dont les adhérents sont des
          sous-entités (autoecole.sag.ci → adhérent « auto-ecole-dahoue ») ;
          chacun dispose ainsi d'une porte d'entrée à ses couleurs sans build
          dédié.

          Le slug n'est QUE cosmétique : il ne restreint pas qui peut se
          connecter et n'entre pas dans la requête d'authentification. Slug
          inconnu ou appel en échec → repli silencieux sur la marque du build.
          Publique via le préfixe '/login' déjà présent dans PUBLIC_PATHS
          (la comparaison se fait en startsWith). */}
      <Route
        path="/login/:slug"
        element={
          isAuthenticated
            ? <Navigate to={defaultHome} replace />
            : (IS_CGEGUI ? <Navigate to={loginPathForBuild()} replace /> : <Login />)
        }
      />

      {/* Retour SSO SAML 2.0 (SP-initiated) — publique : lit token+refresh des
          query params puis hydrate la session. Voir PUBLIC_PATHS. */}
      <Route path="/sso/callback" element={<SsoCallback />} />

      <Route path="/unauthorized" element={<Unauthorized />} />
      {/* Changement de mot de passe obligatoire à la première connexion */}
      <Route path="/change-password" element={isAuthenticated ? <ChangePasswordFirstLogin /> : <Navigate to="/login" replace />} />

      {/* Routes protégées */}
      {/* Dashboard global : si l'utilisateur n'a pas `access_dashboard`, on
          le redirige gracieusement vers son espace personnel (qui sert de
          tableau de bord par défaut pour tout user) — pas de blocage. */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute requiredPermission="access_dashboard" fallbackPath="/mon-espace">
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ═══════════════════════════════════════════════════════════════════
          Caisse : workspace unifié avec onglets (Ventes / États / Billetage /
          Remise). Le contexte (caisse + session) est conservé lors de la
          navigation entre onglets. Les anciennes URLs continuent de fonctionner.
          ═══════════════════════════════════════════════════════════════════ */}
      <Route
        path="/caisse"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <CaisseWorkspace />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/etats"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <CaisseWorkspace />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/billetage"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <CaisseWorkspace />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/caisse/scolarite"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <CaisseWorkspace />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/caisse/annulation"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <CaisseWorkspace />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/reedition"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <CaisseWorkspace />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route legacy pour accéder directement à l'ancienne page Caisse
          (sans les onglets) — utile pour debug / compatibilité */}
      <Route
        path="/caisse/legacy"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <Caisse />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/billetages/historique"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <BilletageHistorique />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/ecarts"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <EcartCaisseValidation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/validation-annulations"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <ValidationAnnulations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/caisse/remise-banque"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <RemiseBanque />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Remises en banque — workflow détaillé (chèques, mobile money,
          virements, cartes) avec encaissement effectif et rejet de lignes.
          Distinct de /caisse/remise-banque qui gère les versements simples
          fin de journée. */}
      <Route
        path="/caisse/remises"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <RemisesEnBanque />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/stock"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout>
              <Stock />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Juin 2026 — Fiche article (vue 360°). Doit précéder les routes
          /stock/* à segment fixe — ici pas de collision, /:id capte un UUID. */}
      <Route
        path="/stock/articles/:id/fiche"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout>
              <FicheArticle />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Demandes de sortie d'articles
          IMPORTANT : permission `access_demande_sortie` (et NON access_stock)
          afin de permettre aux agents BTP / techniques / service général de
          créer leurs demandes sans avoir accès complet au module Stock. */}
      <Route
        path="/stock/demandes-sortie"
        element={
          <ProtectedRoute requiredPermission="access_demande_sortie">
            <Layout><DemandesSortieList /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/demandes-sortie/nouveau"
        element={
          <ProtectedRoute requiredPermission="create_demande_sortie">
            <Layout><DemandeSortieForm /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/demandes-sortie/:id"
        element={
          <ProtectedRoute requiredPermission="access_demande_sortie">
            <Layout><DemandeSortieDetail /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/demandes-sortie/:id/modifier"
        element={
          <ProtectedRoute requiredPermission="edit_demande_sortie">
            <Layout><DemandeSortieForm /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/motifs-sortie"
        element={
          <ProtectedRoute requiredPermission="gerer_motifs_sortie">
            <Layout><MotifsSortieAdmin /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Parc compteurs (registre EEC). Alimente le dropdown
          « N° compteur » du CR d'intervention. */}
      <Route
        path="/stock/compteurs"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout><CompteursParcPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Parc scellés (registre EEC). Alimente le dropdown
          « N° scellé » du CR d'intervention. */}
      <Route
        path="/stock/scelles"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout><ScellesParcPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Juillet 2026 — Parc transformateurs (registre EEC). */}
      <Route
        path="/stock/transformateurs"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout><TransformateursParcPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Juillet 2026 — Parc poteaux (registre EEC). */}
      <Route
        path="/stock/poteaux"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout><PoteauxParcPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/disjoncteurs"
        element={
          <ProtectedRoute requiredPermission="access_stock" requiredModule="caisse">
            <Layout><DisjoncteursParcPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Réduction des pertes non techniques (anti-fraude EDG) — cockpit +
          moteur de facturation fraude. Gate sur la facturation électrique
          (permission dédiée access_pertes_non_techniques seedable ultérieurement). */}
      <Route
        path="/pertes-non-techniques"
        element={
          <ProtectedRoute requiredAnyPermission={['access_pertes_non_techniques', 'access_facturation_electrique']} requiredModule="caisse">
            <Layout><PertesNonTechniquesPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pertes-non-techniques/facture-fraude"
        element={
          <ProtectedRoute requiredAnyPermission={['access_pertes_non_techniques', 'access_facturation_electrique']} requiredModule="caisse">
            <Layout><FactureFraudePage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pertes-non-techniques/detection"
        element={
          <ProtectedRoute requiredAnyPermission={['access_pertes_non_techniques', 'access_facturation_electrique']} requiredModule="caisse">
            <Layout><DetectionFraudePage /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/achats"
        element={
          <ProtectedRoute requiredPermission="access_achats" requiredModule="achats">
            <Layout>
              <Achats />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ══ Factures fournisseur (septembre 2026) ═══════════════════════════
          Toutes protégées par `access_factures_fournisseur`, comme le backend
          (assertLecture). Les actions d'écriture sont gardées À L'INTÉRIEUR
          des écrans par `gerer_factures_fournisseur` / `valider_facture_fournisseur` :
          consulter reste possible sans pouvoir agir.

          ⚠️ ORDRE : les segments littéraux (`nouvelle`, `a-rapprocher`) sont
          déclarés AVANT `/:id`. React Router 6 privilégie déjà le statique sur
          le dynamique, mais l'ordre explicite évite qu'un futur remaniement ne
          transforme « a-rapprocher » en identifiant de facture. */}
      <Route
        path="/factures-fournisseur"
        element={
          <ProtectedRoute requiredPermission="access_factures_fournisseur" requiredModule="achats">
            <Layout><FacturesFournisseurList /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/factures-fournisseur/a-rapprocher"
        element={
          <ProtectedRoute requiredPermission="access_factures_fournisseur" requiredModule="achats">
            <Layout><FacturesARapprocher /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/factures-fournisseur/nouvelle"
        element={
          <ProtectedRoute requiredPermission="gerer_factures_fournisseur" requiredModule="achats">
            <Layout><FactureFournisseurForm /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/factures-fournisseur/:id"
        element={
          <ProtectedRoute requiredPermission="access_factures_fournisseur" requiredModule="achats">
            <Layout><FactureFournisseurDetail /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/factures-fournisseur/:id/modifier"
        element={
          <ProtectedRoute requiredPermission="gerer_factures_fournisseur" requiredModule="achats">
            <Layout><FactureFournisseurForm /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Page publique fournisseur (lien email, sans auth) */}
      <Route path="/cotation/:token" element={<CotationPubliquePage />} />

      <Route
        path="/achats/cotations/:id"
        element={
          <ProtectedRoute requiredPermission="access_achats" requiredModule="achats">
            <Layout>
              <CotationDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/inventaire"
        element={
          <ProtectedRoute requiredPermission="access_inventaire" requiredModule="caisse">
            <Layout>
              <Inventaire />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Promotions */}
      <Route
        path="/promotions/*"
        element={
          <ProtectedRoute requiredPermission="access_promotions" requiredModule="promotions">
            <Layout>
              <Promotions />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Chantiers BTP — Pack BTP & Construction.
          Exige le droit access_chantier (gestion des chantiers) ET le module
          btp_chantier souscrit. NE PAS confondre avec access_caisse — un
          chef de service technique BTP n'a pas forcément accès à la caisse. */}
      <Route
        path="/chantiers"
        element={
          <ProtectedRoute requiredPermission="access_chantier" requiredModule="btp_chantier">
            <Layout>
              <ChantiersPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Septembre 2026 — BTP Lot 1 « Marchés & situations » (module btp_chantier).
          Les actions sont filtrées dans les écrans selon les droits fins BTP. */}
      <Route
        path="/chantiers/marches"
        element={
          <ProtectedRoute requiredAnyPermission={['access_chantier', 'gerer_marches_btp', 'admin_btp']} requiredModule="btp_chantier">
            <Layout>
              <MarchesBtpListePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chantiers/marches/:id"
        element={
          <ProtectedRoute requiredAnyPermission={['access_chantier', 'gerer_marches_btp', 'admin_btp']} requiredModule="btp_chantier">
            <Layout>
              <MarcheBtpFichePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chantiers/situations/:id"
        element={
          <ProtectedRoute requiredAnyPermission={['access_chantier', 'gerer_marches_btp', 'saisir_situation_btp', 'valider_situation_btp', 'facturer_situation_btp', 'admin_btp']} requiredModule="btp_chantier">
            <Layout>
              <SituationBtpPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chantiers/parametrage-btp"
        element={
          <ProtectedRoute requiredAnyPermission={['parametrer_btp', 'admin_btp']} requiredModule="btp_chantier">
            <Layout>
              <ParametrageBtpPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Catalogue de prestations de service (services intangibles
          vendables/achetables — distinctes des articles stockés). Accessible
          à toute entité ayant le module Achats OU Ventes. */}
      <Route
        path="/prestations"
        element={
          <ProtectedRoute requiredAnyPermission={['access_achats', 'access_caisse']}>
            <Layout>
              <PrestationsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Dashboard immobilier consolidé multi-programmes pour la DG.
          Vue analytique des programmes, marges, taux de vente, etc.
          Nécessite le module immobilier souscrit. */}
      <Route
        path="/immobilier/dashboard-consolide"
        element={
          <ProtectedRoute requiredPermission="access_immobilier" requiredModule="immobilier">
            <Layout>
              <DashboardImmoConsolide />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE CONSOLIDATION GROUPE =====
          États financiers consolidés multi-entités (IG/IP/MEE), éliminations
          intra-groupe, balance/bilan/résultat consolidés. Réservé via la
          permission access_consolidation_groupe (super_admin par bypass). */}
      <Route
        path="/consolidation"
        element={
          <ProtectedRoute requiredPermission="access_consolidation_groupe">
            <Layout>
              <ConsolidationHome />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== AGRÉGATEUR DE PAIEMENT — dashboard marchand (back-office) =====
          Marchands + clés API, création de paiements (lien/QR), transactions
          & stats. Réservé via la permission access_agregateur_paiement. */}
      <Route
        path="/agregateur"
        element={
          <ProtectedRoute requiredPermission="access_agregateur_paiement">
            <Layout>
              <AgregateurDashboardPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE ÉDITION (report-builder) =====
          Constructeur d'éditions dynamiques : source → colonnes → filtres →
          format → aperçu → génération + gestion des modèles. Lecture/aperçu/
          génération via access_edition ; écriture des modèles via
          creer_modele_edition (masqué côté UI sinon). */}
      <Route
        path="/edition"
        element={
          <ProtectedRoute requiredPermission="access_edition">
            <Layout>
              <EditionHome />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE E-LEARNING (LMS interne) =====
          Formateur (gerer_elearning) : cours / sessions / médias / QCM (+ IA).
          Apprenant (access_elearning) : mes-formations, lecteur, tuteur & résumé
          IA, QCM + attestation. Suivi (gerer_elearning) : KPIs + progression.
          Aucune route publique ici — le portail public est un lot séparé. */}
      <Route
        path="/elearning"
        element={
          <ProtectedRoute>
            <Layout>
              <ElearningTableauBord />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/elearning/formateur"
        element={
          <ProtectedRoute requiredPermission="gerer_elearning">
            <Layout>
              <ElearningFormateurCours />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/elearning/formateur/cours/:id"
        element={
          <ProtectedRoute requiredPermission="gerer_elearning">
            <Layout>
              <ElearningFormateurCoursDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/elearning/suivi"
        element={
          <ProtectedRoute requiredPermission="gerer_elearning">
            <Layout>
              <ElearningSuivi />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/elearning/mes-formations"
        element={
          <ProtectedRoute requiredPermission="access_elearning">
            <Layout>
              <ElearningMesFormations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/elearning/cours/:id"
        element={
          <ProtectedRoute requiredPermission="access_elearning">
            <Layout>
              <ElearningCoursApprenant />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Vue d'ensemble du module Électricité — page d'accueil du module.
          L'entrée « Vue d'ensemble » de la barre latérale pointe sur `routeBase`
          (= /electricite, défini au catalogue des modules) : sans cette route,
          le catch-all renvoyait au tableau de bord général.
          Le droit exigé est celui qui fait apparaître le module dans le menu —
          qui voit l'entrée peut l'ouvrir. */}
      <Route
        path="/electricite"
        element={
          <ProtectedRoute requiredPermission="access_electricite" requiredModule="electricite">
            <Layout>
              <VueEnsembleElectricitePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Consolidation Électricité — états consolidés des processus électricité
          (facturation/énergie, parc, recouvrement, prépayé, carte, indicateurs perf).
          Réservé via la permission access_consolidation_electricite + module electricite. */}
      <Route
        path="/consolidation-electricite"
        element={
          <ProtectedRoute requiredPermission="access_consolidation_electricite" requiredModule="electricite">
            <Layout>
              <ConsolidationElectriciteHome />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Admin des niveaux d'organisation (échelons hiérarchiques de consolidation).
          Réservé via la permission gerer_niveaux_organisation. */}
      <Route
        path="/niveaux-organisation"
        element={
          <ProtectedRoute requiredPermission="gerer_niveaux_organisation">
            <Layout>
              <NiveauxOrganisationAdmin />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE ÉLECTRICITÉ — CONSIGNATION =====
          Attestations de consignation réseau + actions de diffusion
          (impression PDF, email demandeur, diffusion multi-cibles).
          Réservé via access_consignation + module electricite. */}
      <Route
        path="/consignation"
        element={
          <ProtectedRoute requiredPermission="access_consignation" requiredModule="electricite">
            <Layout>
              <ConsignationListPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Module Demandes de Remboursement — électricité EDG */}
      <Route
        path="/demandes-remboursement"
        element={
          <ProtectedRoute requiredPermission="access_demande_remboursement" requiredModule="electricite">
            <Layout>
              <DemandesRemboursement />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Projets — Gestion générique de projets (études, événements,
          formations, partenariats…). Pas restreinte au module caisse. */}
      <Route
        path="/projets"
        element={
          <ProtectedRoute>
            <Layout>
              <ProjetsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Adhérents — Gestion des membres CGE-GUI / autres patronats.
          Pas de requiredModule="caisse" car les patronats n'ont pas ce module
          activé. Authentification simple suffit (filtrage métier côté backend). */}
      <Route
        path="/adherents"
        element={
          <ProtectedRoute>
            <Layout>
              <AdherentsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Routes « vie du réseau » — back-office (RéSAE). Pas de requiredModule
          (patronats/réseaux sans module caisse). Droits dédiés par brique. */}
      <Route
        path="/programmes"
        element={<ProtectedRoute requiredPermission="gerer_programmes"><Layout><ProgrammesPage /></Layout></ProtectedRoute>}
      />
      <Route
        path="/chiffres-annuels"
        element={<ProtectedRoute requiredPermission="gerer_chiffres"><Layout><ChiffresPage /></Layout></ProtectedRoute>}
      />
      <Route
        path="/opportunites"
        element={<ProtectedRoute requiredPermission="gerer_opportunites"><Layout><OpportunitesPage /></Layout></ProtectedRoute>}
      />
      <Route
        path="/registre-entrepreneurs"
        element={<ProtectedRoute requiredPermission="gerer_registre"><Layout><RegistreEntrepreneursPage /></Layout></ProtectedRoute>}
      />

      {/* Routes « vie du réseau » (suite) — back-office (RéSAE). Instances,
          éthique/sanctions, vérifications (Lot 3). Pas de requiredModule. */}
      <Route
        path="/instances"
        element={<ProtectedRoute requiredPermission="gerer_instances"><Layout><InstancesPage /></Layout></ProtectedRoute>}
      />
      <Route
        path="/ethique"
        element={<ProtectedRoute requiredPermission="gerer_ethique"><Layout><EthiquePage /></Layout></ProtectedRoute>}
      />
      <Route
        path="/verifications"
        element={<ProtectedRoute requiredPermission="gerer_verifications"><Layout><VerificationsPage /></Layout></ProtectedRoute>}
      />

      {/* Route Votes & élections — back-office (RéSAE Lot 2).
          Gestion des scrutins : création, ouverture, clôture, dépouillement.
          Droit gerer_scrutins ; pas de requiredModule (patronats sans caisse). */}
      <Route
        path="/scrutins"
        element={
          <ProtectedRoute requiredPermission="gerer_scrutins">
            <Layout>
              <ScrutinsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Vente Directe */}
      <Route
        path="/vente-directe"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <VenteSaisieDirecte />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Route Clients & Factures */}
      <Route
        path="/clients"
        element={
          <ProtectedRoute requiredPermission="access_clients" requiredModule="clients">
            <Layout>
              <Clients />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Chantier GG : module Devis CRM */}
      <Route
        path="/devis"
        element={
          <ProtectedRoute requiredPermission="access_clients">
            <Layout>
              <DevisPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE IMMOBILIER ===== */}
      <Route
        path="/immobilier"
        element={
          <ProtectedRoute requiredPermission="access_immobilier" requiredModule="immobilier">
            <Layout>
              <Immobilier />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE ASSURANCE (vente Vie / Non-vie) ===== */}
      {/* Tableau de bord consolidé Assurance — droit view_stats_assurance */}
      <Route
        path="/assurance/dashboard"
        element={
          <ProtectedRoute requiredPermission="view_stats_assurance" requiredModule="assurance">
            <Layout>
              <DashboardAssurance />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/assurance"
        element={
          <ProtectedRoute requiredPermission="access_assurance" requiredModule="assurance">
            <Layout>
              <Assurance />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Espace client assurance (abonné portail) — polices, quittances, sinistres */}
      <Route
        path="/portail-assurance"
        element={
          <ProtectedRoute>
            <Layout>
              <PortailAssuranceClient />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE LOCATION (gestion locative) ===== */}
      <Route
        path="/location"
        element={
          <ProtectedRoute requiredPermission="access_location">
            <Layout>
              <Location />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE IMMOBILISATIONS (actifs amortissables) ===== */}
      <Route
        path="/immobilisations"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <Immobilisations />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* États réglementaires SYSCOHADA — Livrable A
          Tableau immobilisations + Mouvements + Justification amortissements */}
      <Route
        path="/immobilisations/etats"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <EtatsImmobilisations />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Inventaires physiques des immobilisations — Livrable B
          Liste + scanner QR code + marquage terrain (présent/manquant/déplacé/dégradé) */}
      <Route
        path="/immobilisations/inventaires"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <InventaireImmobilisations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/immobilisations/inventaires/:id"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <InventaireDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Contrôles d'intégrité globaux — Livrable D */}
      <Route
        path="/immobilisations/integrite"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <ControleIntegriteGlobal />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Subventions d'investissement — Livrable H */}
      <Route
        path="/immobilisations/subventions"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <SubventionsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Crédit-bail / Leasing — Livrable I */}
      <Route
        path="/immobilisations/credit-bail"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <CreditBailPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Maintenance — Livrable K */}
      <Route
        path="/immobilisations/maintenance"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <MaintenancePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Garanties & Assurances — Livrable O */}
      <Route
        path="/immobilisations/garanties"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <GarantiesPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Clôture d'exercice — Livrable M */}
      <Route
        path="/immobilisations/cloture"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <ClotureExercicePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Cartographie GPS — Livrable N */}
      <Route
        path="/immobilisations/cartographie"
        element={
          <ProtectedRoute requiredPermission="access_immobilisations" requiredModule="immobilisations">
            <Layout>
              <CartographieGPSPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== ESPACE CLIENT — BACK-OFFICE ADMIN ===== */}
      <Route
        path="/administration/espace-client"
        element={
          <ProtectedRoute requiredPermission="access_espace_client_admin">
            <Layout>
              <EspaceClientAdmin />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== BOUTIQUE — COMMANDES EN LIGNE (BACK-OFFICE) ===== */}
      <Route
        path="/boutique/commandes-en-ligne"
        element={
          <ProtectedRoute requiredPermission="gerer_commandes_enligne">
            <Layout>
              <CommandesEnLignePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== BOUTIQUE — COURSIERS (équipe de livraison) =====
           Même droit que les commandes : qui traite les commandes gère les
           livreurs qui les emportent. */}
      <Route
        path="/boutique/coursiers"
        element={
          <ProtectedRoute requiredPermission="gerer_commandes_enligne">
            <Layout>
              <CoursiersPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== BOUTIQUE — STATISTIQUES DE LIVRAISON ===== */}
      <Route
        path="/boutique/statistiques-livraison"
        element={
          <ProtectedRoute requiredPermission="gerer_commandes_enligne">
            <Layout>
              <StatistiquesLivraisonPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== BOUTIQUE — SUIVI DES LIVRAISONS (vue staff + POD) =====
           Livraisons affectées aux coursiers + preuve de livraison. Même droit
           que les commandes. Le query param ?coursierId= pré-filtre la vue. */}
      <Route
        path="/boutique/suivi-livraisons"
        element={
          <ProtectedRoute requiredPermission="gerer_commandes_enligne">
            <Layout>
              <SuiviLivraisonsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== BOUTIQUE — ZONES DE LIVRAISON =====
           Secteurs desservis + commission coursier. Même droit que les commandes. */}
      <Route
        path="/boutique/zones-livraison"
        element={
          <ProtectedRoute requiredPermission="gerer_commandes_enligne">
            <Layout>
              <ZonesLivraisonPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== ROUTES POUR LES DEMANDES DE DÉCAISSEMENT ===== */}

      {/* Liste des demandes */}
      <Route
        path="/demandes-decaissement"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DemandesDecaissementList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Nouvelle demande générale */}
      <Route
        path="/demandes-decaissement/nouveau"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <NouvelleDemandeDecaissement />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Détail d'une demande */}
      <Route
        path="/demandes-decaissement/:id"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DemandesDecaissementList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Modification d'une demande */}
      <Route
        path="/demandes-decaissement/modifier/:id"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <NouvelleDemandeDecaissement />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Validation d'une demande */}
      <Route
        path="/demandes-decaissement/validation/:id"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <ValidationDemandeDecaissement />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Paiement d'une demande */}
      <Route
        path="/demandes-decaissement/paiement/:id"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DecaissementsDirectsList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Statistiques des demandes */}
      <Route
        path="/demandes-decaissement/statistiques"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DemandesDecaissementList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== ROUTES POUR LES DÉCAISSEMENTS DIRECTS ===== */}

      {/* Liste des décaissements directs */}
      <Route
        path="/decaissements-directs"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DecaissementsDirectsList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Nouveau décaissement direct */}
      <Route
        path="/decaissements-directs/nouveau"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DecaissementsDirectsList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Détail d'un décaissement direct */}
      <Route
        path="/decaissements-directs/:id"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DecaissementsDirectsList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Impression d'un décaissement direct */}
      <Route
        path="/decaissements-directs/:id/print"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DecaissementsDirectsList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Export des décaissements directs */}
      <Route
        path="/decaissements-directs/export"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DecaissementsDirectsList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== ROUTES SPÉCIFIQUES PAIEMENT FOURNISSEUR/PRESTATAIRE ===== */}

      <Route
        path="/decaissements/paiement-fournisseur"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DemandePaiementFournisseurPrestataire typeBeneficiaire="fournisseur" />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/decaissements/paiement-prestataire"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DemandePaiementFournisseurPrestataire typeBeneficiaire="prestataire" />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/decaissements/paiement-tous"
        element={
          <ProtectedRoute requiredPermission="access_decaissements" requiredModule="decaissement_workflow">
            <Layout>
              <DemandePaiementFournisseurPrestataire typeBeneficiaire="tous" />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Anciennes routes (redirection pour compatibilité) */}
      <Route
        path="/decaissements"
        element={<Navigate to="/demandes-decaissement" replace />}
      />
      <Route
        path="/decaissements/nouveau"
        element={<Navigate to="/demandes-decaissement/nouveau" replace />}
      />
      <Route
        path="/decaissements/:id"
        element={<Navigate to="/demandes-decaissement/:id" replace />}
      />
      <Route
        path="/decaissements/statistiques"
        element={<Navigate to="/demandes-decaissement/statistiques" replace />}
      />

      {/* Routes existantes */}
      <Route
        path="/statistiques"
        element={
          <ProtectedRoute requiredPermission="access_statistics" requiredModule="comptabilite">
            <Layout>
              <Statistics />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/bilan-periodique"
        element={
          <ProtectedRoute requiredPermission="access_statistics" requiredModule="comptabilite">
            <Layout>
              <BilanPeriodique />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/comptabilite"
        element={
          <ProtectedRoute requiredPermission="access_comptabilite" requiredModule="comptabilite">
            <Layout>
              <ComptabiliteOHADA />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Rééquilibrage des écritures comptables (audit + correction auto) */}
      <Route
        path="/comptabilite/rebalance"
        element={
          <ProtectedRoute requiredPermission="access_rebalance_ecritures" requiredModule="comptabilite">
            <Layout>
              <RebalanceEcritures />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/finances"
        element={
          <ProtectedRoute>
            <Layout>
              <Finances />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/sig/branchements"
        element={
          <ProtectedRoute requiredPermission="access_facturation_electrique">
            <Layout>
              <CarteBranchementsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/pilotage"
        element={
          <ProtectedRoute requiredPermission="access_pilotage">
            <Layout>
              <CentrePilotagePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/finances/couverture-change"
        element={
          <ProtectedRoute requiredPermission="manage_couverture_change">
            <Layout>
              <CouvertureChangePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/finances/cash-pooling"
        element={
          <ProtectedRoute requiredPermission="manage_cash_pooling">
            <Layout>
              <CashPoolingPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mode-couture"
        element={
          <ProtectedRoute requiredPermission="access_mode_couture">
            <Layout>
              <ModeCouturePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/administration"
        element={
          <ProtectedRoute requiredPermission="access_admin">
            <Layout>
              <React.Suspense
                fallback={
                  <div className="bg-white rounded-xl shadow-md p-12 text-center text-gray-600">
                    Chargement du module d'administration…
                  </div>
                }
              >
                <Administration />
              </React.Suspense>
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/supervision"
        element={
          <ProtectedRoute requiredPermission="access_supervision" requiredModule="supervision">
            <Layout>
              <Supervision />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/alertes"
        element={
          <ProtectedRoute requiredPermission="access_alertes">
            <Layout>
              <Alertes />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/db-sync"
        element={
          <ProtectedRoute requiredPermission="access_db_sync">
            <Layout>
              <DatabaseSyncPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* NOTE : la route par défaut "/" est définie plus haut (ligne ~200)
          et redirige vers /landing pour les non-authentifiés (pas vers /login).
          Cette duplicata a été supprimée pour éviter d'écraser la première
          et provoquer une redirection automatique non désirée vers /login. */}

      {/* ===== ROUTES RH ===== */}

      {/* Dashboard RH */}
      <Route
        path="/rh/dashboard"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <DashboardRH />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Mai 2026 — Chantier JJ-1 : tableau de bord RH (multi-vues inspiré TDB 2017) */}
      <Route
        path="/rh/tableau-de-bord"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <RhDashboardPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Mai 2026 — Chantier KK-2 : paiement salaires espèces depuis bordereau */}
      <Route
        path="/caisse/paiement-salaires"
        element={
          <ProtectedRoute requiredPermission="access_caisse" requiredModule="caisse">
            <Layout>
              <PaiementSalairesCaisse />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Mai 2026 — Chantier MM-2 : réconciliation bancaire admin */}
      <Route
        path="/admin/bancaire-reconciliation"
        element={
          <ProtectedRoute requiredPermission="access_finances">
            <Layout>
              <BancaireReconciliation />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* MM-16 — Mes tâches workflow (filtre par profil acteur) */}
      <Route
        path="/mes-taches"
        element={
          <ProtectedRoute>
            <Layout>
              <MesTachesPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rh/alertes"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <AlertesRH />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Demandes RH — hub centralisé */}
      <Route
        path="/rh/demandes"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <DemandesRH />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Demandes de document RH (certificat, attestation, CNPS, duplicata) */}
      <Route
        path="/rh/demandes-documents"
        element={
          <ProtectedRoute requiredPermission="access_demandes_documents" requiredModule="rh">
            <Layout>
              <DemandesDocuments />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Bordereaux de paiement d'allocations de stage */}
      <Route
        path="/rh/bordereaux-stages"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <BordereauxStages />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Employés */}
      <Route
        path="/rh/employes"
        element={
          <ProtectedRoute requiredPermission="access_employes" requiredModule="rh">
            <Layout>
              <ListeEmployes />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/employes/nouveau"
        element={
          <ProtectedRoute requiredPermission="create_employe" requiredModule="rh">
            <Layout>
              <NouvelEmploye />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/employes/:id"
        element={
          <ProtectedRoute requiredPermission="access_employes" requiredModule="rh">
            <Layout>
              <FicheEmploye />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/employes/:id/modifier"
        element={
          <ProtectedRoute requiredPermission="edit_employe" requiredModule="rh">
            <Layout>
              <ModifierEmploye />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Contrats */}
      <Route
        path="/rh/contrats"
        element={
          <ProtectedRoute requiredPermission="access_contrats" requiredModule="rh">
            <Layout>
              <ListeContrats />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/contrats/nouveau"
        element={
          <ProtectedRoute requiredPermission="create_contrat" requiredModule="rh">
            <Layout>
              <NouveauContrat />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Import d'un contrat depuis un PDF — DOIT être avant /rh/contrats/:id
          pour éviter que le segment "import" soit capté comme un :id */}
      {/* Import de contrat PDF — garde alignee sur celle de l API
          (import_contrat_rh). Gardee par access_contrats, l entree de menu
          s affichait a des utilisateurs que le backend refusait ensuite :
          « Forbidden resource » apres le choix du fichier. */}
      <Route
        path="/rh/contrats/import"
        element={
          <ProtectedRoute requiredPermission="import_contrat_rh">
            <Layout>
              <ImportContratPdfPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/contrats/:id"
        element={
          <ProtectedRoute requiredPermission="access_contrats" requiredModule="rh">
            <Layout>
              <DetailContrat />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/contrats/:id/modifier"
        element={
          <ProtectedRoute requiredPermission="create_contrat" requiredModule="rh">
            <Layout>
              <NouveauContrat />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Paie */}
      <Route
        path="/rh/paie"
        element={
          <ProtectedRoute requiredPermission="access_paie" requiredModule="rh">
            <Layout>
              <DashboardPaie />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/paie/generation"
        element={
          <ProtectedRoute requiredPermission="generate_paie" requiredModule="rh">
            <Layout>
              <GenerationPaie />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/paie/historique"
        element={
          <ProtectedRoute requiredPermission="access_paie" requiredModule="rh">
            <Layout>
              <HistoriquePaie />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/paie/bulletin/:id"
        element={
          <ProtectedRoute requiredPermission="access_paie" requiredModule="rh">
            <Layout>
              <BulletinPaieDetail />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/paie/bulletin/:id/edit"
        element={
          <ProtectedRoute requiredPermission="access_paie" requiredModule="rh">
            <Layout>
              <EditBulletinPaie />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/paie/virements"
        element={<Navigate to="/rh/paie/bordereau-paiement" replace />}
      />

      <Route
        path="/rh/paie/bordereau-paiement"
        element={
          <ProtectedRoute requiredPermission="access_paie" requiredModule="rh">
            <Layout>
              <BordereauPaiement />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/paie/ecritures-comptables"
        element={
          <ProtectedRoute requiredPermission="access_paie" requiredModule="rh">
            <Layout>
              <EcrituresComptablesPaie />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Rémunération des mandataires sociaux (gérants non salariés) */}
      <Route
        path="/rh/remuneration-mandataires"
        element={
          <ProtectedRoute requiredPermission="view_remuneration_mandataires" requiredModule="rh">
            <Layout>
              <RemunerationMandatairesPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Congés — accessible à tous les employés */}
      <Route
        path="/rh/conges"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <DemandesConges />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/conges/calendrier"
        element={
          <ProtectedRoute requiredPermission="view_calendrier_conges" requiredModule="rh">
            <Layout>
              <CalendrierConges />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/conges/validation"
        element={
          <ProtectedRoute requiredPermission="validate_conge" requiredModule="rh">
            <Layout>
              <ValidationConges />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/conges/nouveau"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <NouvelleDemandeConge />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Absences — accessible à tous les employés */}
      <Route
        path="/rh/absences"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <DemandesAbsences />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/absences/nouvelle"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <NouvelleDemandeAbsence />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Recrutement */}
      <Route
        path="/rh/recrutement"
        element={
          <ProtectedRoute requiredPermission="access_recrutement" requiredModule="rh">
            <Layout>
              <RecrutementModule />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/recrutement/candidatures"
        element={
          <ProtectedRoute requiredPermission="manage_candidatures" requiredModule="rh">
            <Layout>
              <Candidatures />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/recrutement/candidatures/:id"
        element={
          <ProtectedRoute requiredPermission="manage_candidatures" requiredModule="rh">
            <Layout>
              <DetailCandidature />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/recrutement/entretiens"
        element={
          <ProtectedRoute requiredPermission="plan_entretiens" requiredModule="rh">
            <Layout>
              <Entretiens />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Évaluations */}
      <Route
        path="/rh/evaluations"
        element={
          <ProtectedRoute requiredPermission="access_evaluations_rh" requiredModule="rh">
            <Layout>
              <ListeEvaluations />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/evaluations/nouveau"
        element={
          <ProtectedRoute requiredPermission="create_evaluation_rh" requiredModule="rh">
            <Layout>
              <NouvelleEvaluation />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/evaluations/:id"
        element={
          <ProtectedRoute requiredPermission="access_evaluations_rh" requiredModule="rh">
            <Layout>
              <DetailEvaluation />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Formations — accessible à tous les employés */}
      <Route
        path="/rh/formations"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <CatalogueFormations />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Demande de formation — DOIT être avant /rh/formations/:id pour éviter le conflit */}
      <Route
        path="/rh/formations/nouveau"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <NouvelleDemandeFormation />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/formations/:id/inscriptions"
        element={
          <ProtectedRoute requiredPermission="manage_inscriptions" requiredModule="rh">
            <Layout>
              <InscriptionsFormation />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/rh/formations/:id"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <DetailFormation />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mise à disponibilité */}
      <Route
        path="/rh/disponibilite"
        element={
          <ProtectedRoute requiredPermission="access_disponibilite" requiredModule="rh">
            <Layout>
              <DemandeDisponibilite />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Démissions */}
      <Route
        path="/rh/demissions"
        element={
          <ProtectedRoute requiredPermission="access_demission" requiredModule="rh">
            <Layout>
              <GestionDemissions />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Disciplinaire */}
      <Route
        path="/rh/disciplinaire"
        element={
          <ProtectedRoute requiredPermission="manage_rh_params" requiredModule="rh">
            <Layout>
              <ProcedureDisciplinaire />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Pointage / Time tracking */}
      <Route
        path="/rh/pointage"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <PointagePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mai 2026 — Bordereaux journaliers (paie hebdomadaire) */}
      <Route
        path="/rh/bordereaux-journaliers"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <BordereauxJournaliers />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Organismes sociaux */}
      <Route
        path="/rh/organismes-sociaux"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <OrganismesSociaux />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Team Building */}
      <Route
        path="/rh/team-building"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <TeamBuilding />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Organisation RH */}
      <Route
        path="/rh/organisation"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <OrganisationRH />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Fiches de poste */}
      <Route
        path="/rh/organisation/postes/nouveau"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <FichePoste />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rh/organisation/postes/:id"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <FichePoste />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Enquêtes internes RH */}
      <Route
        path="/rh/enquetes"
        element={
          <ProtectedRoute requiredPermission="access_enquetes_rh" requiredModule="rh">
            <Layout>
              <EnquetesRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Événements internes RH */}
      <Route
        path="/rh/evenements"
        element={
          <ProtectedRoute requiredPermission="access_evenements_rh" requiredModule="rh">
            <Layout>
              <EvenementsRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Annonces RH */}
      <Route
        path="/rh/annonces"
        element={
          <ProtectedRoute requiredPermission="access_annonces_rh" requiredModule="rh">
            <Layout>
              <AnnoncesRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Documents d'entreprise — droit dédié.
          Cet écran est destiné à TOUS les collaborateurs (règlement intérieur,
          conventions collectives, notes de service…). Exiger `access_rh` en
          réservait l'accès aux gestionnaires RH, alors que le droit
          `access_documents_entreprise` existe et leur est bien accordé. */}
      <Route
        path="/rh/documents-entreprise"
        element={
          <ProtectedRoute requiredPermission="access_documents_entreprise">
            <Layout>
              <DocumentsEntreprisePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== DOSSIER MÉDICAL ===== */}
      {/* Mon dossier — tous les employés authentifiés */}
      <Route
        path="/rh/medical/mon-dossier"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <MonDossierMedical />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Liste des dossiers — médecin */}
      <Route
        path="/rh/medical"
        element={
          <ProtectedRoute requiredAnyPermission={['access_dossier_medical', 'acces_medecine_travail']} requiredModule="rh">
            <Layout>
              <RhMedicalList />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Dossier complet d'un employé — médecin */}
      <Route
        path="/rh/medical/dossier/:employeId"
        element={
          <ProtectedRoute requiredAnyPermission={['access_dossier_medical', 'acces_medecine_travail']} requiredModule="rh">
            <Layout>
              <RhDossierMedical />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Arrêts maladie — médecin + RH + manager (filtrés côté API) */}
      <Route
        path="/rh/medical/arrets"
        element={
          <ProtectedRoute requiredPermission="authenticated" requiredModule="authenticated">
            <Layout>
              <ArretsMaladie />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Événements internes RH */}
      <Route
        path="/rh/evenements"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <EvenementsRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Annonces RH */}
      <Route
        path="/rh/annonces"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <AnnoncesRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Documents d'entreprise */}
      <Route
        path="/rh/documents-entreprise"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <DocumentsEntreprisePage />
            </Layout>
          </ProtectedRoute>
        }
      />


      {/* États RH — hub des rapports / éditions */}
      <Route
        path="/rh/etats"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <EtatsRHHub />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Campagnes de primes — mai 2026 */}
      <Route
        path="/rh/campagnes-primes"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <CampagnesPrimes />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Fiches de postes */}
      <Route
        path="/rh/gpec/fiches-postes"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecFichesPostesPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Matrice des compétences */}
      <Route
        path="/rh/gpec/matrice-competences"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecMatriceCompetencesPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Profils de carrière */}
      <Route
        path="/rh/gpec/profils-carriere"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecProfilsCarrierePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Plans de succession */}
      <Route
        path="/rh/gpec/succession"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecSuccessionPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Talents & Nine Box */}
      <Route
        path="/rh/gpec/talents"
        element={
          <ProtectedRoute requiredPermission="access_gpec_talents">
            <Layout>
              <GpecTalentsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Matrice des risques RH */}
      <Route
        path="/rh/gpec/risques"
        element={
          <ProtectedRoute requiredPermission="access_risques_rh">
            <Layout>
              <GpecRisquesRhPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Feedback 360° */}
      <Route
        path="/rh/gpec/feedback-360"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecFeedback360Page />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Mobilité et carrière */}
      <Route
        path="/rh/gpec/mobilite-interne"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecMobiliteCarrierePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — États & Rapports */}
      <Route
        path="/rh/gpec/etats"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecEtatsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Self Service — Mes collaborateurs (N-1 directs) */}
      <Route
        path="/mon-espace/mes-collaborateurs"
        element={
          <ProtectedRoute>
            <Layout>
              <MesCollaborateursPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Petit matériel — biens passés en charge mais remis aux agents, et
          seuil d'immobilisation. Le contrôle des droits est fait par le serveur. */}
      <Route
        path="/rh/petit-materiel"
        element={
          <ProtectedRoute>
            <Layout>
              <PetitMaterielPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Self Service — Mes projets.
          Sans permission exigée ici : un simple membre d'équipe doit pouvoir
          consulter le projet auquel il contribue. Le serveur ne renvoie que
          les projets de l'appelant, et refuse la modification à qui n'en est
          ni responsable ni chef de projet. */}
      <Route
        path="/mon-espace/mes-projets"
        element={
          <ProtectedRoute>
            <Layout>
              <MesProjetsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Évaluation / Performance — Lot 3 (objectifs, auto-éval, éval manager, pilotage RH) */}
      <Route
        path="/evaluation-performance"
        element={
          <ProtectedRoute requiredPermission="access_evaluation_performance">
            <Layout>
              <EvaluationPerformancePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Politique de sécurité — règles mot de passe / connexion / 2FA de l'entité.
          Réservé via la permission access_politique_securite (édition = manage_politique_securite). */}
      <Route
        path="/securite/politique"
        element={
          <ProtectedRoute requiredPermission="access_politique_securite">
            <Layout>
              <PolitiqueSecuritePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Délégations & Intérims */}
      <Route
        path="/rh/delegations"
        element={
          <ProtectedRoute requiredPermission="access_rh" requiredModule="rh">
            <Layout>
              <Delegations />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mes Délégations & Intérims (Mon Espace employé) */}
      <Route
        path="/rh/mes-delegations"
        element={
          <ProtectedRoute requiredModule="rh">
            <Layout>
              <MesDelegations />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mon équipe (N-1) — visible par tout employé authentifié */}
      <Route
        path="/rh/mon-equipe"
        element={
          <ProtectedRoute requiredModule="rh">
            <Layout>
              <MonEquipePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Mes collègues — même niveau hiérarchique */}
      <Route
        path="/rh/mes-collegues"
        element={
          <ProtectedRoute requiredModule="rh">
            <Layout>
              <MesColleguesRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Annuaire / Trombinoscope global */}
      <Route
        path="/rh/annuaire"
        element={
          <ProtectedRoute requiredModule="rh">
            <Layout>
              <AnnuaireRHPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* GPEC — Mobilité interne */}
      <Route
        path="/rh/gpec/mobilite-interne"
        element={
          <ProtectedRoute requiredPermission="access_rh">
            <Layout>
              <GpecMobiliteInternePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Paramètres RH */}
      <Route
        path="/rh/parametres"
        element={
          <ProtectedRoute requiredPermission="manage_rh_params" requiredModule="rh">
            <Layout>
              <ParametresRH />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* ===== MODULE CRM — Rapports d'activité commerciale ===== */}
      <Route
        path="/crm"
        element={
          <ProtectedRoute requiredAnyPermission={['access_clients', 'voir_dashboard_crm']} requiredModule="clients">
            <Layout><DashboardCRM /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/rapports"
        element={
          <ProtectedRoute requiredPermission="access_clients" requiredModule="clients">
            <Layout><ListeRapports /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/rapports-a-valider"
        element={
          <ProtectedRoute requiredPermission="valider_rapport_crm" requiredModule="clients">
            <Layout><RapportsAValider /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/etat-activite"
        element={
          <ProtectedRoute requiredPermission="voir_etat_activite_crm" requiredModule="clients">
            <Layout><EtatActiviteCommerciale /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/rapports/nouveau"
        element={
          <ProtectedRoute requiredPermission="access_clients" requiredModule="clients">
            <Layout><NouveauRapport /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/rapports/:id"
        element={
          <ProtectedRoute requiredPermission="access_clients" requiredModule="clients">
            <Layout><NouveauRapport /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/rapports/:id/modifier"
        element={
          <ProtectedRoute requiredPermission="access_clients" requiredModule="clients">
            <Layout><NouveauRapport /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Prospects (leads inbound) ===== */}
      <Route
        path="/crm/prospects"
        element={
          <ProtectedRoute requiredPermission="access_prospects" requiredModule="clients">
            <Layout><ProspectsList /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Pipeline commercial (Kanban + KPIs de conversion) ===== */}
      <Route
        path="/crm/pipeline"
        element={
          <ProtectedRoute requiredPermission="access_crm" requiredModule="clients">
            <Layout><PipelineCommercialPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Rétention & santé client (score, churn, renouvellements) ===== */}
      <Route
        path="/crm/retention"
        element={
          <ProtectedRoute requiredPermission="access_crm" requiredModule="clients">
            <Layout><RetentionSantePage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Fidélité & parrainage (ambassadeurs, recommandations, upsell) ===== */}
      <Route
        path="/crm/fidelite"
        element={
          <ProtectedRoute requiredPermission="access_crm" requiredModule="clients">
            <Layout><FideliteParrainagePage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Engagement & relances (qualification MQL/SQL + moteur) ===== */}
      <Route
        path="/crm/engagement"
        element={
          <ProtectedRoute requiredPermission="access_crm" requiredModule="clients">
            <Layout><EngagementRelancesPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Acquisition & coûts (coût par lead + taux de réponse ventilé) ===== */}
      <Route
        path="/crm/acquisition"
        element={
          <ProtectedRoute requiredPermission="access_crm" requiredModule="clients">
            <Layout><AcquisitionCoutsPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Branchements & Abonnements (vues globales) ===== */}
      <Route
        path="/crm/branchements"
        element={
          <ProtectedRoute requiredPermission="access_branchements">
            <Layout><BranchementsListPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/abonnements"
        element={
          <ProtectedRoute requiredPermission="access_abonnements">
            <Layout><AbonnementsListPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Réclamations client (PHASE 1) =====
          Point d'entrée + liste des demandes RECL_* (redressement / étalonnage
          BT-MT). Réutilise le moteur de demande générique : création via
          /demandes/nouvelle/:typeCode, détail via /demandes/:id.
          Gate sur le droit dédié `access_reclamations` (accordé aux profils
          CRM / admin) — distinct de `access_demandes_client`. */}
      <Route
        path="/crm/reclamations"
        element={
          <ProtectedRoute requiredPermission="access_reclamations">
            <Layout><ReclamationsPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Barème des frais d'étalonnage (référentiel paramétrable) =====
          UI d'admin du barème : montant facturé selon usage / réseau / tranche
          de puissance. Modifiable sans toucher au code ; appliqué immédiatement
          au calcul des réclamations d'étalonnage.
          Gate sur le droit dédié `gerer_frais_etalonnage`. */}
      <Route
        path="/crm/reclamations/bareme-etalonnage"
        element={
          <ProtectedRoute requiredPermission="gerer_frais_etalonnage">
            <Layout><BaremeFraisEtalonnagePage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Enquêtes de satisfaction EEC ===== */}
      <Route
        path="/crm/enquetes-satisfaction"
        element={
          <ProtectedRoute requiredPermission="access_demandes_client">
            <Layout><EnquetesSatisfactionPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Bilan satisfaction ===== */}
      <Route
        path="/crm/enquetes-satisfaction/bilan"
        element={
          <ProtectedRoute requiredPermission="access_demandes_client">
            <Layout><BilanEnquetesSatisfactionPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Suivi des actions correctives ===== */}
      <Route
        path="/crm/enquetes-satisfaction/suivi-actions"
        element={
          <ProtectedRoute requiredPermission="access_demandes_client">
            <Layout><SuiviActionsEnquetesPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== CRM — Dossiers de vente (suivi commercial post-acte) ===== */}
      <Route
        path="/crm/dossiers-vente"
        element={
          <ProtectedRoute requiredPermission="access_dossiers_vente" requiredModule="clients">
            <Layout><DossiersVenteList /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/dossiers-vente/mes-actions"
        element={
          <ProtectedRoute requiredPermission="access_dossiers_vente" requiredModule="clients">
            <Layout><MesActionsCommerciales /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/dossiers-vente/:id"
        element={
          <ProtectedRoute requiredPermission="access_dossiers_vente" requiredModule="clients">
            <Layout><DossierVenteDetail /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/clients/:clientId/fiche"
        element={
          <ProtectedRoute requiredPermission="access_clients" requiredModule="clients">
            <Layout><FicheClient360 /></Layout>
          </ProtectedRoute>
        }
      />
      {/* MM-112 — Vue 360 SPÉCIFIQUE utility (EEC/SEG) — séparée de FicheClient360 CRM */}
      <Route
        path="/clients/:id/vue-360"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout><ClientVue360UtilityPage /></Layout>
          </ProtectedRoute>
        }
      />
      {/* MM-118 — Confirmation publique du droit d'entrée (PAS d'auth, token JWT dans URL) */}
      <Route
        path="/public/droit-entree/:token"
        element={<ConfirmationDroitEntreePage />}
      />
      {/* AGEE — Accord public frais de dossier (PAS d'auth, token JWT dans URL) */}
      <Route
        path="/public/agee/frais-dossier/:token"
        element={<PublicAgeeFraisDossier />}
      />
      {/* MM-119 — Paiement public du droit d'entrée (PAS d'auth, token JWT 30j) */}
      <Route
        path="/public/paiement/:token"
        element={<PaiementDroitEntreePage />}
      />
      {/* Carte de visite digitale — page PUBLIQUE (PAS d'auth) : URL encodée dans le QR */}
      <Route
        path="/public/carte/:slug"
        element={<CartePubliquePage />}
      />
      {/* MM-117b — Page admin paramétrage barèmes frais d'entrée */}
      <Route
        path="/admin/baremes-frais-entree"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout><BaremesFraisEntreePage /></Layout>
          </ProtectedRoute>
        }
      />
      {/* WS-Variantes V2c — Conventions de subvention (branchements subventionnés) */}
      <Route
        path="/admin/conventions-subvention"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout><ConventionsSubventionPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/objectifs"
        element={
          <ProtectedRoute requiredPermission="gerer_objectifs_crm" requiredModule="clients">
            <Layout><ObjectifsAgents /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/planning"
        element={
          <ProtectedRoute requiredPermission="access_planning_activite" requiredModule="clients">
            <Layout><PlanningActivite /></Layout>
          </ProtectedRoute>
        }
      />
      {/* Mai 2026 — Hub unifié des états CRM (équivalent /achats/etats) */}
      <Route
        path="/crm/etats"
        element={
          <ProtectedRoute requiredPermission="voir_etats_crm" requiredModule="clients">
            <Layout><EtatsCrmPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Mon profil — accessible à tout utilisateur connecté */}
      <Route
        path="/profil"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MonProfil />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ── Tableau des Tâches (toutes tâches affectées à l'utilisateur) ────── */}
      <Route
        path="/tableau-taches"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <TableauTaches />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ── Carte de visite digitale (back-office, droit gerer_cartes_visite) ─ */}
      <Route
        path="/cartes-visite"
        element={
          <ProtectedRoute requiredPermission="gerer_cartes_visite">
            <Layout><CartesVisitePage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* ── Espace adhérent (organisation membre d'un patronat) ───────────── */}
      <Route
        path="/espace-adherent"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <LayoutEspaceAdherent />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="accueil" replace />} />
        <Route path="accueil" element={<AccueilAdherent />} />
        <Route path="adhesion" element={<MonAdhesion />} />
        <Route path="dossier" element={<MonDossierAdherent />} />
        <Route path="ma-carte" element={<MaCartePage />} />
        <Route path="communication" element={<CommunicationAdherent />} />
        <Route path="activites" element={<MesActivitesAdherent />} />
        <Route path="commissions" element={<MesCommissionsAdherent />} />
        <Route path="courriers" element={<MesCourriersAdherent />} />
        <Route path="finances" element={<MesFinancesAdherent />} />
        <Route path="convocations" element={<MesConvocationsAdherent />} />
        <Route path="sanctions" element={<MesSanctionsAdherent />} />
        <Route path="programmes" element={<MesProgrammesAdherent />} />
        <Route path="chiffres" element={<MesChiffresAdherent />} />
        <Route path="opportunites" element={<MesOpportunitesAdherent />} />
        <Route path="entrepreneurs" element={<MesEntrepreneursAdherent />} />
        <Route path="votes" element={<MesVotesAdherent />} />
        {/* Démarches du membre vers son organisation. Les écrans sont inertes
            pour une organisation qui n'a publié aucun type : la liste est
            vide et aucune entrée de menu n'y mène. */}
        <Route path="solliciter" element={<SolliciterAdherent />} />
        <Route path="sollicitations" element={<MesSollicitationsAdherent />} />
      </Route>

      {/* ── Mon Espace (self-service employé) ──────────────────────────────── */}
      <Route
        path="/mon-espace"
        element={
          estAdherent ? <Navigate to="/espace-adherent/accueil" replace /> : (
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MonEspaceHub />
            </Layout>
          </ProtectedRoute>
          )
        }
      />

      <Route
        path="/mon-espace/mes-demandes"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesDemandes />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mon-espace/bulletins"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesBulletins />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Listes Mon espace */}
      <Route
        path="/mon-espace/acomptes"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesAcomptes />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/prets"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesPrets />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/achats"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesAchats />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Fiche employe perso */}
      <Route
        path="/mon-espace/ma-fiche"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <FicheEmploye />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/ma-fiche-de-poste"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MaFicheDePoste />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/ma-fiche/modifier"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <ModifierEmploye />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/evaluations"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesEvaluations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/mon-cv"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MonCv />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Self Service — Mes enquêtes (répondre + historique) */}
      <Route
        path="/mon-espace/mes-enquetes"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesEnquetesPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/mes-objectifs"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MesObjectifs />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Relations sociales : syndicats, conflits collectifs, contentieux.
          Trois droits distincts, filtrés onglet par onglet dans la page. */}
      <Route
        path="/rh/relations-sociales"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <RelationsSocialesPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Mesures affectant le contrat : sanctions, procédures, départs, économique. */}
      <Route
        path="/rh/mesures"
        element={
          <ProtectedRoute requiredPermission="access_disciplinaire">
            <Layout>
              <MesuresPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Réunions et suivi des résolutions — indépendant des campagnes. */}
      <Route
        path="/gouvernance"
        element={
          <ProtectedRoute requiredPermission="access_gouvernance">
            <Layout>
              <GouvernancePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Regroupe entretiens, objectifs, auto-évaluation, évaluation N+1 et bilan. */}
      <Route
        path="/mon-espace/ma-carriere"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MaCarriere />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mon-espace/demission"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <MaDemission />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Formulaires Mon espace */}
      <Route
        path="/mon-espace/acompte"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <DemandeAcompte />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mon-espace/pret"
        element={
          <ProtectedRoute requiredPermission="authenticated">
            <Layout>
              <DemandePret />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mon-espace/portail-applications"
        element={
          <ProtectedRoute>
            <Layout>
              <PortailApplications />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* ===== MODULE VIE SCOLAIRE ===== */}
      <Route path="/vie-scolaire" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><VieScolaireHome /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/badges" element={
        <ProtectedRoute requiredModule="vie_scolaire" requiredAnyPermission={['access_sco_badges', 'gerer_sco_badges', 'gerer_sco_badgeuses', 'traiter_alertes_presence']}>
          <Layout><BadgesPresencesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/ecoles/:ecoleId" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><EcoleDetailPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/cursus/:cursusId" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><CursusDetailPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/cursus/:cursusId/programme" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><CursusProgrammePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/ecoles/:ecoleId/annees" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><EcoleAnneesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/annees-scolaires/:anneeId" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><AnneeScolaireDetailPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/promotions/:promotionId" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><PromotionDetailPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/classes/:classeId" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><ClasseDetailPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/classes/:classeId/notes/:evalId" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><NotesGridPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/promotions/:promotionId/diplomes" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><DiplomesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/remises" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><RemisesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/vie-scolaire/besoins-speciaux" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><RepertoireBesoinsSpeciaux /></Layout>
        </ProtectedRoute>
      } />

      {/* Inscription démo Vie Scolaire (publique, sans JWT, accessible depuis QR code email) */}
      <Route path="/demo-vie-scolaire" element={<DemoVieScolairePage />} />

      {/* Mot de passe oublié (pages publiques, pas de JWT) */}
      <Route path="/mot-de-passe-oublie" element={<MotDePasseOubliePage />} />
      <Route path="/reinitialiser-mot-de-passe" element={<ReinitialiserMotDePassePage />} />

      {/* Retour après paiement PSP (publique) */}
      <Route path="/paiement/retour" element={<PaiementRetourPage />} />

      {/* Retour dédié CinetPay (publique) — utilise /cinetpay/verifier/:id */}
      <Route path="/cinetpay/retour" element={<PaiementRetour />} />

      {/* Historique CinetPay (admin) */}
      <Route path="/admin/cinetpay/historique" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><HistoriqueCinetPay /></Layout>
        </ProtectedRoute>
      } />

      {/* Gestion administrative des paiements */}
      <Route path="/admin/paiements" element={
        <ProtectedRoute>
          <Layout><PaiementsAdminPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Réédition de compte (libération des cautions) */}
      <Route path="/admin/reedition-compte" element={
        <ProtectedRoute>
          <Layout><ReeditionComptePage /></Layout>
        </ProtectedRoute>
      } />

      {/* Dashboard Transmissions FNE DGI */}
      <Route path="/admin/fne-transmissions" element={
        <ProtectedRoute>
          <Layout><FneTransmissionsPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Paramétrage du connecteur FNE (DGI Côte d'Ivoire) — lecture gardée par
          `access_fne`, l'édition est gardée dans la page par `gerer_fne`. */}
      <Route path="/parametrage/fne" element={
        <ProtectedRoute requiredPermission="access_fne">
          <Layout><FneConfigPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Bridge SAGeCom — service tokens M2M + webhook subscriptions + audit deliveries.
          Permission `manage_bridge` (super_admin uniquement par défaut). */}
      <Route path="/admin/bridge" element={
        <ProtectedRoute requiredAnyPermission={['manage_bridge', 'access_interfacage']}>
          <Layout><BridgeAdmin /></Layout>
        </ProtectedRoute>
      } />

      {/* Référentiel des coupures (billets / pièces) — admin */}
      <Route path="/admin/coupures" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><ReferentielCoupures /></Layout>
        </ProtectedRoute>
      } />

      {/* Référentiel des devises (ISO 4217) — super_admin pour CRUD,
          lecture seule pour les autres admins */}
      <Route path="/admin/referentiel-devises" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><ReferentielDevises /></Layout>
        </ProtectedRoute>
      } />

      {/* Référentiels applicatifs génériques (modules, journaux, sens,
          catégories, moyens de paiement…) — gestion centralisée */}
      <Route path="/admin/referentiels" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><ReferentielsAdmin /></Layout>
        </ProtectedRoute>
      } />

      {/* Configuration des modèles de documents PDF (devis, facture, BC,
          reçu, BL) par entité — style par défaut + overrides + en-tête PDF */}
      <Route path="/admin/templates-documents" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><DocumentTemplatesPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Module Développeur — Configuration avancée des types d'opération
          (workflow, formulaire, ACL, notifications, transitions). */}
      <Route path="/admin/dev/types-operation" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><DevTypesOperation /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/admin/dev/types-operation/:code" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><DevTypesOperation /></Layout>
        </ProtectedRoute>
      } />
      {/* MM-33 — Module Développeur : Templates de formulaires d'étape */}
      <Route path="/admin/form-templates" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><FormTemplatesPage /></Layout>
        </ProtectedRoute>
      } />
      {/* MM-28 / MM-50 — Catalogue Demandes client par entité.
          Permission dédiée access_demandes_client (auto-attribuée à
          super_admin/admin/manager + attribuable à tout profil custom). */}
      {/* Catalogue des processus métier : point d'entrée pour DÉMARRER une
          demande, donc ouvert à tout utilisateur connecté. Les actions de
          paramétrage (Configurer / Aperçu) restent gardées par `access_admin`
          dans la page elle-même. */}
      <Route path="/admin/demandes-client" element={
        <ProtectedRoute requiredPermission="authenticated">
          <Layout><DemandesClientPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Module Développeur — Gestion des modules SAGeCom */}
      <Route path="/admin/dev/modules" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><DevModules /></Layout>
        </ProtectedRoute>
      } />
      {/* Saisie générique d'une demande à partir du DevMode (formConfig dynamique) */}
      <Route path="/demandes/nouvelle/:typeCode" element={
        <ProtectedRoute>
          <Layout><NouvelleDemandeGenerique /></Layout>
        </ProtectedRoute>
      } />
      {/* MM-124 — Saisie du CR Étude Terrain (workflow EEC, étape cr_activite).
          DOIT être déclarée AVANT /demandes/:id car React Router matche en
          ordre — sinon `:id` capterait "cr-etude-terrain". */}
      <Route path="/demandes/:demandeId/cr-etude-terrain" element={
        <ProtectedRoute>
          <Layout><SaisieCREtudeTerrainPage /></Layout>
        </ProtectedRoute>
      } />
      {/* EEC 5.17 — Saisie du CR d'Intervention (workflow EEC, étape cr_intervention).
          Déclarée AVANT /demandes/:id (cf. note ci-dessus). */}
      <Route path="/demandes/:demandeId/cr-intervention" element={
        <ProtectedRoute>
          <Layout><SaisieCrInterventionPage /></Layout>
        </ProtectedRoute>
      } />
      {/* EEC MT 5.21 — Saisie du CR Contrôle des travaux (étape cr_controle).
          Déclarée AVANT /demandes/:id (cf. note ci-dessus). */}
      <Route path="/demandes/:demandeId/cr-controle" element={
        <ProtectedRoute>
          <Layout><SaisieCrControlePage /></Layout>
        </ProtectedRoute>
      } />
      {/* EEC MT 5.22 — Validation du CR Contrôle (étape val_cr_controle). */}
      <Route path="/demandes/:demandeId/validation-cr-controle" element={
        <ProtectedRoute>
          <Layout><ValidationCrControlePage /></Layout>
        </ProtectedRoute>
      } />
      {/* EEC MT — Saisie du CR Consignation (étape cr_consignation).
          Déclarée AVANT /demandes/:id (cf. note ci-dessus). */}
      <Route path="/demandes/:demandeId/cr-consignation" element={
        <ProtectedRoute>
          <Layout><SaisieCrConsignationPage /></Layout>
        </ProtectedRoute>
      } />
      {/* EEC MT — Saisie du CR Déconsignation (étape cr_deconsignation). */}
      <Route path="/demandes/:demandeId/cr-deconsignation" element={
        <ProtectedRoute>
          <Layout><SaisieCrDeconsignationPage /></Layout>
        </ProtectedRoute>
      } />
      {/* UTIL — Saisie du CR de dépose du compteur (étape cr_depose des
          workflows UTIL_DEPOSE_COMPTEUR_BT/MT). Déclarée AVANT /demandes/:id. */}
      <Route path="/demandes/:demandeId/cr-depose" element={
        <ProtectedRoute>
          <Layout><SaisieCrDeposePage /></Layout>
        </ProtectedRoute>
      } />
      {/* UTIL — Saisie du CR de déplacement du compteur (étape cr_deplacement des
          workflows UTIL_DEPLACEMENT_COMPTEUR_BT/MT). Déclarée AVANT /demandes/:id. */}
      <Route path="/demandes/:demandeId/cr-deplacement" element={
        <ProtectedRoute>
          <Layout><SaisieCrDeplacementPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Détail autonome d'un Bordereau d'Intervention par son ID.
          Déclarée AVANT /demandes/:id pour éviter toute ambiguïté de matching. */}
      <Route
        path="/bordereaux-intervention/:id"
        element={
          <ProtectedRoute requiredPermission="access_electricite">
            <Layout><BordereauInterventionDetailPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Détail d'une demande générique (consultation : courrier, adhésion,
          décaissement métier, etc.). Page de fallback pour TOUS les types. */}
      <Route path="/demandes/:id" element={
        <ProtectedRoute>
          <Layout><DemandeDetailPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Module Courrier — Gestion Électronique des Courriers (GEC) */}
      <Route path="/courrier" element={
        <ProtectedRoute>
          <Layout><CourrierListPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Module GED — Dossier Électronique */}
      <Route path="/dossier-electronique" element={
        <ProtectedRoute>
          <Layout><DossierElectronique /></Layout>
        </ProtectedRoute>
      } />
      {/* ── AGEE — Vue d'ensemble spécialisée (tableau de bord environnemental) ─
          Route statique déclarée AVANT /m/:moduleKey pour qu'elle prenne
          la priorité sur le hub générique pour ce module précis. */}
      <Route path="/m/agee_avis_projet" element={
        <ProtectedRoute>
          <Layout><AgeeVueEnsemble /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/agee/base-connaissances/carte" element={
        <ProtectedRoute>
          <Layout><AgeeCarteProjet /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/agee/base-connaissances" element={
        <ProtectedRoute>
          <Layout><AgeeBaseConnaissances /></Layout>
        </ProtectedRoute>
      } />

      {/* ── Hub générique des modules auto-sidebar ──────────────────────
          Sert la `routeBase` de tout module marqué `autoSidebar=true`
          dans le catalogue. Affiche : bandeau identité + cartes "actions"
          (1 par type d'opération du module) + liste des demandes récentes.
          Permet de livrer un nouveau module sans coder de page React :
          il suffit d'ajouter une ligne dans le catalogue + des types
          d'opération via DevMode. */}
      <Route path="/m/:moduleKey" element={
        <ProtectedRoute>
          <Layout><ModuleHubPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Routes statiques alignées sur les `routeBase` des modules Patronat. */}
      <Route path="/adherents" element={
        <ProtectedRoute>
          <Layout><ModuleHubPage moduleKey="gestion_adherents" /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/adherents/commissions" element={
        <ProtectedRoute>
          <Layout><CommissionsPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Suivi des cotisations et vue 360 — le sécrétariat suit ce qui est
          appelé, perçu et restant dû, membre par membre. */}
      {/* Cockpit chiffré et états imprimables du secrétariat. */}
      <Route path="/adherents/etats" element={
        <ProtectedRoute requiredAnyPermission={['access_suivi_cotisations', 'access_gestion_adherents', 'admin_users']}>
          <Layout><EtatsPatronatPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/adherents/cotisations" element={
        <ProtectedRoute requiredAnyPermission={['access_suivi_cotisations', 'admin_users']}>
          <Layout><SuiviCotisationsPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/adherents/:id/vue-360" element={
        <ProtectedRoute requiredAnyPermission={['access_suivi_cotisations', 'admin_users']}>
          <Layout><Vue360AdherentPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/adherents/composition-commissions" element={
        <ProtectedRoute>
          <Layout><CompositionCommissionsPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/activites" element={
        <ProtectedRoute>
          <Layout><ActivitesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/stats-patronales" element={
        <ProtectedRoute requiredPermission="view_stats_patronales">
          <Layout><StatsPatronalesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/activites/:id" element={
        <ProtectedRoute>
          <Layout><ActivitesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/secretariat" element={
        <ProtectedRoute>
          <Layout><ModuleHubPage moduleKey="secretariat_general" /></Layout>
        </ProtectedRoute>
      } />
      {/* ── Saisie back-office d'une nouvelle adhésion patronale ───────
          Réutilise les 3 formulaires multi-étapes du portail public en
          les soumettant via demandeGeneriqueService (workflow ADH_SION). */}
      <Route path="/adhesions/nouvelle" element={
        <ProtectedRoute>
          <Layout><NouvelleAdhesionBackoffice /></Layout>
        </ProtectedRoute>
      } />
      {/* Import / migration de masse des adhérents existants
          (Excel/CSV / BD / API). Pour les organisations qui passent
          d'un système legacy vers SAGeCom et veulent reprendre leur
          base d'adhérents en bloc. */}
      <Route path="/adhesions/migration" element={
        <ProtectedRoute>
          <Layout><MigrationAdherentsPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Liste admin des adhérents migrés (renvoi credentials, etc.) */}
      <Route path="/adhesions/migrations" element={
        <ProtectedRoute>
          <Layout><AdherentsMigresPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Configuration de l'Espace Public d'une entité (patronat, association…)
          Pas de requiredPermission stricte : tout user authentifié peut accéder
          à la page (le PUT de la config est protégé côté backend par admin_users).
          Cela évite que la page soit invisible si le user n'a pas exactement le
          droit admin_users mais doit la consulter. */}
      <Route path="/admin/entites/:entityId/espace-public" element={
        <ProtectedRoute>
          <Layout><EspacePublicConfigPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Contenu de la vitrine patronat (cadres, actualités, émissions, galerie,
          témoignages) — alimente Entity.configEspacePublic.adherents.* */}
      <Route path="/admin/entites/:entityId/vitrine-contenu" element={
        <ProtectedRoute>
          <Layout><PortailVitrineAdminPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Socle « Vitrine Patronat » — contenu du site public des entités de
          catégorie `patronat`. Alimente Entity.configEspacePublic.vitrinePatronat.
          L'écran vérifie lui-même l'éligibilité de l'entité. */}
      <Route path="/admin/entites/:entityId/vitrine-patronat" element={
        <ProtectedRoute>
          <Layout><VitrinePatronatAdminPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Espace fédéré : gestion des demandes d'adhésion soumises depuis
          le portail public (POST /api/public/portail/adherents/:slug/adhesion).
          Filtrable par statut (en attente / en examen / validée / refusée). */}
      <Route path="/admin/entites/:entityId/demandes-adhesion" element={
        <ProtectedRoute>
          <Layout><DemandesAdhesionPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Portails publics (sans authentification) — accessibles via slug */}
      {/* Lien public AGENTS = écran de login personnalisé (logo + couleurs
          de l'organisation). Pas de portail riche : les collaborateurs
          n'ont pas besoin de naviguer en mode public, juste de s'authentifier
          rapidement avec un branding cohérent. */}
      <Route path="/p/agents/:slug" element={<LoginPatronatAgentsPage />} />
      <Route path="/p/adherents/:slug/login" element={<LoginPatronatAdherentsPage />} />
      {/* Suivi public d'une demande d'adhésion par numéro */}
      <Route path="/p/adherents/:slug/suivi" element={<SuiviDemandePage />} />
      {/* Fiche détaillée d'un cadre/conseiller (« En savoir plus ») */}
      <Route path="/p/adherents/:slug/membre/:id" element={<FichePersonnePage />} />
      {/* Événements / activités d'une catégorie */}
      <Route path="/p/adherents/:slug/evenements/:categorie" element={<EvenementsCategoriePage />} />
      <Route path="/p/adherents/:slug/activites/:categorie" element={<ActivitesCategoriePage />} />
      {/* Galerie complète */}
      <Route path="/p/adherents/:slug/galerie" element={<GaleriePage />} />
      {/* Actualités : détail d'un article + par catégorie + toutes */}
      <Route path="/p/adherents/:slug/actualites/article/:id" element={<ActualiteDetailPage />} />
      <Route path="/p/adherents/:slug/actualites/categorie/:categorie" element={<ActualitesCategoriePage />} />
      <Route path="/p/adherents/:slug/actualites" element={<AllActualitesPage />} />
      {/* Tous les témoignages */}
      <Route path="/p/adherents/:slug/temoignages" element={<AllTemoignagesPage />} />
      {/* Émissions d'une catégorie */}
      <Route path="/p/adherents/:slug/emissions/:categorie" element={<EmissionsCategoriePage />} />
      {/* Annuaire public des adhérents (recherche nom/NIF) */}
      <Route path="/p/adherents/:slug/annuaire" element={<AnnuairePage />} />
      {/* Dépôt public d'un signalement éthique */}
      <Route path="/p/adherents/:slug/signalement" element={<SignalementPage />} />
      {/* Catalogue public des programmes d'accompagnement du réseau */}
      <Route path="/p/adherents/:slug/programmes" element={<CatalogueProgrammesPage />} />
      {/* Synthèse publique des chiffres du réseau */}
      <Route path="/p/adherents/:slug/chiffres" element={<SyntheseReseauPage />} />
      {/* Catalogue public des opportunités du réseau */}
      <Route path="/p/adherents/:slug/opportunites" element={<OpportunitesPubliquesPage />} />
      {/* Toutes les catégories d'une rubrique */}
      <Route path="/p/adherents/:slug/categories/:rubrique" element={<ToutesCategoriesPage />} />

      {/* ─── Routes RACINE (URLs propres) — UNIQUEMENT dans le build CGE-GUI ───
          Gatées par IS_CGEGUI → absentes des autres builds (aucun impact tenant).
          Le slug est fixe (HOME_VITRINE_SLUG) → les pages retombent dessus.
          Collisions ERP remappées : /login→/connexion, /activites→/nos-activites. */}
      {/* Connexion des MEMBRES et entrée AGENTS : gatées par IS_PATRONAT et non
          par IS_CGEGUI. Elles ne portent aucun contenu propre à un tenant — ce
          sont deux écrans de connexion — et le menu du socle y renvoie pour
          TOUS les patronats (`destination: '/connexion'`). Gatées sur un seul
          tenant, le lien « Espace adhérent » retombait ailleurs sur /login,
          l'écran du personnel : un membre ne trouvait pas son espace.
          IS_CGEGUI implique IS_PATRONAT, donc CGE-GUI est inchangée.
          Le reste du bloc ci-dessous reste gaté sur le tenant : ces pages-là
          servent du contenu CGE-GUI codé en dur. */}
      {IS_PATRONAT && (
        <>
          <Route path="/acces-collaborateurs" element={<LoginPatronatAgentsPage />} />
          <Route path="/connexion" element={<LoginPatronatAdherentsPage />} />
        </>
      )}
      {IS_CGEGUI && (
        <>
          <Route path="/suivi" element={<SuiviDemandePage />} />
          <Route path="/membre/:id" element={<FichePersonnePage />} />
          <Route path="/galerie" element={<GaleriePage />} />
          <Route path="/annuaire" element={<AnnuairePage />} />
          <Route path="/temoignages" element={<AllTemoignagesPage />} />
          <Route path="/actualites" element={<AllActualitesPage />} />
          <Route path="/actualites/article/:id" element={<ActualiteDetailPage />} />
          <Route path="/actualites/categorie/:categorie" element={<ActualitesCategoriePage />} />
          <Route path="/evenements/:categorie" element={<EvenementsCategoriePage />} />
          <Route path="/nos-activites/:categorie" element={<ActivitesCategoriePage />} />
          <Route path="/emissions/:categorie" element={<EmissionsCategoriePage />} />
          <Route path="/categories/:rubrique" element={<ToutesCategoriesPage />} />
        </>
      )}

      {/* ─── Routes RACINE (URLs propres) — UNIQUEMENT dans le build CGE-GUI ───
          Gatées par IS_CGEGUI → absentes des autres builds (aucun impact tenant).
          Le slug est fixe (HOME_VITRINE_SLUG) → les pages retombent dessus.
          Collisions ERP remappées : /login→/connexion, /activites→/nos-activites. */}
      {/* Connexion des MEMBRES et entrée AGENTS : gatées par IS_PATRONAT et non
          par IS_CGEGUI. Elles ne portent aucun contenu propre à un tenant — ce
          sont deux écrans de connexion — et le menu du socle y renvoie pour
          TOUS les patronats (`destination: '/connexion'`). Gatées sur un seul
          tenant, le lien « Espace adhérent » retombait ailleurs sur /login,
          l'écran du personnel : un membre ne trouvait pas son espace.
          IS_CGEGUI implique IS_PATRONAT, donc CGE-GUI est inchangée.
          Le reste du bloc ci-dessous reste gaté sur le tenant : ces pages-là
          servent du contenu CGE-GUI codé en dur. */}
      {IS_PATRONAT && (
        <>
          <Route path="/acces-collaborateurs" element={<LoginPatronatAgentsPage />} />
          <Route path="/connexion" element={<LoginPatronatAdherentsPage />} />
        </>
      )}
      {IS_CGEGUI && (
        <>
          <Route path="/suivi" element={<SuiviDemandePage />} />
          <Route path="/membre/:id" element={<FichePersonnePage />} />
          <Route path="/galerie" element={<GaleriePage />} />
          <Route path="/temoignages" element={<AllTemoignagesPage />} />
          <Route path="/categories/:rubrique" element={<ToutesCategoriesPage />} />
        </>
      )}
      {/* Lien public ADHERENTS = portail riche avec services, messagerie,
          formulaire d'adhésion (pour les non-membres qui veulent rejoindre). */}
      {/* Landing brandée CGE-GUI — route spécifique avant le générique :slug */}
      <Route path="/p/adherents/cge-gui" element={<LandingPageCGEGUI />} />
      <Route path="/p/adherents/:slug" element={<PortailPatronatPage role="adherents" />} />
      {/* Formulaires en ligne depuis le portail adhérent patronat
          (ex : INSCRIPTION_AUX_COMMISSIONS). PUBLIC_PATHS couvre /p/adherents/. */}
      <Route path="/p/adherents/:slug/demandes/nouvelle/:typeCode" element={<NouvelleDemandePortailPage />} />
      {/* Page publique d'une activité — pas de JWT requis */}
      <Route path="/p/activites/:id" element={<PublicActivitePage />} />

      {/* Paramétrage des banques de l'entité */}
      <Route path="/parametrage/banques" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><BanquesPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Paramétrage des opérateurs Mobile Money */}
      <Route path="/parametrage/operateurs-mobile-money" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><OperateursMobileMoneyPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Paramétrage des tarifs eau (gestion clientèle eau, lot 2) — droit dédié */}
      <Route path="/parametrage/tarifs-eau" element={
        <ProtectedRoute requiredPermission="gerer_tarifs_eau">
          <Layout><TarifsEauPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Référentiel géographique (pays → … → secteur) + import CSV — droit
          des écritures du contrôleur zone-geographique */}
      <Route path="/parametrage/zones-geographiques" element={
        <ProtectedRoute requiredPermission="gerer_referentiels">
          <Layout><ZonesGeographiquesPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Paramétrage des tarifs électriques (EEC) — droit dédié */}
      <Route path="/parametrage/tarifs-electriques" element={
        <ProtectedRoute requiredPermission="gerer_tarifs_electriques">
          <Layout><TarifsElectriquesPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Barèmes des frais de mission — consultation ouverte au droit d'accès,
          les actions de modification sont gardées dans la page par
          `gerer_baremes_mission`. */}
      <Route path="/parametrage/baremes-mission" element={
        <ProtectedRoute requiredPermission="access_baremes_mission">
          <Layout><BaremesMission /></Layout>
        </ProtectedRoute>
      } />

      {/* Registre des conflits d'intérêts. La route porte le droit de
          DÉCLARER, le plus large : tout collaborateur doit pouvoir déposer
          et relire ses propres déclarations. L'accès au registre complet,
          l'examen et le paramétrage sont gardés plus loin, dans la page et
          surtout dans le contrôleur, par `gerer_conflits_interet`. */}
      <Route path="/conflits-interet" element={
        <ProtectedRoute requiredPermission="declarer_conflit_interet">
          <Layout><ConflitsInteret /></Layout>
        </ProtectedRoute>
      } />

      {/* Campagnes d'avancement. La route porte le droit de PROPOSER,
          le plus large : un encadrant doit pouvoir deposer pour ses
          collaborateurs. L'arbitrage, l'application et le tableau des couts
          sont gardes dans le controleur par `gerer_avancements`. */}
      <Route path="/rh/avancements" element={
        <ProtectedRoute requiredPermission="proposer_avancement">
          <Layout><Avancements /></Layout>
        </ProtectedRoute>
      } />

      {/* Distinctions honorifiques. Gardee par le droit de PROPOSER ;
          le referentiel, l'arbitrage et les contingents sont gardes dans le
          controleur par `gerer_distinctions`. */}
      <Route path="/rh/distinctions" element={
        <ProtectedRoute requiredPermission="proposer_distinction">
          <Layout><Distinctions /></Layout>
        </ProtectedRoute>
      } />

      {/* Self-service : ce que l'agent voit de SON propre parcours.
          Aucune permission requise — consulter sa situation n'en demande pas,
          et le serveur filtre sur la fiche employe du compte, jamais sur un
          identifiant transmis par la page. Deux routes distinctes plutot qu'un
          filtre sur l'ecran de gestion : celui-ci donne acces aux salaires
          proposes de tous, et la confidentialite ne peut pas dependre d'un
          parametre d'URL. */}
      {/* Parc automobile. La route porte le droit de CONSULTER, le plus
          large : savoir quels véhicules existent aide n'importe quel encadrant
          à demander. Affecter et réformer restent gardés dans le contrôleur
          par `gerer_parc_auto`. */}
      {/* GMAO — patrimoine réseau (électricité, éclairage public, eau). */}
      <Route path="/gmao/patrimoine" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'gerer_patrimoine_reseau', 'parametrer_gmao']}>
          <Layout><PatrimoineReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/incidents" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'declarer_incident_reseau', 'gerer_ordres_travail', 'executer_ordres_travail']}>
          <Layout><IncidentsReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/ordres-travail" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'gerer_ordres_travail', 'executer_ordres_travail', 'declarer_incident_reseau']}>
          <Layout><OrdresTravailReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/preventif" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'gerer_maintenance_preventive', 'gerer_ordres_travail', 'parametrer_gmao']}>
          <Layout><PreventifReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/equipes" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'gerer_equipes_gmao', 'gerer_ordres_travail', 'parametrer_gmao']}>
          <Layout><EquipesReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/indicateurs" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'voir_indicateurs_gmao', 'gerer_ordres_travail', 'parametrer_gmao']}>
          <Layout><IndicateursReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/terrain" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'executer_ordres_travail', 'declarer_incident_reseau', 'gerer_ordres_travail']}>
          <Layout><TerrainReseauPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/gmao/carte" element={
        <ProtectedRoute requiredModule="gmao" requiredAnyPermission={['access_gmao', 'declarer_incident_reseau', 'gerer_ordres_travail', 'executer_ordres_travail']}>
          <Layout><CarteExploitationPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Conformité et efficacité (QHSE). Documents, NC, actions, suggestions et HSE
          sont ouverts à tout collaborateur de l'organisation abonnée (lecture des
          documents diffusés, signalements, actions dont il est responsable) ;
          le backend filtre et contrôle chaque geste. */}
      <Route path="/conformite" element={
        <ProtectedRoute requiredModule="conformite" requiredAnyPermission={DROITS_CONFORMITE}>
          <Layout><TableauDeBordConformitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/processus" element={
        <ProtectedRoute requiredModule="conformite" requiredAnyPermission={DROITS_CONFORMITE}>
          <Layout><ProcessusQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/documents" element={
        <ProtectedRoute requiredModule="conformite">
          <Layout><DocumentsQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/non-conformites" element={
        <ProtectedRoute requiredModule="conformite">
          <Layout><NonConformitesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/actions" element={
        <ProtectedRoute requiredModule="conformite">
          <Layout><ActionsQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/suggestions" element={
        <ProtectedRoute requiredModule="conformite">
          <Layout><SuggestionsQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/audits" element={
        <ProtectedRoute requiredModule="conformite" requiredAnyPermission={DROITS_CONFORMITE}>
          <Layout><AuditsQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/indicateurs" element={
        <ProtectedRoute requiredModule="conformite" requiredAnyPermission={DROITS_CONFORMITE}>
          <Layout><IndicateursQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/risques" element={
        <ProtectedRoute requiredModule="conformite" requiredAnyPermission={DROITS_CONFORMITE}>
          <Layout><RisquesQualitePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conformite/hse" element={
        <ProtectedRoute requiredModule="conformite">
          <Layout><HseQualitePage /></Layout>
        </ProtectedRoute>
      } />

      {/* Fédération sportive — le périmètre (club, ligue, fédération) est appliqué par le backend. */}
      <Route path="/federation" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_mon_club', 'instruire_ligue', 'gerer_federation']}>
          <Layout><TableauDeBordFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/clubs" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_mon_club', 'instruire_ligue', 'gerer_federation']}>
          <Layout><ClubsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/licences" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_mon_club', 'instruire_ligue', 'gerer_federation']}>
          <Layout><LicencesFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/structures" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_mon_club', 'instruire_ligue', 'gerer_federation']}>
          <Layout><ClubsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/agrements" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_mon_club', 'instruire_ligue', 'gerer_federation', 'gerer_agrements_federation']}>
          <Layout><AgrementsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/commissions" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_federation', 'gerer_commissions_federation']}>
          <Layout><CommissionsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/evenements" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'instruire_ligue', 'gerer_federation']}>
          <Layout><EvenementsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/suivi-affiliations" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'instruire_ligue', 'gerer_federation', 'encaisser_federation']}>
          <Layout><SuiviAffiliationsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/auto-ecole/reussite" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'instruire_ligue', 'gerer_federation']}>
          <Layout><ReussiteAutoEcolePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/paiements" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['access_federation', 'gerer_mon_club', 'encaisser_federation', 'gerer_federation']}>
          <Layout><PaiementsFederationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/federation/parametrage" element={
        <ProtectedRoute requiredModule="federation" requiredAnyPermission={['parametrer_federation']}>
          <Layout><ParametrageFederationPage /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/parc-auto" element={
        <ProtectedRoute requiredAnyPermission={['access_parc_auto', 'gerer_parc_auto', 'saisir_plein_carburant', 'revoir_anomalie_carburant', 'reserver_vehicule_pool']}>
          <Layout><ParcAutoPage /></Layout>
        </ProtectedRoute>
      } />

      {/* ── Verticale Auto-école (module `auto_ecole`, routeBase /auto-ecole) ──
          Routes toutes protégées. Chaque action est gardée en plus par son droit
          dédié à l'intérieur de la page (helper hasPermission). */}
      <Route path="/auto-ecole" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={DROITS_AUTO_ECOLE}>
          <Layout><AutoEcoleTableauDeBord /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/auto-ecole/eleves" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={DROITS_AUTO_ECOLE}>
          <Layout><AutoEcoleEleves /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/auto-ecole/moniteurs" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={['access_auto_ecole', 'gerer_moniteurs_ae', 'gerer_formation_ae']}>
          <Layout><AutoEcoleMoniteurs /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/auto-ecole/bareme" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={['access_auto_ecole', 'gerer_bareme_frais_ae']}>
          <Layout><AutoEcoleBareme /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/auto-ecole/paiements" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={['access_auto_ecole', 'encaisser_frais_ae', 'gerer_eleves_ae', 'gerer_bareme_frais_ae']}>
          <Layout><AutoEcolePaiements /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/auto-ecole/planning" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={['access_auto_ecole', 'gerer_planning_ae', 'gerer_formation_ae']}>
          <Layout><AutoEcolePlanning /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/auto-ecole/examens" element={
        <ProtectedRoute requiredModule="auto_ecole" requiredAnyPermission={['access_auto_ecole', 'gerer_examens_ae', 'gerer_formation_ae']}>
          <Layout><AutoEcoleExamens /></Layout>
        </ProtectedRoute>
      } />

      {/* Mon dossier : les pièces que l'agent doit fournir. Aucun droit —
          consulter son propre dossier n'en demande pas, et c'est là que mène
          la relance qu'il reçoit. */}
      <Route path="/mon-espace/mon-dossier" element={
        <ProtectedRoute>
          <Layout><MonDossier /></Layout>
        </ProtectedRoute>
      } />

      {/* Conformité des dossiers — côté RH. La route porte le droit de
          CONSULTER ; ouvrir une campagne et relancer sont gardés dans le
          contrôleur par `gerer_campagnes_documents`, car écrire à tout le
          personnel n'est pas le même geste que vérifier une pièce. */}
      <Route path="/rh/conformite-dossiers" element={
        <ProtectedRoute requiredAnyPermission={['acces_conformite_dossier', 'gerer_campagnes_documents', 'access_employes']}>
          <Layout><ConformiteDossiers /></Layout>
        </ProtectedRoute>
      } />

      <Route path="/mon-espace/mes-avancements" element={
        <ProtectedRoute>
          <Layout><MesAvancementsDistinctions vue="avancements" /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/mon-espace/mes-distinctions" element={
        <ProtectedRoute>
          <Layout><MesAvancementsDistinctions vue="distinctions" /></Layout>
        </ProtectedRoute>
      } />

      {/* Sante et securite au travail. La route porte le droit de
          DECLARER, le plus large : un accident se declare dans l'heure, par
          qui est present. Le registre, l'analyse, le document unique et la
          medecine du travail sont gardes plus finement dans le controleur. */}
      <Route path="/rh/sante-securite" element={
        <ProtectedRoute requiredPermission="declarer_accident_travail">
          <Layout><SanteSecurite /></Layout>
        </ProtectedRoute>
      } />

      {/* Cours de devises — la CONSULTATION porte la route (c'est elle qui
          permet de vérifier quel cours s'applique) ; la saisie et la correction
          sont gardées dans la page par `gerer_cours_devises`, et les cotations
          globales restent réservées au super-administrateur. */}
      <Route path="/parametrage/cours-devises" element={
        <ProtectedRoute requiredPermission="access_cours_devises">
          <Layout><CoursDevises /></Layout>
        </ProtectedRoute>
      } />

      {/* Personnaliser les menus : libellés des sections/modules/sous-menus PAR ENTITÉ */}
      <Route path="/parametrage/menus" element={
        <ProtectedRoute requiredPermission="personnaliser_menus">
          <Layout><PersonnaliserMenusPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Regroupements (entités morales / administrations multi-abonnements) — droit dédié */}
      <Route path="/parametrage/regroupements" element={
        <ProtectedRoute requiredPermission="gerer_regroupements">
          <Layout><RegroupementsPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Fonds d épargne à adhérents (PoC Index Partner) : registre KYC,
          lettrage bancaire, séquestre, capitalisation — droit dédié */}
      <Route path="/fonds-epargne" element={
        <ProtectedRoute requiredPermission="access_fonds_epargne">
          <Layout><FondsEpargnePage /></Layout>
        </ProtectedRoute>
      } />

      {/* ═══ Facturation électrique (EEC) — Hub + BT (cycles + pilotage) ═══ */}
      <Route path="/facturation-electrique" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><FacturationHubPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/calendrier" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><CalendrierFacturationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/bt" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><CyclesBtPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/bt/:cycleId" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><CyclePilotagePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/compteurs-intelligents" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><FacturationSmartPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/mt" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><CyclesMtPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/mt/:cycleId" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><CyclePilotagePage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-electrique/prepaye" element={
        <ProtectedRoute requiredPermission="access_facturation_electrique">
          <Layout><AchatPrepayePage /></Layout>
        </ProtectedRoute>
      } />

      {/* ═══ Gestion clientèle eau — vue d'ensemble (routeBase du module « eau ») + facturation ═══ */}
      <Route path="/eau" element={
        <ProtectedRoute requiredPermission="access_eau">
          <Layout><VueEnsembleEauPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/facturation-eau" element={
        <ProtectedRoute requiredPermission="access_facturation_eau">
          <Layout><FacturationEauPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Recouvrement eau (lot 4) : liste noire, réouverture manuelle. */}
      <Route path="/recouvrement-eau" element={
        <ProtectedRoute requiredPermission="gerer_recouvrement_eau">
          <Layout><RecouvrementEauPage /></Layout>
        </ProtectedRoute>
      } />

      {/* ═══ Recouvrement / Relance (chaînes BM / M / TRAVAUX — EDG ; chaînes eau) ═══
          Ouverte aussi à `gerer_recouvrement_eau` : un profil eau seul n'y voit que les
          dossiers de relance eau (fluide figé, cf. RecouvrementPage). */}
      <Route path="/recouvrement" element={
        <ProtectedRoute requiredAnyPermission={['access_facturation_electrique', 'gerer_recouvrement_eau']}>
          <Layout><RecouvrementPage /></Layout>
        </ProtectedRoute>
      } />

      {/* CRM — Accords commerciaux / Plans de paiement (simulateur + suivi) */}
      <Route path="/accords-commerciaux" element={
        <ProtectedRoute requiredPermission="access_recouvrement">
          <Layout><AccordsCommerciaux /></Layout>
        </ProtectedRoute>
      } />

      {/* Paramétrage des référentiels Relance (classification data-driven EDG) */}
      <Route path="/parametrage/relance-referentiels" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><RelanceReferentielsPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Paramétrage des alertes & notifications */}
      <Route path="/administration/alertes" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><AlertesConfigPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Tableau de bord Abonnements Parents (revenue sharing) */}
      <Route path="/vie-scolaire/ecoles/:ecoleId/abonnements-parents" element={
        <ProtectedRoute requiredPermission="access_vie_scolaire">
          <Layout><AbonnementsParentsPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Souscription parent à l'Espace Parents & Élèves (publique, pas de JWT) */}
      <Route path="/espace-parent/souscription" element={<SouscriptionParentPage />} />

      {/* Échéancier de scolarité — espace parent (publique, JWT parent géré côté API) */}
      <Route path="/espace-parent/echeancier/:inscriptionId" element={<EcheancierScolaritePage />} />

      {/* Dashboard SAGeCom global revenue sharing (admin) */}
      <Route path="/admin/revenue-sharing" element={
        <ProtectedRoute>
          <Layout><DashboardRevenueSharingPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Module Promotions / Marketing emailing */}
      <Route path="/marketing" element={
        <ProtectedRoute>
          <Layout><PromotionsMarketingPage /></Layout>
        </ProtectedRoute>
      } />

      {/* CRM — Prospects (alias direct sur l'onglet Prospects de Marketing) */}
      <Route path="/prospects" element={
        <ProtectedRoute requiredPermission="access_prospects">
          <Layout><PromotionsMarketingPage /></Layout>
        </ProtectedRoute>
      } />

      {/* CRM — Contacts (personnes rattachées à un client/compte) */}
      <Route path="/contacts" element={
        <ProtectedRoute requiredPermission="access_contacts" requiredModule="clients">
          <Layout><Clients /></Layout>
        </ProtectedRoute>
      } />

      {/* ===== Module Société / Associés / Dividendes ===== */}
      {/* Liste des associés / actionnaires + gestion des rôles */}
      <Route path="/societe/associes" element={
        <ProtectedRoute requiredPermission="view_associes">
          <Layout><AssociesPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Capital social : composition + historique + détentions */}
      <Route path="/societe/capital-social" element={
        <ProtectedRoute requiredPermission="view_associes">
          <Layout><CapitalSocialPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Workflow de distribution de dividendes (proposée → validée → payée) */}
      <Route path="/dividendes/distributions" element={
        <ProtectedRoute requiredPermission="view_dividendes">
          <Layout><DistributionsDividendesPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Référentiels fiscaux paramétrables (types d'entreprise + taux IRCM/IS) */}
      <Route path="/administration/referentiels-fiscaux" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><ReferentielsFiscauxPage /></Layout>
        </ProtectedRoute>
      } />
      {/* Axes analytiques dynamiques (mai 2026) — paramétrage par entité */}
      <Route path="/administration/axes-analytiques" element={
        <ProtectedRoute requiredPermission="access_admin">
          <Layout><AxesAnalytiquesPage /></Layout>
        </ProtectedRoute>
      } />

      {/* ════════════════════════════════════════════════════════════════════
          Sprint EEC Congo — App mobile AGENT TERRAIN (Phase 3+4).
          Layout DÉDIÉ plein écran (TerrainShell, intégré dans chaque page),
          PAS de <Layout> desktop. Droit dédié `acces_releve_terrain` (les
          admins gardent l'accès via le bypass hasPermission).
          /terrain/login est PUBLIC (dans PUBLIC_PATHS) — les autres ne le sont PAS.
          Stubs interventions/CR amorcés pour la phase 5.
          ═══════════════════════════════════════════════════════════════════ */}
      {/* Login mobile dédié — DOIT être AVANT les routes protégées /terrain/* */}
      <Route path="/terrain/login" element={<TerrainLoginPage />} />
      <Route path="/terrain" element={
        <ProtectedRoute requiredAnyPermission={['acces_releve_terrain', 'acces_intervention_terrain']}><TerrainHomePage /></ProtectedRoute>
      } />
      <Route path="/terrain/releves" element={
        <ProtectedRoute requiredPermission="acces_releve_terrain"><LotsListPage /></ProtectedRoute>
      } />
      <Route path="/terrain/releves/:lotId" element={
        <ProtectedRoute requiredPermission="acces_releve_terrain"><LotDetailPage /></ProtectedRoute>
      } />
      <Route path="/terrain/releves/:lotId/saisie/:ligneId" element={
        <ProtectedRoute requiredPermission="acces_releve_terrain"><SaisieRelevePage /></ProtectedRoute>
      } />
      <Route path="/terrain/releves/:lotId/charge/:ligneId" element={
        <ProtectedRoute requiredPermission="acces_releve_terrain"><SaisieChargePage /></ProtectedRoute>
      } />
      {/* Stubs phase 5 */}
      <Route path="/terrain/interventions" element={
        <ProtectedRoute requiredPermission="acces_intervention_terrain"><InterventionsListPage /></ProtectedRoute>
      } />
      <Route path="/terrain/interventions/:id" element={
        <ProtectedRoute requiredPermission="acces_intervention_terrain"><InterventionDetailPage /></ProtectedRoute>
      } />
      <Route path="/terrain/cr" element={
        <ProtectedRoute requiredAnyPermission={['acces_releve_terrain', 'acces_intervention_terrain']}><CrListPage /></ProtectedRoute>
      } />

      {/* ===== Module Plantation — gestion agro-industrielle ===== */}
      <Route path="/plantation/*" element={
        <ProtectedRoute requiredPermission="access_plantation">
          <Layout><PlantationPage /></Layout>
        </ProtectedRoute>
      } />

      {/* Route 404 — redirige vers landing ou dashboard selon connexion */}
      <Route path="*" element={<Navigate to={isAuthenticated ? defaultHome : defaultPublicRoute} replace />} />
    </Routes>
    </React.Suspense>
  );
};

export default AppRoutes;